import React from 'react';

const english = {
  readingReceipt: { receivedAt: 'Received at: {0}', delayed: 'Reading received with delay.' },
  capActivity: {
    lastTakeTitle: "Devices by days since last usage",
    lastActivityTitle: "Devices by days since last activity",
    activityDays: "Days since last activity",
    noActivity: "No activity: {0}",
    lastActivityDescription: "Number of distinct devices by calendar days since their last activity (0 = today). Devices without activity are shown separately. Date and program filters do not apply.",
    group: "Device activity",
    devices: "Devices",
    days: "Days since last usage",
    neverUsed: "Never used: {0}",
    snapshot: "Current snapshot: {0} ({1}).",
    lastTakeDescription: "Number of distinct devices by calendar days since their last vital event (0 = today). Devices without vital events are shown separately as never used. Date and program filters do not apply.",
    chartType: "Chart type",
    bar: "Bar chart",
    area: "Area chart",
    line: "Line chart",
    pie: "Pie chart",
  },
  accessCareUpdates: {
    responsibleClinician: 'Responsible clinician', chooseClinician: 'Select a doctor',
    cliniciansFailed: 'Unable to load doctors. Close and reopen this Care Update to try again.', noClinicians: 'No eligible doctors are available for this patient.',
    validClinicianRequired: 'Select an active doctor with access to this patient.',
    send: 'Send Care Update', sendingUnavailable: 'Sending Care Updates is not available yet. Your draft has not been sent.',
    requiredField: 'This field is required before sending.', planRequired: 'Add at least one complete intervention before sending.',
    completeBeforeSending: 'Complete before sending: {0}.',
    optionalActionsHint: 'Actions are optional. If left blank, the PDF shows "No action needed".',
    refreshPreview: 'Refresh preview', closePreview: 'Close preview', previewStale: 'The draft has changed. Refresh the preview to include your latest edits.',
    title: 'Care Updates', open: 'Open Care Update', enrollment: 'ACCESS enrollment', update: 'Care Update',
    assessment: 'Assessment', interventions: 'Interventions', plan: 'Plan', actions: 'Actions', measure: 'Measure / intervention',
    assessmentHint: "Summarize the patient's current clinical status, progress and any concerns that the receiving provider should know about.",
    actionsHint: 'Describe any actions requested from the PCP or referring provider. Leave blank when no action is needed.',
    availableAt: 'Available from', dueAt: 'Transmission deadline', reload: 'Reload',
    overdue: 'Overdue',
    dueDate: 'Due date', actionByUpdatedAt: 'Action (last updated)',
    createEscalation: 'Care Escalation', escalationCreated: 'Escalation task created.',
    addIntervention: 'Add intervention', removeIntervention: 'Remove intervention', saveDraft: 'Save draft',
    addInterventionHint: 'Add a measure or intervention and describe the planned care, for example blood pressure monitoring or a medication adjustment.',
    reloadRequired: 'This Care Update has changed since you opened it. Reload the latest version before saving.',
    saved: 'Care Update draft saved.',
    previewPdf: 'Preview PDF', downloadPdf: 'Download PDF', pdfPreviewTitle: 'Care Update PDF preview',
    previewHint: 'Preview uses your current edits and live clinical data without saving the draft. It does not approve or send the document.',
    previewFailed: 'Unable to generate the Care Update PDF. Please try again.',
    requestFailed: 'Unable to load or save Care Updates. Please try again.',
    maxCharacters: 'Maximum {0} characters.', discardChanges: 'Discard unsaved changes?',
    keepEditing: 'Keep editing', discard: 'Discard changes',
    draftOnly: 'Saving updates the draft only. It does not approve the document, complete the action, or send a message.',
    readOnly: 'This Care Update is read-only in its current status.',
    types: { initiation: 'Care initiation', escalation: 'Care escalation', completion: 'Care completion' },
    statuses: { draft: 'Draft', ready_for_transmission: 'Ready for transmission', transmission_in_progress: 'Transmission in progress', completed: 'Completed', failed_to_transmit: 'Failed to transmit', cancelled: 'Cancelled' },
  },
  yes: 'Yes',
  no: 'No',
  none: 'None',
  all: 'All',
  allKits: 'All Kits',
  allEnrollments: 'All Enrollments',
  writePrivileges: 'Write Privileges',
  orderList: 'Order List',
  appEmail: 'support@rxcap.com',
  downloadData: 'Download Data',
  downloadAllData: 'Download All Data',
  downloadResultsData: 'Download Results Data',
  downloadHistory: 'Download History',
  downloadAllMeds: 'Download Med List',
  downloadEvents: 'Download Events',
  downloadSummary: 'Download Summary',
  downloadMonthlySummary: 'Download Monthly Summary',
  downloadDevicesDetails: 'Download Devices Details',
  showingXDevicesAndKits: 'Showing {0} of {1} Devices • {2} Kits',
  downloadInvoicingData: 'Download Invoicing Data',
  downloadMonitoringReport: 'Download Monitoring Report',
  downloadNotesAndActions: 'Download Notes and Actions',
  addPatient: 'Add Patient',
  removePatient: 'Remove Patient',
  initiateNewEnrollment: 'Initiate New Enrollment',
  bulkAddPatients: 'Bulk Add',
  addEnrollAssignMed: 'Add & Enroll Patient, Assign Medication',
  chooseFileToUpload: 'Choose File to Upload',
  noFileSelected: 'No file selected',
  patientsFoundInFile: 'Patients found in the file',
  addNickName: 'Edit Name',
  sessionTimeout: 'Extend Session',
  sessionExpiredMessage: 'Your session expired. Please sign in again.',
  sessionExpiredTitle: 'Session Expired',
  sessionExpiredInactivityMessage: 'You have been logged out due to inactivity.',
  sessionExpiredInactivityMessageWithDuration: 'You have been logged out due to inactivity for {0} minutes.',
  sessionExpiredLoginButton: 'Log in again',
  idleSessionCountdown: 'You will be signed out in {0}.',
  nickName: 'Cap name',
  editName: 'Edit Name',
  editCapName: 'Edit Cap Name',
  addPatients: 'Add Patients',
  addRemovePatients: 'Add / Remove Patients',
  fullName: 'Full Name',
  date: 'Date',
  time: 'Time',
  lastEventDate: 'Last Event Date',
  editInfo: 'Edit Info',
  reloadGraph: 'Reload graph',
  reload: 'Reload',
  showSelectedItems: 'Show selected fields',
  showSelectedWidgets: 'Show selected widgets',
  resetToDefaults: 'Reset to Defaults',
  deleteWarning: 'Are you sure you want to delete {0}?',
  deletePatientWarning: 'Are you sure you want to delete patient',
  updateStatus: 'Are you sure you want to update status to',
  deleteCapManagerWarning: 'Are you sure you want to delete cap manager',
  deleteDoctorWarning: 'Are you sure you want to delete doctor',
  deleteOrderWarning: 'Are you sure you want to delete order',
  deleteOrgWarning: 'Are you sure you want to delete organization',
  deleteOrgBlockedCaption: 'cannot be deleted',
  deleteOrgBlockedMessage: 'The following items block deleting this organization:',
  deleteOrgNoBlockers: 'Nothing blocks deleting this organization.',
  deleteOrgReadinessFailed: 'Could not check what blocks deleting this organization.',
  deleteOrgForceCleanWarning: 'Deleting this organization will also remove the blockers listed above.',
  deleteOrgForceCleanConfirmationLabel: 'Organization name',
  deleteOrgForceCleanConfirmationMessage: 'Type the organization name below',
  launchOrgWarning: 'Are you sure you want to launch organization',
  unsuspendOrgWarning: 'Are you sure you want to unsuspend organization',
  deleteOrgGrpWarning: 'Are you sure you want to delete organization group',
  removeOrgFromGroupWarning: 'Are you sure you want to remove organization from group',
  deleteScheduleWarning: 'Are you sure you want to delete the schedule for',
  deleteTaksHistoryWarning: 'Are you sure you want to delete task history',
  deleteMedicationWarning: 'Are you sure you want to delete medication',
  deleteScheduleCapWarning: 'Are you sure you want to delete cap',
  deleteOrgManagerWarning: 'Are you sure you want to delete organization manager',
  deleteOrgAdminWarning: 'Are you sure you want to delete organization admin',
  deleteOrgCapsManagerWarning: 'Are you sure you want to delete organization caps manager',
  deleteOrgOutboundAPIWarning: 'Are you sure you want to delete organization outbound API',
  deleteCohortWarning: 'Are you sure you want to delete cohort',
  unassignPatientWarning: 'Are you sure you want to unassign patient from cohort',
  deleteCapWarning: 'Are you sure you want to remove device',
  capSendSecurityCode: 'Send Device Security Code',
  capSendSecurityCodeSent: ' Device Security Code sent',
  deleteHubDeviceWarning: 'Are you sure you want to delete device',
  assignCapToScheduleCaption: 'Cap {0} will be assigned to schedule {1}',
  unassignCapToScheduleCaption: 'Cap {0} will be unassigned from schedule {1}',
  deletePrefabReply: 'Are you sure you want to delete prefab response',
  invitePatientWarning: 'Are you sure you want to invite patient {0} to portal?',
  resetBleWarning: 'Are you sure you want to reset BLE chip for selected hub(s)?',
  startEnrollmentWarning: 'Are you sure you want to activate the following program for patient {0}?',
  startEnrollmentMedsWarning:
    'The following schedules are linked to the program and have start date in the future. They will automatically start when the program is activated.',
  resetPatientStatusWarning:
    'Are you sure you want to initiate new enrollment for patient {0}? Patient will appear in Onboarded/Registered state.',
  resetPatientStatusActiveProgramsWarning: 'Patient already has active enrollment programs. Initiating new enrollment will not end the active programs.',
  resetPatientStatusSchedulesWarning:
    'The following schedules have cap assigned. Please select the schedules from which you want to unassign cap.',
  resetPatientStatusActiveAlertsWarning:
    'Some schedules have active alerts. You have to clear them to be able to unassign cap from them and to remove kit from patient. To clear alerts go to',
  patientDashboardTxt: 'Patient Dashboard',
  resetPatientStatusKitWarning:
    'Do you want to remove the kit from the patient? We recommend removing the kit only if the patient will be getting new one.',
  cancelEnrollmentWarning: 'Are you sure you want to cancel enrollment for patient {0}?',
  deleteOrgGrpWarning: 'Are you sure you want to delete organization group {0}?',
  deleteOrgFromGroupWarningarning: (org, grpName) => ['Are you sure you want to delete organization ', <b>{org}</b>, ` from group ${grpName}?`],
  deleteMaintainerFromGroupWarningarning: (user, grpName) => ['Are you sure you want to delete maintainer ', <b>{user}</b>, ` from group ${grpName}?`],
  deleteUserFromGroupWarningarning: (user, grpName) => ['Are you sure you want to delete user ', <b>{user}</b>, ` from group ${grpName}?`],
  remindersChangeRequiredCaption: 'Reminders change required',
  remindersChangeRequired:
    'Patient has reminders defined. They will NOT be automatically translated to the newly set language. To change the reminders, please navigate to Medications page and edit each medication that has remiders set to change them. Would you like to be navigated to Medications page?',
  previous: 'Previous',
  nextWeek: 'Next week',
  downloadPatientData: 'Download Patient Data',
  downloadPatientsEvents: 'Download Patients Events',
  caregiver: 'Caregiver',
  caregivers: 'Caregivers',
  addCaregiver: 'Add Caregiver',
  addACaregiver: 'Add a Caregiver',
  editCaregiverList: 'Edit Caregiver List',
  numberOfAdministrators: 'Number of administrators',
  addAdmin: 'Invite Admin',
  rxcapCopyRightText: 'RXCap 2020 - All copyrights reserved',
  showingDataFrom: 'Showing data from ',
  trend: 'Trend',
  missed: 'Missed',
  miss: 'Miss',
  complied: 'Complied',
  skipped: 'Skipped',
  noData: 'No Data',
  last30days: 'Last 30 Days',
  last7days: 'Last 7 Days',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  last6Months: 'Last 6 Months',
  thisYear: 'This Year',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  selectAllUnavailableForAllReadings: 'Choose "New Readings" or "Archived Readings" to select all',
  selectedItems: 'Selected items',
  onePatientSelected: '1 patient selected',
  xPatientsSelected: '{0} patients selected',
  archiveUnarchive: 'Archive/Unarchive',
  completeMonitoring: 'Complete monitoring',
  onePatient: '1 patient',
  xPatients: '{0} patients',
  completeMonitoringDescription:
    "Readings of {0} will be marked as reviewed. Enter the time spent on each patient review that will be added to patients' Task History.",
  completeMonitoringTimeForPatient: '{0} will be logged for this patient',
  completeMonitoringTimeForEachPatient: 'Time is logged for each patient: {0} × {1} patients',
  last12Months: 'Last 12 Months',
  selectedDate: 'Selected Date',
  last7DaysAdherence: 'Adherence Last 7 Days',
  noDescription: 'No description',
  noDataAvailable: 'No data available',
  totalAdherence: 'Total Adherence',
  weeklyTotalAdherence: 'Total | Weekly Adherence',
  totalAccuracy: 'Total Accuracy',
  accuracy: 'Accuracy',
  appOnly: 'App Only',
  smartCap: 'SmartCap',
  pillbox: 'Pillbox',
  smartCapUsage: 'Smart Cap Usage',
  accepted: 'Accepted',
  accept: 'Accept',
  reject: 'Reject',
  pending: 'Pending',
  createOrder: 'Create Order',
  acceptedPendingInvites: 'Accepted / Pending Invites',
  medication: 'Medication',
  noMedicationsTaken: 'No medications taken',
  noMedications: 'No medications',
  averageTimedelta: 'Average timedelta',
  taken: 'Taken',
  takes: 'Takes',
  nextMed: 'Next Med',
  unscheduled: 'unscheduled',
  takeTypes: {
    scheduled: 'Scheduled take',
    unscheduled: 'Unscheduled take',
    missed: 'Missed take',
  },
  delta: 'delta',
  na: 'N/A',
  name: 'Name',
  verificationCode: 'Enter Verification Code',
  send: 'Send',
  sendVerificationCode: 'Send Verification Code',
  reSendVerificationCode: 'Resend Verification Code',
  sendVerificationLink: 'Send Verification Link',
  reSendVerificationLink: 'Resend Verification Link',
  total: 'Total',
  verified: 'Verified',
  invalidType: 'Invalid Type',
  dashboard: 'Dashboard',
  loading: 'Loading',
  notificationSettings: 'Notification Settings',
  mobilePhone: 'Mobile Phone',
  phoneNo: 'Phone No.',
  contactNo: 'Contact No.',
  hardwareId: 'Hardware ID',
  notVerified: 'Not verified',
  emailAddress: 'Email Address',
  inProcess: 'In process...',
  saveChanges: 'Save Changes',
  save: 'Save',
  update: 'Update',
  firstName: 'First Name',
  yourName: 'Your Name',
  lastName: 'Last Name',
  userName: 'Username',
  patient: 'Patient',
  selectGender: 'Please select gender',
  gender: 'Gender',
  genders: {
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  userNameEmail: 'Username or Email',
  usingSmartCap: 'Using Smart Cap',
  studies: 'Studies',
  patients: 'Patients',
  patientView: 'Patients View',
  enrollmentView: 'Enrollments View',
  view: 'View',
  careManagementPrograms: 'Care Management Programs',
  accessPrograms: 'ACCESS',
  clinicalTrials: 'Clinical Trials',
  enrollmentProcess: 'Enrollment Process / No Program Assigned',
  enrollmentStatus: 'Enrollment Status',
  stateSince: 'State Since',
  enrollmentPeriod: 'Enrollment Period',
  ongoing: 'Ongoing',
  myPatients: 'My Patients',
  enrollAndMonitor: 'Enroll & Monitor',
  alerts: 'Alerts',
  patientAlertFields: {
    pressure_systolic: 'SYS',
    pressure_diastolic: 'DIA',
    forced_expiratory_volume_1s: 'FEV1',
    forced_vital_capacity: 'FVC',
    pm25: 'PM 2.5',
    prothrombin_time: 'PT',
    international_normalized_ratio: 'INR',
  },
  admin: 'Admins',
  caps: 'Caps',
  signOut: 'Sign Out',
  today: 'Today',
  daily: 'Daily',
  monthly: 'Monthly',
  medications: 'Medications',
  Info: 'Info',
  timeDelta: 'Time Delta',
  personalSettings: 'Personal Settings',
  settings: 'Settings',
  support: 'Support',
  systemConfiguration: 'System Config',
  superuserHealthCenter: 'System Health',
  superuserHealthDashboardTab: 'Dashboard',
  superuserHealthMessagesTab: 'Messages',
  superuserHealthEventsTab: 'Events',
  superuserHealthIssuesTab: 'Issues',
  superuserHealthAlertsTab: 'Alerts',
  superuserHealthComingSoon: 'This section is ready. Detailed requirements for this tab can be added next.',
  superuserHealthNoData: 'No data yet.',
  superuserHealthLoadError: 'Unable to load health monitor data.',
  superuserHealthMessagesTitle: 'Messages overview',
  superuserHealthMessagesSubtitle: 'SMS volume, current status mix, and organization-level trends.',
  superuserHealthIssuesTitle: 'Issues',
  superuserHealthSearchIssues: 'Search issues',
  superuserHealthCreateIssue: 'Create issue',
  superuserHealthCreateIssueTitle: 'Create issue',
  superuserHealthIssue: 'Issue',
  superuserHealthIssueDetailsTitle: 'Issue details',
  superuserHealthLoadIssuesError: 'Unable to load issues.',
  superuserHealthLoadIssueDetailsError: 'Unable to load issue details.',
  superuserHealthLoadAssigneeRoleError: 'Unable to load assignee role.',
  superuserHealthLoadAssignableUsersError: 'Unable to load assignable users.',
  superuserHealthTitleAndCategoryRequired: 'Title and category are required.',
  superuserHealthUpdateIssueError: 'Unable to update issue.',
  superuserHealthAddCommentError: 'Unable to add comment.',
  superuserHealthMarkResolved: 'Mark resolved',
  superuserHealthReopenIssue: 'Reopen',
  superuserHealthResolvedAt: 'Resolved at',
  superuserHealthResolvedBy: 'Resolved by',
  healthEventSourceDevice: 'Source device',
  healthEventPeerDevice: 'Peer device',
  healthEventUserID: 'User ID',
  healthEventData: 'Data',
  healthEventDataJ: 'DataJ',
  healthEventFullValue: 'View full {0}',
  healthEventInvalidIDs: 'Enter positive IDs separated by commas (maximum 9223372036854775807).',
  healthEventLoadError: 'Unable to load event details.',
  healthEventPermissionError: 'You do not have permission to view event details.',
  healthEventFailCodeFilter: 'Remove fail code filter: {0}',
  superuserHealthProperties: 'Properties',
  superuserHealthLabels: 'Labels',
  superuserHealthCustomerCase: 'Customer case',
  superuserHealthAddComment: 'Add comment',
  superuserHealthCommentPlaceholder: 'Write an operational note',
  superuserHealthNoComments: 'No comments yet.',
  superuserHealthLastHour: 'Last hour',
  superuserHealthLast24Hours: 'Last 24 hours',
  superuserHealthPrevious24Hours: 'Previous 24 hours',
  superuserHealthLast7Days: 'Last 7 days',
  superuserHealthPrevious7Days: 'Previous 7 days',
  superuserHealthToday: 'Last 24 hours',
  superuserHealthYesterday: 'Previous 24 hours',
  superuserHealthThisWeek: 'Last 7 days',
  superuserHealthLastWeek: 'Last week',
  superuserHealthLastWeekSamePeriod: 'Previous 7 days',
  superuserHealthSmsTodayVsLastWeek: 'SMS: last 24 hours vs previous 24 hours',
  superuserHealthSmsWeekVsLastWeek: 'SMS: last 7 days vs previous 7 days',
  superuserHealthSmsLast24HoursVsPrevious24Hours: 'SMS: last 24 hours vs previous 24 hours',
  superuserHealthSmsLast7DaysVsPrevious7Days: 'SMS: last 7 days vs previous 7 days',
  superuserHealthStatusBreakdown: 'Status breakdown',
  superuserHealthStatusBreakdownLast24Hours: 'Status breakdown · last 24 hours',
  superuserHealthFailedReasons: 'Failed SMS reasons',
  superuserHealthFailedReasonsLast24Hours: 'Failed SMS reasons · last 24 hours',
  superuserHealthSmsTypesLast24Hours: 'Top SMS types · last 24 hours',
  superuserHealthOrganizationsLast24Hours: 'Top organizations · last 24 hours',
  superuserHealthSmsTypes: 'Top SMS types',
  superuserHealthOrganizations: 'Top organizations',
  superuserHealthTestSms: 'Test SMS',
  refresh: 'Refresh',
  admin: 'Admin',
  users: 'Users',
  archetype: 'Archetype',
  roles: 'Roles',
  allArchetypes: 'All Archetypes',
  allOrganizations: 'All Organizations',
  allStatuses: 'All Statuses',
  superuser: 'Superuser',
  organizationManager: 'Org Manager',
  shipper: 'Shipper',
  doctor: 'Doctor',
  bot: 'Bot',
  accountType: 'Account type',
  accountTypeUser: 'User',
  accountTypeServiceAccount: 'Service Account',
  accountTypeApiKey: 'API key',
  pendingRole: 'Pending Role',
  noUsersFound: 'No users found',
  supportHeader: 'How can we help? (Technical Support Only)',
  howToUseYourSmartCap: 'How to use your smart cap',
  smartCapTitle: 'How to use your smart cap',
  emailUs: 'Email',
  emailText: `If you have a query or specific question, we'd be happy to hear from you. Our customer support team are here to help and can be reached at:`,
  supportText:
    "If you have a query or specific question, we'd be happy to hear from you. Our customer support team are here to help and can be reached at ",
  supportEmail: 'contact@rxcap.com',
  supportLidSyncEmail: 'support@lidsync.com',
  supportButton: 'Email Us',
  phone: '+1(818) 618 6375',
  phoneLidSync: '+1(888)-618-0463',
  emailSubject: 'RxCap Web Portal assistance',
  emailLidSyncSubject: 'Lid Sync Web Portal assistance',
  calendar: 'Calendar',
  findOutMore: 'Find Out More',
  cancel: 'Cancel',
  done: 'Done',
  confirm: 'Confirm',
  careGiverInvalidLink: 'Link is invalid. please generate a new link.',
  takeSimulation: 'Take simulation',
  careGiverHeading: 'Become an RxCap Caregiver',
  careGiverSubHeading:
    'By entering your details you are accepting to receive txt message notifications from RxCap for the purposes of the CareGiver feature only…',
  invite: 'Invite',
  inviteToPortal: 'Invite to Portal',
  reInviteToPortal: 'Resend Portal Invitation',
  emailNeededForPortalAccess: 'Only patients with email addresses can be invited to portal',
  invitationSuccess: 'Invitation sent successfully',
  upload: 'Upload',
  uploading: 'Uploading',
  uploadSignedForm: 'Upload Signed Form',
  submit: 'Submit',
  close: 'Close',
  skipAndClose: 'Skip & Close',
  studyName: 'Study Name',
  daysOfWeek: 'Days of Week',
  dayOfWeek: 'Day of Week',
  dayOfMonth: 'Day of Month',
  setupCodeTasksHint: 'Required once per enrollment before monitoring codes are billed',
  description: 'Description',
  defaultEnabled: 'Default enabled',
  enabled: 'Enabled',
  disabled: 'Disabled',
  blacklisted: 'Blacklisted',
  masterConfiguration: 'Master Configuration',
  organizationConfiguration: 'Organization Configuration',
  backToHours: 'Back to Hours',
  add: 'Add',
  addPills: 'Add (Pills)',
  totalPills: 'Total (Pills)',
  back: 'Back',
  status: 'Status',
  oldStatus: 'Old Status',
  newStatus: 'New Status',
  usageState: 'State',
  administrativeState: 'Admin',
  operationalState: 'Ops',
  businessState: 'Business State',
  old: 'Old',
  changedStatus: 'Changed Status',
  patientUserName: 'Patient Username',
  alertBySMS: 'Alert by SMS',
  alertByEmail: 'Alert by Email',
  alertByPhone: 'Alert by Phone',
  showAll: 'Show All',
  login: 'Login',
  loginTitle: 'Login to RxCap',
  loginTo: 'Login to',
  securityCode: 'Security Code',
  securityCodeIsRequired: 'Security Code is required, check your email or sms message',
  show: 'Show',
  reset: 'Reset',
  inviteFirstAdmin: 'Invite your first administrator',
  inviteFirstPatient: 'Invite your first patient',
  inviteAnAdmin: 'Invite an Admin',
  sendInvite: 'Send Invite',
  inviteAdmin: 'Invite Admin',
  personalDetails: 'Personal Details',
  userDetails: 'User Details',
  phoneNumber: 'Phone Number',
  fillMissingPhoneNumber: 'Fill missing phone number',
  fillMissingAddress: 'Fill missing address',
  phone: 'Phone',
  company: 'Company',
  email: 'Email',
  dob: 'D.O.B.',
  monthYear: 'Month-Year',
  selectCompletedMonth: 'Select a completed month.',
  age: 'Age',
  startDate: 'Start Date',
  endDate: 'End Date',
  endsAt: 'Ends at',
  regimenDetails: 'Regimen Details',
  regimenStartDate: 'Regimen Start Date',
  regimenEndDate: 'Regimen End Date',
  regimenLength: 'Regimen Length',
  activeFor: 'Active for',
  usesSmartCap: 'Uses Smart Cap',
  notAvailable: 'not available',
  adminAppPrevileges: 'Admin App Privileges',
  adminWritePrevileges: 'Write Privileges',
  adminTimerRights: 'Triggers Timer',
  adminAccess: 'Admin access',
  manageMultipleStudiesText: 'You can create and manage multiple studies at the same time.',
  invitePatientMessage: 'You can invite patients to use RXCap to track their medication adherence.',
  medicationAdherenceMessage: 'Medication adherence data are automatically added to your Provider Portal.',
  showingDataFromAllPatients: 'Showing data from all of your patients and studies',
  downloadApp: 'Download the App',
  createYourFirstStudy_p1: 'You can ',
  createYourFirstStudy_p2:
    ', view or edit any of your studies from the studies tab. With quick access to patient counts adherence and trends. Or delve deeper to view patient data and medication time stamps.',
  addAPatient_p1: 'You can ',
  addAPatient_p2:
    ', view and manage patients from the patients tab. Once you have created a ‘study’ you will be able to assign patients directly to a study when you are adding them to the portal.',
  addAPatient_2_p1: 'You have added a study, but have not assigned any ',
  addAPatient_2_p2: '. You can ',
  addAPatient_2_p3:
    ' and manage all your patients via the patients tab. This dashboard will be updated with analytics and graphs once sufficient data has been gathered from assigned patients.',
  inviteAnAdmin_p1: 'In the admin tab you can ',
  inviteAnAdmin_p2: ' and manage administration privileges, and access rights for doctors and researchers.',

  dashboardNoDataYet: 'Dashboard features will unlock after more data becomes available',

  medicationsMap: 'Medications Map',
  signIn: 'Sign In',
  signUp: 'Sign Up',
  patientAddedSuccessfully: 'Patient added successfully',
  patientSavedSuccessfully: 'Patient saved successfully',
  welcomeToRxCap: 'Welcome to RxCap',
  welcomeToApp: 'Welcome to RXCap Provider Portal',
  welcome: 'Welcome',
  loadingFhirSessions: 'Loading FHIR session...',
  password: 'Password',
  forgotPassword: 'Forgot password?',
  createAccount: 'Create Account',
  createRxCapAccount: 'Create RXCap Account',
  create: 'Create',
  addAPatient: 'Add a Patient',
  appTitle: 'The RXCap Platform',
  loginToRxCap: 'Login to RX-Cap',
  loginToLidSync: 'Login to Lid Sync',
  lidSync: 'Lid Sync',
  setPasswordToRxCap: 'Set password',
  invitePatient: 'Invite Patient',
  addMedication: 'Add Medication',
  editMedication: 'Edit Medication',
  summary: 'Summary',
  youAreAllDone: "You're All Done",
  youAreAllDoneName: 'Add next patient(s)/medication',
  youFinishedSetup: "You've finished the set up for {0}",
  finishedRpmSetup: "You've finished the set up for your organization",
  mobileVersionNotSupported: 'Mobile version not supported',
  editProfile: 'Edit Profile',
  editPatientInfo: 'Edit Patient Info',
  deletePatient: 'Delete Patient',
  changePassword: 'Change Password',
  adherence: 'Adherence',
  adherenceForPeriod: 'Adherence for period',
  study: 'Study',
  search: 'Search',
  searchLog: 'Search Log',
  leave: 'Leave',
  patientCount: 'Patient Count',
  createStudy: 'Create a Study',
  editStudy: 'Edit a Study',
  country: 'Country',
  introduction: 'Introduction',
  editPersonalSettings: 'Edit Your personal settings',
  dateOfBirth: 'Date of birth',
  city: 'City',
  mobileNumber: 'Mobile Number',
  confirmPassword: 'Confirm Password',
  passwordChangeFailedCheckYourSecurityCode: 'Password change failed, check your security code.',
  confirmDelete: 'Confirm Delete',
  confirmAssignment: 'Confirm Assignment',
  newPassword: 'New Password',
  oldPassword: 'Old Password',
  showPassword: 'Show Password',
  hidePassword: 'Hide Password',
  resetPassword: 'Reset Password',
  careProviderOrganization: 'Care Provider Organization',
  reassignCareProvider: 'Reassign Care Provider',
  reassignCareProviderSuccess: 'Care Provider reassigned successfully',
  removeCareProviderWarning: 'Are you sure you want to remove care provider {0}?',
  careProvidersHeader: 'Care Providers (users available to this organization that can be assigned to patient enrollment)',
  careProviderAssignmentWarning: 'Care provider organization is assigned to active enrollments',
  careProviderAssignmentWarningDetails:
    'Remove or update these patient enrollments before deleting this care provider organization or click "Unassign and Remove" to have them unassigned.',
  inactiveCareProviderWarning: 'Inactive or deleted care provider organization',
  inactiveCareProviderWarningDetails:
    'This care provider organization is inactive or deleted and can no longer be used for new assignments.',
  careProviders: 'Care Providers',
  unassignAndRemove: 'Unassign and Remove',
  byEmail: 'By Email',
  bySMS: 'By SMS',
  next: 'Next',
  later: 'Later',
  watchNow: 'Watch Now',
  allDay: 'All Day',
  yourAllDone: 'Your All Done!',
  videoInst:
    'Great, your device is all set up and ready to use. Before you start using it, we recomend you view a quick tutorial on how to use it.',
  esiDoctorInviteText:
    'You have been invited to be an admin on RxCap. To complete the verification process, please enter your mobile number, then enter the verification code.',
  esiDoctorCodeText:
    'We have sent you a 6-Digit verification code. Enter it below to verify your account. This code will expire in: ',
  esiDoctorAlmostDone:
    'Almost done, please use the credentials that have been sent to you via email to login to your account.',
  resetByEmail: 'Reset By Email',
  resetBySMS: 'Reset By SMS',
  resend: 'Resend',
  withYourAccount: 'with your account',
  weSentYouEmail: 'We have sent you Email',
  ok: 'Ok',
  enterNewPasswordMessage: 'Enter the new password you wish to use for',
  weSentVerificationCode: 'We have sent a verification code',
  yourRxCapAccountBelow: 'your RXCap account below',
  congratulations: 'Congratulations',
  enterBelowToContinue: 'Enter it below to continue',
  thisOptionIsrequired: 'This option is required',
  notFound: 'Not found',
  hi: 'Hi',
  lblResetPassword: 'Enter the email address associated with',
  lblResetPasswordRx: 'your RX-CAP account below:',
  enterEmailAddressAssociated: 'Enter the email address associated',
  enterPhoneNumberAssociated: 'Enter the mobile number associated with your account.',
  enterPhoneNumber2nd: ' In case of problems, contacts:',
  resetPasswordMessage: ' If you forgot your password, please choose one of the reset methods below:',
  appSubtitle:
    'Keep track of your medication usage, or if you are a doctor gain valuable, \n  real time insights on your patient medicine adherence \n through our online, mobile app and SmartCap solution.',
  requestDeleteText: 'You have requested to delete your RXCap account. ',
  requestConfirmText: () =>
    'Please confirm that you understand that this operation is <span class="color-brand-red"><strong>irreversible</strong></span> ',
  requestToContinue: 'and press the button to continue.',
  iAmAwareText: 'I am aware that continuing will ',
  irreversiblyText: 'irreversibly delete all data',
  aboutMeText: 'about me currently stored by RXCap.',
  deleteBtn: 'Delete Account',
  verificationCompleteText: 'Verification Complete',
  reviewThePatientText:
    'Review the patients profile information, then press the next button to review their current medications.',
  nextBtnText: 'Next',
  weAreSorryText:
    'We&apos;re sorry, but your FHIR endpoint doesn&apos;t seem to support the MedicationOrder endpoint. Please contact your EHR administrator for more information.',
  reviewYourPatient:
    'Review your patients medication, then select the ones you want to have linked to their RXCap account.',
  sendInviteText: 'Send Invite',
  patientNameText: 'Patient Name',
  inviteBySMSText: 'Invite by SMS',
  toFinishTheSetupText: 'To finish the set up process, add the patients phone number and click',
  invitationSentText: 'Invitation sent',
  adminInviteSent: 'Admin invite sent',
  youHaveBeenInvitedText: 'You have been invited to use RXCap by your Physician to keep',
  trackOfYourMedicineText: ' track of your medicine adherence. Input the required information by',
  toVerifyYourAccountText: ' to verify your account.',
  verifyAccountText: 'Verify your Account',
  yourDSAccountActivatedText:
    'Your RXCap account is now active, and you can now log into it on the RXCap mobile app. Check your mail box on your phone for the Download link to get the app on iPhone or Android',
  yourDSAccActivatedText: 'Your RXCap account is now active.',
  checkYourInbox: 'Check your inbox, or click the relevant link below to download the app.',
  loadingFHIRSession: 'Loading FHIR session...',
  enterPhoneNumberThatCanBeUsedToVerifyYourIdentity:
    'Enter a phone number that can be used to verify your identity with a text message.',
  noSMSReminderText: 'No SMS reminders?',
  weHaveSentCodeText: 'We have sent a temporary verification code to:',
  enterTheCodeText: '. Enter the code below to verify the number.',
  didnText: 'Didn',
  tReceiveACode: 't receive a code?',
  digitVerificationCode: '6 Digit Verification code',
  yourText: 'Your ',
  verifiedText: ' has been successfully verified.',
  editNotifcationSettingsText: 'Edit Notification Settings',
  chagneSettingForText: 'Change Settings for',
  dsUsesSmartText:
    'RXCap uses smart escalating notifications to send you medication reminders, via either email, SMS text messages, or by phone calls. We may also send information about important updates.',
  selectWhichNotificationText: 'Select which notifications you would like to receive from RXCap',
  emailsText: 'Emails',
  smsText: 'SMS',
  voiceText: 'Voice',
  takenAt: 'Taken At',
  dailyDataText: 'Daily data begins at 6 am',
  clickToTakeText: 'Click to Take Now!',
  dateText: 'Date',
  timeDueText: 'Time Due',
  medicationNameText: 'Medication Name',
  medicationSearchUnavailable:
    'Medication search is temporarily unavailable. Please try again later or add the medication manually.',
  frequencyText: 'Frequency',
  areYouSure: 'Are You Sure?',
  areYouSureText: 'Are you sure you want to delete ',
  addMedicationText: 'Add Medication',
  dosageText: 'Dosage - ',
  daysText: 'Days - ',
  timesText: 'Times -',
  dosage: 'Dosage',
  times: 'Times',
  delete: 'Delete',
  edit: 'Edit',
  launch: 'Launch',
  unsuspend: 'Unsuspend',
  createYourFirstStudy: 'Create Your First Study',
  whenToTakeMedicine: 'When to take Medicine?',
  frequency: 'Frequency',
  doseFrequency: 'Dosing Frequency',
  asNeeded: 'As Needed',
  everyDay: 'Every Day',
  everyXDays: 'Every {0} Days',
  specificDays: 'Specific Days',
  interval: 'Interval',
  howLongToTakeMedicine: 'How long to take Medicine?',
  days: 'Days',
  weeks: 'Weeks',
  daysOfweek: 'Days of Week',
  afterHowManyDays: 'After how many days?',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  timeForTakingMedicine: 'Time for taking Medicine',
  administrationWindow: 'Administration Window',
  medicineName: 'Medicine Name',
  dose: 'Dose',
  startsAlongWithEnrollment: 'Starts along with enrollment',
  attach: 'Attach',
  review: 'Review',
  capName: 'Cap Name',
  capId: 'Cap ID',
  hubId: 'Hub ID',
  devicesPlural: {
    hub: 'Hubs',
    ble: 'BLE Caps',
    lte: 'LTE Caps',
    lsc: 'LSC Caps',
  },
  devicesEnum: {
    Kit: 'Kit',
    Datahub: 'Datahub',
    'Bluetooth Cap': 'Bluetooth Cap',
    'LTE Pillbox': 'LTE Pillbox',
    'LTE Smart Cap': 'LTE Smart Cap',
    'Injectable Medication Tracker': 'Injectable Medication Tracker',
    'MDP Dispenser': 'MDP Dispenser',
    'LTE Medication Organizer': 'LTE Medication Organizer',
    'Blood Pressure Monitor': 'Blood Pressure Monitor',
    'Weighing Machine': 'Weighing Machine',
    'Wrist Band': 'Wrist Band',
    Glucometer: 'Glucometer',
    Thermometer: 'Thermometer',
    Inhaler: 'Inhaler',
    Spirometer: 'Spirometer',
    'Pulse Oximeter': 'Pulse Oximeter',
    'Air Quality Monitor': 'Air Quality Monitor',
    'Hailie Inhaler': 'Hailie Inhaler',
    'PT/INR Monitor': 'PT/INR Monitor',
  },
  devicePluralsEnum: {
    Kit: 'Kits',
    Datahub: 'Datahubs',
    'Bluetooth Cap': 'Bluetooth Caps',
    'LTE Pillbox': 'LTE Pillboxes',
    'LTE Smart Cap': 'LTE Smart Caps',
    'Injectable Medication Tracker': 'Injectable Medication Trackers',
    'MDP Dispenser': 'MDP Dispensers',
    'LTE Medication Organizer': 'LTE Medication Organizers',
    'Blood Pressure Monitor': 'Blood Pressure Monitors',
    'Weighing Machine': 'Weighing Machines',
    'Wrist Band': 'Wrist Bands',
    Glucometer: 'Glucometers',
    Thermometer: 'Thermometers',
    Inhaler: 'Inhalers',
    Spirometer: 'Spirometers',
    'Pulse Oximeter': 'Pulse Oximeters',
    'Air Quality Monitor': 'Air Quality Monitors',
    'Hailie Inhaler': 'Hailie Inhalers',
    'PT/INR Monitor': 'PT/INR Monitors',
  },
  id: 'ID',
  hubName: 'Hub Name',
  or: 'Or',
  capsAdmin: 'Caps Manager',
  searchNewCap: 'Search New Cap',
  addCapsAdmin: 'Add Cap Manager',
  addDoctor: 'Add Doctor',
  doctors: 'Doctors',
  serviceAccounts: 'Service Accounts',
  attachCapsToAdmin: 'Attach Caps to Manager',
  attachCap: 'Attach Device',
  attachDevice: 'Attach Device',
  devicesToAttach: 'Devices to attach',
  SendDeviceSecurityCode: 'Send Device Security Code',
  AddEditHardware: 'Enter Device ID',
  enter6DigitCode: 'Enter 6 character code or hardware ID printed on the cap',
  eventTimestamp: 'Event Date',
  lastEventTimestamp: 'Last Event Date',
  lastEventTime: 'Last Event Time',
  eventDate: 'Event Date',
  eventType: 'Event Type',
  physioParams: 'Physio Params',
  max: 'Max',
  min: 'Min',
  condition: 'Condition',
  conditions: 'Conditions',
  attachCapToAdmin: 'Attach Cap to Admin',
  locations: 'Location',
  location: 'Location',
  state: 'State',
  street: 'Street',
  zipCode: 'Zip Code',
  organizationName: 'Org Name',
  devices: 'Devices',
  deletedDevices: 'Deleted Devices',
  temperature: 'Temperature',
  charge: 'Charge',
  action: 'Action',
  eventList: 'Event list',
  version: 'Version ',
  timezone: 'Time zone',
  selectStartAdministrativeWindow: 'Please select an start administrative window',
  selectEndAdministrativeWindow: 'Please select an end administrative window',
  idleSessionMessage: 'Your session is about to expire due to inactivity.',
  extend: 'Extend',
  recoverPassword: 'Recover Password',
  showingXOf: 'Showing {0} of {1} {2}',
  showingX: 'Showing {0} {1}',
  showingXHubs: {
    showing: 'Showing',
    of: 'of',
    hubs: 'Hubs',
  },
  showingXKits: 'Showing {0} of {1} Kits',
  showingXDevices: 'Showing {0} of {1} Devices',
  showingXPatients: 'Showing {0} of {1} Patients',
  showingXCohorts: 'Showing {0} of {1} Cohorts',
  devicesInThisArea: 'Devices in this area',
  activeHubs: 'Active Hubs',
  pendingHubs: 'Pending Hubs',
  hubs: 'Hubs',
  scales: 'Scales',
  bpMonitors: 'BP Monitors',
  bpm: 'BPM',
  bpm_unit: 'bpm',
  inLast: 'In last',
  noReadings: 'No Readings',
  showingWait: 'Showing...',
  deviceReadings: 'Readings',
  yourKits: 'Your Kits',
  kits: 'Kits',
  pendingCalls: 'Pending Calls',
  pendingMessages: 'Pending Messages',
  enrolledPatients: 'Enrolled Patients',
  pendingEnrollment: 'Pending Enrollment',
  totalKits: 'Total Kits',
  widgets: {
    yourKitsChart: 'Your Kits Chart',
    deviceReadingsChart: 'Device Readings Chart',
    numberOfDevices: 'Number of Devices',
    numberOf: 'Number of {0} ({1})',
    real_time: 'real-time',
    daily: 'daily',
    monthly: 'monthly',
    locationsOfYourKits: 'Locations of Your Kits',
    hubsWithoutReadings: 'Hubs without Readings',
    hubsActivedLastMonth: 'Hubs Activated Last Month',
    monthlyOperatingRate: 'Monthly Operating Rate',
    patientActions: 'Patient Actions',
    unreadMessages: 'Unread Messages',
    patientsEnrollment: 'Patients Enrollment',
    totalKits: 'Total Kits',
    patientsWithNoReadings: 'Activated Patients with no readings',
    patientsWithNoReadingsInTheLastDays: 'Activated Patients with no readings in the last {0} days',
    patientsWithNewNotes: 'Patients with new notes',
    medicalHistory: 'Medical History',
    patientDetails: 'Patient Details',
    enrollmentHistory: 'Enrollment History',
    insurance: 'Insurance',
    centerDetails: 'Center Details',
    transplantDetails: 'Transplant Details',
    patientsToCall: 'Patients to Call',
    details: 'Details',
    people: 'People',
    daysComplied: 'Days Complied',
    daysLeftInCycle: '{0} days left in cycle',
    devicesActivatedToday: '{0} Activated Today',
    patientStatus: 'Patient Status',
    programDistribution: 'Program Distribution',
    patientsWithMandatoryTasksMissing: 'Patients missing required billing tasks',
    ordersPendingReview: 'Orders pending review',
    recentDeliveries: 'Recent Deliveries',
    recentDeliveriesTooltip: 'In the last 30 days',
  },
  widgetsTooltips: {
    active_number_real_time: 'Number of {0} which sent at least one measurement in the last 24 hours',
    new_number_real_time: 'Number of {0} that have never sent a reading since they were assigned to the organization',
    offline_number_real_time: "Number of {0} which didn't connect to the network in the last 7 days",
    online_number_real_time: 'Number of {0} connected to the network in the last 7 days',
    total_number_real_time: 'Number of all {0} assigned to the organization',
    activated_number_real_time: 'Number of {0} activated today',
    active_number_daily: 'Number of {0} which sent at least one measurement yesterday',
    new_number_daily:
      'Number of {0} that have never sent a reading since they were assigned to the organization as of yesterday',
    offline_number_daily: "Number of {0} which didn't connect to the network yesterday",
    online_number_daily: 'Number of {0} connected to the network yesterday',
    total_number_daily: 'Number of all {0} assigned to the organization as of yesterday',
    activated_number_daily: 'Number of {0} activated yesterday',
    active_number_monthly: 'Number of {0} which sent at least one measurement in the previous month',
    new_number_monthly:
      'Number of {0} that have never sent a reading since they were assigned to the organization as of previous month',
    offline_number_monthly: "Number of {0} which didn't connect to the network in the previous month",
    online_number_monthly: 'Number of {0} connected to the network in the previous month',
    total_number_monthly: 'Number of all {0} assigned to the organization as of previous month',
    activated_number_monthly: 'Number of {0} activated in the previous month',
    monthlyOperatingRate:
      'Average of connected rate (Days having a connection at least once / eligible days in the previous month) of all activated hubs',
    activated_number_24h: 'Number of {0} activated in the last 24 hours',
    numberOfDaysComplied: 'Number of days complied since {0} (for code {1})',
    inTheLastXDays: 'In the last {0} days',
  },
  editDashboardTooltip: 'Edit dashboard (remove, rearrange, resize widgets)',
  errors: {
    requiredStudyNameAndDescription: 'Your study needs a name and description',
    longStudyName:
      'Long study names may not be fully displayed, depending on the screen resolution at which the page is viewed.',
    invalidCapId: 'Invalid Cap id',
    invalidDeviceId: 'Invalid Device id',
    enterAnyOne: 'Enter any one cap id',
    endTime: 'End time should be greater than a start time',
    timeInTheFuture: 'Start time and end time should not be a future date',
    timeBeforeEnrollment: 'Task time must be within the enrollment period (starting {0})',
    taskDurationMinutes: 'Enter a whole number of minutes greater than or equal to 0',
    taskDurationSeconds: 'Enter a whole number of seconds from 0 to 59',
    taskDurationRequired: 'Task duration must be at least 1 second',
    taskDurationInFuture: 'Start time plus duration cannot be in the future',
    taskDurationTooLong: 'Task duration cannot exceed 24 hours',
    dateInTheFuture: 'Date should not be a future date',
    dateInThePast: 'Date should be a future date',
    emptyOrgId: 'Please select organization',
    emptyCapId: 'Valid cap id is required',
    emptyDeviceId: 'Valid device id is required',
    emptyMedicineName: 'Medicine name is required',
    emptyHowLongToTakeMedicine: 'Number of days is required',
    emptyHowLongToTakeMedicineWeek: 'Number of weeks is required',
    validHowLongToTakeMedicine: 'Please enter a valid number of days/weeks',
    validHowLongToTakeMedicineDays: 'Please enter valid number of days (below 999 days)',
    validHowLongToTakeMedicineWeeks: 'Please enter valid number of weeks (below 999 weeks)',
    scheduleTypeRequired: 'Please select when to take medicine',
    invalidDays: 'please enter valid days',
    duplicateTimeForTake: 'Time for taking medication is duplicated',
    administrativeWindowRequiredForMultipleTakes: 'Administrative window is required for multiple takes',
    timeBetweenMedicineTooShort: 'Time between takes is too short',
    emptyValidHowManydays: 'How many days is required',
    emptyTakenTime: 'Time for taking Medicine is required',
    emptyDaysOfWeek: 'Please select days of Week',
    connectionError: 'Please check your internet connection and try again',
    internalError: 'Something went wrong, please try again',
    unknownError: 'Unknown error',
    invalidEmail: 'Please enter a valid email address',
    emptyEmailAddress: 'Email Address is required',
    emptyNickName: 'Nickname is required',
    emptyFirstName: 'First Name is required',
    emptyOrgName: 'Organization name is required',
    emptyIsRequired: 'is required',
    emptyOldPassword: 'Old password is required',
    emptyConfirmPassword: 'Confirm password is required',
    emptyNewPassword: 'New password is required',
    passwordsDontMatch: "Passwords don't match",
    emptyLastName: 'Last Name is required',
    emptyCode: 'Code is required',
    emptyPhoneNumber: 'Phone number is required',
    emptyName: 'Name is required',
    emptyDosage: 'Dosage is required.',
    emptyPatient: 'Patient is required.',
    selectOneDay: 'Please select at least one day.',
    addMedicationTime: 'Please add at least one medication time.',
    invalidPhoneNumber: 'Invalid phone number',
    passwordNotMatched: 'Incorrect username or password',
    pleaseTryAgain: 'Please, try again.',
    invalidDOB: 'Please enter valid Date of birth.',
    enterValidText: 'Please enter a valid',
    invalidPassword:
      'Your password should be at least 8 characters long and must have 1 number, 1 symbol (~!*^@#$%&), 1 upper case and 1 lower case character.',
    invalidActivationCode: 'Activation code is not valid.',
    noPhoneNoEmail: 'You should enter your email or phone number',
    phone: {
      notValid: 'Phone is not valid',
      invalidCountryCode: 'Invalid country code',
      notANumber: 'Not a number',
      tooLong: 'Number is too long',
      tooShort: 'Number is too short',
    },
    unrecognisedNumber: 'Unrecognised Number',
    unrecognisedNumberText: 'The phone number you entered does not match the one we have for you on our system.',
    settingLimitsError: 'Setting limits error',
    unrecognisedNumberEsiPatientText: () => [
      'Please re-enter your phone number or contact us for help. ',
      <a href="mailto:support@lidsync.com">support@lidsync.com</a>,
      ' or ',
      <a href="tel:+1 888-618-0463">+1 888-618-0463</a>,
    ],
    invalidCode: 'Invalid Code',
    invalidCodeText: 'The code you entered was not valid, try again, or press resend to receive a new code.',
    invalidCodeEsiPatientText: () => [
      'The code you entered was not valid, try again, or get help at ',
      <a href="mailto:support@lidsync.com">support@lidsync.com</a>,
      ' or ',
      <a href="tel:+1 888-618-0463">+1 888-618-0463</a>,
    ],
    invalidName: 'You entered invalid name',
    invalidFirstName: 'You entered invalid first name',
    invalidLastName: 'You entered invalid last name',
    invalidOrgName: 'You entered invalid Organization name',
    nothingToChange: 'There is nothing to change',
    deviceIdError: 'Device id shall be shorter than 100 characters',
    maxValueExceeded: 'Maximum allowed value is {0}',
    startDateCantBeInThePast: 'Start date can not be in the past',
    endDateMustBeAfterStartDate: 'End date must be after start date',
    endDateMustBeTomorrow: 'End date must be tomorrow or later',
    endDateMustBeBeforeEnrollmentEndDate: 'End date must be before enrollment end date',
    enrollmentEndMustBeAfterenrollmentStart: 'Enrollment end date must be after enrollment start date',
    duplicateThreshold: 'Threshold should be unique',
    somethingWentWrong: 'Something went wrong. Please try reloading the page. If the problem persists, contact support.',
    // Credential validation
    emailRequired: 'Email is required',
    emailTooLong: 'Email is too long',
    emailMustContainAt: 'Email must contain @',
    emailLocalPartMissing: 'Email local part is missing',
    emailDomainMissing: 'Email domain is missing',
    emailDomainMustContainDot: 'Email domain must contain a dot',
    invalidEmailFormat: 'Invalid email format',
    phoneRequired: 'Phone number is required',
    phoneTooShort: 'Phone number is too short',
    phoneTooLong: 'Phone number is too long',
    usernameRequired: 'Username is required',
    usernameTooShort: 'Username must be at least 3 characters',
    usernameTooLong: 'Username is too long',
    // 2FA errors
    enterRecoveryCode: 'Please enter a recovery code',
    enter6DigitCode: 'Please enter the 6-digit code',
    nothingToUpdate: 'There is nothing to update',
  },
  // Two-factor authentication
  twoFactor: {
    title: 'Two-Factor Authentication',
    smsVerification: 'SMS Verification',
    emailVerification: 'Email Verification',
    enterCodeFromApp: 'Enter the 6-digit code from your authenticator app',
    enterCodeSentToPhone: 'Enter the 6-digit code sent to {0}',
    enterCodeSentToEmail: 'Enter the 6-digit code sent to {0}',
    enterRecoveryCode: 'Enter one of your recovery codes to sign in.',
    useRecoveryCode: 'Use a recovery code instead',
    useAuthenticatorCode: 'Use authenticator code instead',
    resendIn: 'Resend in {0}s',
    invalidCode: 'Invalid code. Please try again.',
  },
  // Credential type detection
  credentialDetection: {
    emailDetected: 'Email detected',
    mobileDetected: 'Mobile detected',
    usernameDetected: 'Username detected',
  },
  // Password strength
  passwordStrength: {
    label: 'Password Strength',
    veryWeak: 'Very Weak',
    weak: 'Weak',
    fair: 'Fair',
    strong: 'Strong',
    veryStrong: 'Very Strong',
    requirements: {
      minLength: 'At least 8 characters',
      uppercase: 'One uppercase letter (A-Z)',
      lowercase: 'One lowercase letter (a-z)',
      number: 'One number (0-9)',
      special: 'One special character (!@#$%^&*)',
    },
  },
  warnigs: {
    cantBeUndone: "Caution: This action can't be undone.",
    deleteCaregiver: 'Are you sure you want to delete caregiver',
    adminAppPrevilegesWarning: 'Are you sure you want to change Admin App Privileges for this doctor?',
    adminDelete: 'This action cannot be undone. Are you sure you want to delete the following administrator?',
    adminResetPassword: 'Are you sure you want to reset password for the following user:',
    resendInvite: 'Are you sure you want to resend the invitation to the following user:',
    inviteFirstAdminWarning: ' To invite your first administrator please enter Email Address.',
    inviteFirstPatientWarning: ' To invite your first patient please enter Email Address.',
    longStudyName:
      'Long study names may not be fully displayed, depending on the screen resolution at which the page is viewed.',
    deletePatientWarning:
      'When patient is deleted, all their Medication schedules and notifications will be stopped and all active alerts will be cleared.',
  },
  success: {
    deleteAccountSuccess: 'The account has been deleted successfully.',
    dataSavedSuccessfully: 'Data saved successfully!',
    passwordResetSuccess:
      'Your RXCap password has now been reset, press login below to login to your account using your new credentials',
    invitationConfirmedSuccessfully: 'Your invitation has been successfully confirmed.',
    medicationSaved: 'Medication saved successfully',
  },
  placeholder: {
    phoneNumber: 'Enter phone number',
    emailAddress: 'Enter Email Address',
    medicationName: 'Enter Medication Name',
    dosageName: 'Enter Dosage Here',
    newTimeZone: 'Add a New Time',
    userName: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    code: 'Code',
    cgPhoneNumber: 'Phone number',
    notesArea: 'Notes',
  },
  battery: {
    level: 'Battery level',
    battery: 'Battery',
    high: 'Good',
    medium: 'Medium',
    low: 'Poor',
    noData: 'Not available',
  },
  charging: {
    charging: 'Charging',
    notCharging: 'Not charging',
    fullUsbConnected: 'Full — USB connected',
    lastBatteryLevel: 'Last battery level: {0}% ({1})',
    lastChargingStatus: 'Last charging status: {0} ({1})',
    chargingStarted: 'Charging started',
    chargingFinished: 'Charging finished',
    chargingOngoing: 'Charging ongoing',
    beforeCharging: 'Before charging: {0}% · {1} V',
    afterCharging: 'After charging: {0}% · {1} V',
  },
  esiPatientStatus: {
    capInUse: 'Cap in use',
    pending: 'Pending',
    shipping: 'Shipping',
    inProgress: 'In progress',
    ready: 'Ready',
    active: 'Active',
  },
  patientDashboard: {
    upcomingReminders: 'Upcoming Reminders',
    activeMedications: 'Active Medications',
    stockManagement: 'Pills in Hand',
    seeAll: 'See All',
    seeDetails: 'See Details',
    calendar: 'Calendar',
    viewHistory: 'View History',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    allMeds: 'All Meds',
    all: 'All',
    allOrg: 'All Organizations',
    noOrg: 'No Organization',
    selectOrg: 'Select Organization',
    doses: 'Pills',
    dose: 'Pill',
  },
  esiPatientInfo: {
    street: 'Street',
    appartment: 'Appartment/Suite',
    zip: 'ZIP',
    city: 'City',
    state: 'State',
    country: 'Country',
    schedule: 'Schedule',
    device: 'Device',
    time: 'Time',
    activeFrom: 'Active from',
  },
  patient_medications: {
    noInsuranceEntered: 'This patient has no insurance on file. Add it in the patient\'s Insurance section, then select it here.',
    medication: 'Medication',
    activeMedications: ' Active medications',
    stockDoses: 'Stock (doses)',
    active: 'Active',
    inActive: 'Inactive',
    schedule: 'Schedule',
    name: 'Name',
    frequency: 'Frequency',
    timesPerDay: 'Times Per Day',
    startDate: 'Start Date',
    endDate: 'End Date',
    createdOn: 'Created On',
    editedOn: 'Edited On',
    lastTaken: 'Last Taken',
    nextReminder: 'Next Reminder',
    stock: 'Stock',
    numberOfPill: 'Number of Pills',
    dosesInStock: 'Doses in Stock',
    pillsInHand: 'Pills in Hand',
    tooMayPillsWaring: 'Too many pills added. Pills number reduced to ',
    willLastFor: 'Will last for',
    expiresOn: 'Expires on',
    edit: 'Edit',
    hardwareId: 'Hardware ID',
    device: 'Device',
    battery: 'Battery',
    activationDate: 'Activation Date',
    learnMore: 'Learn more',
    refill: 'Refill',
    fillDate: 'Fill Date',
    rxNumber: 'RX Number',
    sig: 'SIG',
    medicationNotes: 'Medication Notes',
    patientMedication: 'Patient medication',
    noPatientMedication: 'None',
    otherMedications: 'Other medications',
    status: 'Status',
    statusScheduled: 'Scheduled',
    statusNotScheduled: 'Not scheduled',
    statusNotInMedicationList: 'Not in medication list',
    addSchedule: 'Add schedule',
    editSchedule: 'Edit schedule',
    removeSchedule: 'Remove schedule',
    attachCap: 'Attach cap',
    detachCap: 'Detach cap',
    addScheduleTitle: 'Add Schedule',
    editScheduleTitle: 'Edit Schedule',
    prescriber: 'Prescriber',
    editInMedicalHistory: 'Edit in Medical History',
    removeFromMedicalHistory: 'Remove from Medical History',
    removeFromMedicalHistoryWarning: 'Are you sure you want to remove {0} from the patient\'s medication list?',
    removeFromMedicalHistoryScheduleKept: 'Its schedule is kept and will show as not in the medication list.',
    removedFromMedicalHistory: 'Medication removed from Medical History',
    selectPatientMedication: 'Select a medication from the patient\'s list',
    noPatientMedications: 'The patient\'s medication list is empty. Add the medication to the patient\'s list first (Add Medication).',
    noMedicationsToSchedule: 'Every medication on the patient\'s list already has a schedule. Add the medication to the patient\'s list first (Add Medication).',
    duplicateMedication: 'the patient already has a medication with this name and NDC',
    ndcChecking: 'checking the NDC',
    ndcNotFound: 'NDC not found — leave it blank for drugs without an NDC (e.g. clinical trials) and put the code in Notes',
    ndcCheckUnavailable: 'The NDC could not be checked right now. Make sure the medication name matches the NDC.',
    selectNdcMedication: 'Select the medication for this NDC',
    time: 'Time ',
    times: 'Time(s)',
    am: 'AM',
    pm: 'PM',
    addPills: 'Add (Pills)',
    totalPills: 'Total (Pills)',
    zero: '0',
    doseRemaining: 'Pills Remaining',
    thisWillLastFor: 'This will last until',
    downloadFullMedlist: 'Download Full Med List',
    downloadFilteredMedList: 'Download Filtered Med List',
    last2Months: 'Last 2 Months',
    last6Months: 'Last 6 Months',
    lastWeek: 'Last Week',
    lastMonth: 'Last month',
    assignedCap: 'Assigned cap',
    reminders: {
      early: 'Early Reminder',
      on_time: 'On-Time Reminder',
      late: 'Late Reminder',
      missed_doses: 'Missed Doses Reminder',
      first_take: 'First Take Achievement',
      streak_achievement: 'Streak Achievement',
      back_on_track: 'Back on Track',
      dose_confirmed: 'Dose Confirmed',
      first_dose_reminder: 'First Dose Reminder',
      daily_evening_missed_dose: 'Daily Evening Missed Dose',
    },
    remindersTypes: {
      early: 'Early',
      on_time: 'On-Time',
      late: 'Late',
      missed_doses: 'Missed doses',
    },
    messageFor: 'Message for {0}',
    numberOfDoses: '# of doses',
    defaultDoses: '3 doses',
    tagsForReminders: 'Tags to be used in reminders messages',
    clickOnTag: '(Click on tag to add it to the message)',
    reminderCharLimit: 'Messages must be less than 320 characters long',
    enter3Chars: 'Enter at least 3 characters to search',
    messageSettings: 'Message Settings',
    useSeparateMessage: 'Use separate message for each threshold',
    useSameMessage: 'Use same message for all thresholds',
    notificationsOffWarning:
      'Sending notifications to this patient is disabled. Reminders and milestone messages will be saved but not sent until you turn notifications on. You can enable notifications in the patient info page.',
  },
  endUserLicenseAgreement: 'End User License Agreement',
  privacyPolicy: 'INTERNET PRIVACY POLICY',
  privacyPolicyTrust: 'Privacy policy',
  termsOfUse: 'Terms of use',
  termsAndConditions: 'Terms and Conditions',
  spec: 'Spec',
  esiPatientLoginStep1: 'To login to your Lid Sync account, please enter your mobile phone number below.',
  esiPatientLoginStep2:
    'We have sent you a 6-Digit verification code. Enter it below to verify your account. This code will expire in: ',
  yourTrustIsImportantToUs: 'Your trust is important to us',

  toProceedYouNeedToAcceptTheFollowing: 'To proceed you need to accept the following',
  capsRequiredList: {
    '38mm': 'LS002 Caps Required',
    '42mm': 'LS001 Caps Required',
  },
  capsTitles: {
    '38': '38 mm Caps',
    '42': '42 mm Caps',
  },
  updateOrder: 'Update Order',
  updateCap: 'Update Device',
  registerCap: 'Register Cap',
  hardwareIdUpdatedSuccessfully: 'Hardware ID updated successfully',
  registerYourSmartCap: 'Register your Smart Cap',
  activateYourDeviceTitle: 'Activate Your Device',
  changeYourDeviceTitle: 'Change your cap',
  activateYourDevice:
    'Activate your device by SMS. Your unique 6 digit activation code can be found printed on the label attached to your device. Text the code to:',
  changeYourDevice:
    'Update your device by SMS. Your unique 6 digit activation code can be found printed on the label attached to your device. Text the code to:',
  setYourTimezone: 'Set your Timezone',
  setTimezoneInst:
    'Finally, select your timezone so we can make sure your medications schedules are correct for you. You can change this in the future via settings.',
  smartCapInst:
    'Find the 6 digit Cap ID printed on the top of your cap’s packaging (and the back of the instruction booklet), and enter the number below to register it.',
  findTheSmartCapID:
    'Find the Smart Cap ID printed on the outside of your cap’s packaging, and enter the number below to register it.',
  packageTrackingID: 'Package Tracking ID',
  trackingStatus: 'Tracking Status',
  fieldIsRequired: 'Field is required',
  fieldIsBelowZero: 'The field must be greater than zero',
  valueMustBeLessThan: 'Value must be less than {0}',
  orderStatuses: {
    created: 'Created',
    inTransit: 'In transit',
    shipped: 'Shipped',
    delivered: 'Delivered',
  },
  orderID: 'Order ID',
  orderDate: 'Order Date',
  trackingID: 'Tracking ID',
  capsRequired: 'Caps Required',
  twoFAFormCodeText: 'The one password code was sent to your mobile phone. This code will expire in: ',
  editSchedule: 'Edit schedule',
  editStock: 'Edit Pills in Hand',
  myDetails: 'My Details',
  myAddress: 'My Address',
  address: 'Address',
  outreachPhoneNumber: 'Outreach Phone No.',
  myMedications: 'My Medications',
  editAddress: 'Edit Address',
  apartmentSuiteOptional: 'Apartment/Suite (optional)',
  streetAddress: 'Street Address',
  streetAddressLine2: 'Street Address Line 2',
  editDetails: 'Edit Details',
  scheduledRemindersAreTurningOff:
    'This action is not recommended and will stop you all reminders for all of your currently active meds.',
  scheduledRemindersAreTurningOn: 'You are going to receive all reminders for all of your currently active meds.',
  medicationReminders: 'Medication Reminders',
  receiveWeeklyReports: 'Receive weekly reports',
  addressUpdatedSuccessfully: 'Address Updated Successfully',
  codeHasBeenResent: 'Code has been resent. It will expire in: ',
  profileUpdated: 'Profile Updated',
  selectTimezone: 'Select Timezone',
  history: 'History',
  stateHistory: 'State History',
  timeTaken: 'Time Taken',
  scheduledDate: 'Scheduled Date',
  downloadLast24Months: 'Download Last 24 Months',
  downloadFilteredHistory: 'Download Filtered History',
  exportFormat: 'Export Format',
  addFilter: 'Add Filter',
  noFilter: 'No Filter',
  refresh: 'Refresh',
  imei: 'IMEI',
  deviceImei: 'Device IMEI',
  capShortName: 'Cap Short Name',
  lastActivity: 'Last Activity',
  lastReading: 'Last Reading',
  pairingStatus: 'Pairing Status',
  pairingTime: 'Pairing Time',
  updated_at: 'Updated At',
  reminders: 'Reminders',
  reminder: 'Reminder',
  showReminders: 'Show Reminders',
  factoryMode: 'Factory mode',
  factory: 'Factory',
  customerMode: 'Customer mode',
  customer: 'Customer',
  sleepMode: 'Sleep mode',
  pairingMode: 'Pairing mode',
  on: 'On',
  off: 'Off',
  fota: 'FOTA',
  pins: 'Pins',
  readings: 'Readings',
  signalStrength: 'Signal strength',
  signal: 'Signal',
  activity: 'Activity',
  activityType: 'Activity type',
  value: 'Value',
  qrCode: 'QR Code',
  faults: 'Faults',
  passwordInfo:
    'Your password should be at least 8 characters long and must have 1 number, 1 symbol (~!*^@#$%&), 1 upper case and 1 lower case character.',
  AGN: 'AGN',
  enrollmentDate: 'Enrollment Date',
  activationStartEnd: 'Activation Start/End',
  registeredDate: 'Registered Date',
  lastKnownBattery: 'Last known battery',
  lastKnownTemperature: 'Last known temperature',
  lastKnownSignalStrength: 'Last known signal strength',
  lowSignal: 'Low Signal',
  moderateSignal: 'Moderate Signal',
  highSignal: 'High Signal',
  locationOfDevices: 'Location of Devices',
  mapTooltipText: 'Need text for this...',
  lastKnownLocation: 'Last known location',
  valueHwCode: 'Value (HW Code)',
  current: 'Current',
  remove: 'Remove',
  dosesRemaining: 'Pills Remaining',
  thisWillLastUntil: 'This Will Last Until',
  great: 'Great ',
  youAreAllDone: 'You’re All Done',
  requestDownloadData: 'You have requested to download your data. ',
  pleasePressTheButton: 'Please press the button on the right and save the file on your hard drive.',
  scheduled: 'Scheduled',
  allTimes: 'All Times',
  allMedications: 'All Medications',
  statusAll: 'Status - All',
  statusMissed: 'Status - Missed',
  statusUpcoming: 'Status - Upcoming',
  statusTaken: 'Status - Taken',
  readyOnly: 'Read only',
  readAndWrite: 'Read & Write',
  enterPhoneNumber: 'Enter phone number',
  learnMoreAboutInfo:
    'Learn more about this medication, including instructions for use, side effect, drug interactions, precautions and storage. Powered by ',
  medicationC: 'Medication©',
  day: ' Day',
  daysStreak: ' Streak',
  errorEnterCapId: 'Enter Cap Id',
  errorEnterDeviceId: 'Enter Device Id',
  errorPaitentMedication: 'Error while saving patient medication data',
  errorSavingPatient: 'Error while saving patient data',
  allDays: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'],
  orderUpdatedSuccessfully: 'Order updated successfully',
  downloadCalendar: 'Download Calendar',
  download: 'Download',
  downloadCsv: 'Download CSV',
  downloadXlsx: 'Download Excel',
  openInNewWindow: 'Open',
  left: 'left',
  yourSuccessPreviousMonth: 'Your accuracy previous Month',
  yourSuccessMonthly: 'Your accuracy this Month',
  yourSuccessWeekly: 'Your accuracy this Week',
  good: 'Good',
  average: 'Average',
  bad: 'Bad',
  getTheApp: 'Get the App',
  tutorialTexts: {
    skipBtn: 'Skip',
    dashTitle: 'Dashboard',
    dashboardInfo:
      'The dashboard provides a quick summary of how well you are sticking to your schedule, upcoming reminders, active medications and stock alerts.',
    medicationsTitle: 'Medications',
    medicationsInfo:
      'Here you can view and edit your active and inactive medications, see your schedules and quickly discover many meds you have missed or taken.',
    calendarTitle: 'Calendar',
    calendarInfo:
      'The calender is the fastest way to see all the meds you have due on any given day, and to see what days you have scheduled throughout the entire month.',
    historyTitle: 'History',
    historyInfo:
      'If you need to confirm if you took or missed a medication on an previous day, or review or download any period of time head to History. ',
    settingsTitle: 'Settings',
    settignsInfo:
      'Settings lets you review (and edit some) of your personal details, and allows you to change your language or timezone,  and toggle reminders.',
    supportTitle: 'Support',
    supportInfo:
      'If you need any technical assistance with your cap, or the app or website, we are here to help via chat support, help center, or email or phone.',
  },
  adminDashboard: {
    numberOfParticipants: 'Participants',
    numberOfActivatedCaps: 'Activated Caps',
    missed2ConsecutiveDoses: 'Missed 2 consecutive doses',
    missed5ConsecutiveDoses: 'Missed 5 consecutive doses',
    medicationTaken: 'Taken',
    medicationMissed: 'Missed',
    top5LocationByEvents: 'Top 5 Locations (by Events)',
    evolutionOfCapActivations: 'Evolution of Cap Activations',
    adherenceStats: 'Adherence Statistics',
  },
  organization: 'Organization',
  organizationSelected: '{0} organization selected',
  reason: 'Reason',
  users: 'Users',
  organizations: 'Organizations',
  organizationsSelected: '{0} organizations selected',
  selectOrganizations: 'Select organizations',
  organizationGroup: 'Organization Group',
  editOrganizationGroup: 'Edit Organization Group',
  createOrganizationGroup: 'Create Organization Group',
  userAddedToOrgGroup: 'User {0} added to organization group',
  maintainers: 'Maintainers',
  cantDeleteOrgFromGroup: 'Organization can\'t be deleted, because there are users or maintainers associated with this organization. Please remove them first.',
  cantDeleteMaintainerUser: 'This user can\'t be deleted, because he is maintainer of this organization group. Please remove him from maintainers list first.',
  youDontHaveRightsToEditGroup: 'You don\'t have rights to edit this group',
  youDontHaveRightsToDeleteGroup: 'You don\'t have rights to delete this group',
  provisioning: 'Provisioning',
  testDevice: 'Test Device',
  apiURL: 'API URL',
  fotaURL: 'FOTA URL',
  features: 'Features',
  deviceManagement: 'Devices',
  bluetooth: 'BLE Smart Cap',
  weightScales: 'Weight Scales',
  wristBand: 'Wrist Band',
  glucometer: 'Glucometer',
  spirometer: 'Spirometer',
  inhaler: 'Inhaler',
  sleepReport: 'Sleep report',
  sleepDuration: 'Sleep duration',
  exerciseDetails: 'Exercise details',
  heartRate: 'Heart rate',
  airQuality: 'Air Quality',
  movementReport: 'Movement report',
  stepsLowerCase: 'steps',
  steps: 'Steps',
  inhalations: 'Inhalations',
  lte: 'Pillbox LTE',
  lsc: 'LTE Smart Cap',
  injectableTracker: 'Injectable Medication Tracker',
  mdp: 'Smart MDP Dispenser',
  lmo: 'LTE Medication Organizer',
  bloodPressureMonitor: 'Blood Pressure Monitor',
  hub: 'Datahub',
  otherDevices: 'Other devices',
  report: 'Report',
  businessReport: 'Business Report',
  addOrganization: 'Add Organization',
  editOrganization: 'Edit Organization',
  enterOrganizationName: 'Enter organization name',
  careProviderForOrganizations: 'Care Provider For',
  organizationManagers: 'Org Mgr',
  organizationContact: 'Organization Contact',
  pharmacistInCharge: 'Pharmacist in charge',
  pharmacyIds: 'Pharmacy Ids',
  buildInformation: 'Build Information',
  organizationGroups: 'Org Groups',
  templates: 'Templates',
  owner: 'Owner',
  createTemplate: 'Create Template',
  templateSource: 'Template source',
  createEmptyTemplate: 'Create empty template',
  createTemplateFromOrganization: 'Create from existing organization',
  addOrganizationGroup: 'Add Organization Group',
  addRemoveOrganizations: 'Add / Remove Organizations',
  addRemoveMaintainers: 'Add / Remove Maintainers',
  noOrganizationsFound: 'No organizations found',
  noMaintainersFound: 'No maintainers found',
  noUsersFound: 'No users found',
  capManagers: 'Cap Mgr',
  configuration: 'Configuration',
  saveConfigAsTemplate: 'Save Configuration as Template',
  saveConfigAsTemplateTitle: 'Save configuration as template',
  templateNamePlaceholder: 'Template name',
  templateNameRequired: 'Template name is required',
  templateNameDuplicateWarning: 'A template with this name already exists. Click "Save Anyway" to override existing template.',
  saveTemplate: 'Save Template',
  saveTemplateConfirm: 'Save Anyway',
  templateSaved: 'Template saved successfully',
  editTemplate: 'Edit Template',
  deleteTemplateWarning: 'Delete template',
  organizationType: 'Organization type',
  organizationTemplate: 'Organization template',
  createOrganizationFromTemplate: 'Create organization from template',
  createEmptyOrganization: 'Create empty organization',
  parentOrganization: 'Parent organization',
  addToOrganizationGroup: 'Add to organization group',
  dontAddToOrganizationGroup: "Don't add to organization group",
  noOrganizationGroupAccess: 'You cannot add this organization because you do not have access to any organization groups. Create a group or contact support.',
  noClientOrganizationAccess: 'You cannot add this organization because you do not have access to any client or partner organizations.',
  saveConfigAsTemplate: 'Save Configuration as Template',
  saveConfigAsTemplateTitle: 'Save configuration as template',
  templateNamePlaceholder: 'Template name',
  templateNameRequired: 'Template name is required',
  templateNameDuplicateWarning: 'A template with this name already exists. Click save again to confirm.',
  saveTemplate: 'Save Template',
  saveTemplateConfirm: 'Save Anyway',
  templateSaved: 'Template saved successfully',
  deleteTemplateWarning: 'Delete template',
  organizationType: 'Organization type',
  organizationTemplate: 'Organization template',
  useTemplate: 'Use template',
  createEmptyOrganization: 'Create empty organization',
  parentOrganization: 'Parent organization',
  addToOrganizationGroup: 'Add to organization group',
  noOrganizationGroupAccess: 'You cannot add this organization because you do not have access to any organization groups. Create a group or contact support.',
  noClientOrganizationAccess: 'You cannot add this organization because you do not have access to any client or partner organizations.',
  dates: 'Dates',
  startImmediately: 'Start Immediately',
  date: 'Date',
  twoFAEnabled: '2FA',
  twoFAEnabledStatus: '2FA Enabled',
  twoFADisabledStatus: '2FA Disabled',
  capManager: 'Cap Manager',
  adminTab: 'Admin',
  admins: 'Admins',
  devicesTab: 'Devices',
  outboundAPITab: 'Outbound API',
  externalApiOauthTab: 'External API OAuth',
  externalApiAccessControlTab: 'External API Access Control',
  careProviderApiTab: 'Care Provider API',
  athenaConfigurationTab: 'Athena',
  accessClinicianRosterTab: 'ACCESS clinician roster',
  accessClinicianRosterCurrentRelease: 'Current roster release',
  accessClinicianRosterNotConfigured: 'No active clinician roster has been published for this organization.',
  accessClinicianRosterPublishNew: 'Publish new roster',
  accessClinicianRosterVersion: 'Roster version',
  accessClinicianRosterEffectiveFrom: 'Effective from',
  accessClinicianRosterSource: 'Source / verification note',
  accessClinicianRosterMembers: 'Clinicians',
  accessClinicianRosterNpi: 'NPI',
  accessClinicianRosterClinician: 'Clinician',
  accessClinicianRosterActive: 'Active on ACCESS roster',
  accessClinicianRosterMedicare: 'Medicare enrolled',
  accessClinicianRosterLoadFailed: 'Unable to load the ACCESS clinician roster.',
  accessClinicianRosterSaveFailed: 'Unable to publish the ACCESS clinician roster.',
  accessClinicianRosterPublished: 'ACCESS clinician roster published.',
  athenaReferringProviderMappings: 'Athena referring provider mappings',
  athenaReferringProviderMappingsHint: 'Map an external provider NPI to the athenaOne referring-provider ID for each practice. This ID is distinct from an athena provider ID.',
  athenaReferringProviderMappingNpi: 'External provider NPI',
  athenaReferringProviderId: 'Athena referring provider ID',
  athenaReferringProviderMappingInvalid: 'Enter a 10-digit NPI and positive Athena practice and referring provider IDs.',
  athenaReferringProviderMappingSaved: 'Athena referring provider mapping saved.',
  athenaClinicianProviderMappings: 'Athena clinician provider mappings',
  athenaClinicianProviderMappingsHint: 'Map each immutable ACCESS roster member to its athenaOne provider ID for each practice.',
  athenaRosterMemberId: 'ACCESS roster member ID',
  athenaSelectRosterMember: 'Select an ACCESS clinician',
  athenaRosterMemberNotCurrent: 'Member from an earlier roster',
  athenaSelectPractice: 'Select an Athena practice',
  athenaClinicianRosterNotConfigured: 'Publish an ACCESS clinician roster before creating this mapping.',
  athenaProviderId: 'Athena provider ID',
  athenaClinicianProviderMappingInvalid: 'Select an ACCESS clinician and Athena practice, then enter a positive Athena provider ID.',
  athenaClinicianProviderMappingSaved: 'Athena clinician provider mapping saved.',
  athenaClaimSubmissions: 'Athena claim submissions',
  athenaClaimSubmissionsLoadFailed: 'Unable to load Athena claim submissions',
  athenaClaimSubmissionDispositionId: 'Disposition ID',
  athenaClaimHistoryEvents: 'Submission events',
  athenaClaimHistoryObservations: 'Status observations',
  athenaClaimHistoryActor: 'Actor ID',
  athenaClaimHistoryMappingVersion: 'Status mapping version',
  athenaClaimHistoryOlder: 'Older history',
  athenaClaimSubmissionPatientId: 'Patient UUID',
  athenaClaimSubmissionGCode: 'G-code',
  athenaClaimSubmissionDos: 'DOS',
  athenaClaimSubmissionStatus: 'Status',
  athenaClaimSubmissionAthenaClaimId: 'Athena claim ID',
  athenaClaimSubmissionAttempts: 'Attempts',
  athenaClaimSubmissionError: 'Error',
  athenaClaimSubmissionExternalStatus: 'Athena status',
  athenaClaimSubmissionExternalStatusNote: 'Athena status note',
  athenaClaimSubmissionPollAttempts: 'Poll attempts',
  athenaClaimSubmissionPollError: 'Polling error',
  athenaClaimPollingPauseReason: 'Polling pause reason',
  athenaClaimPollingPausedAt: 'Polling paused at',
  athenaClaimPollingResume: 'Resume polling',
  athenaClaimPollingResumeWarning: 'Confirm you reviewed this uncertain charge in Athena. This resumes status reads for this submission only, for another 30 days. It does not resend the charge.',
  athenaClaimPollingResumed: 'Polling resumed. No charge was resent.',
  athenaClaimPollingResumeFailed: 'Could not resume Athena polling. Refresh the list and try again.',
  athenaClaimSubmissionTimestamps: 'Timestamps',
  athenaClaimSubmissionClaimedAt: 'Claimed at',
  athenaClaimSubmissionSubmittedAt: 'Submitted at',
  athenaClaimSubmissionLastPolledAt: 'Last polled at',
  athenaClaimSubmissionNextPollAt: 'Next poll at',
  athenaClaimSubmissionTerminalAt: 'Terminal at',

  // Superuser "Dev" section: CMS ACCESS simulator.
  devTab: 'Dev',
  accessSimulatorTab: 'ACCESS simulator',
  accessObligationsTab: 'ACCESS obligations',
  accessObligationsServerNow: 'Server time',
  accessObligationsNotPointedHint:
    'This organization is not pointed at the ACCESS simulator, so nothing here can be moved. Point it on the ACCESS simulator tab first.',
  accessObligationsNoEnrollments: 'This organization has no patients enrolled in an ACCESS program (CKM, eCKM, MSK or BH).',
  accessObligationsDaysAgo: 'days ago',
  accessObligationsDaysTooltip: 'How far in the past the target date lands. 0 = now.',
  accessObligationsDueAt: 'Due',
  accessObligationsInternalDueAt: 'Internal due',
  accessObligationsWindow: 'Window',
  accessObligationsFireAt: 'Submission opens',
  accessObligationsNextRecheck: 'Next re-check',
  accessObligationsCaution: 'Caution',
  accessObligationsTerminated: 'Terminated',
  accessObligationsMoved: 'Deadline moved.',
  accessObligationsRechecked: 'Re-check scheduled.',
  accessObligationsPrepared: 'End of period prepared.',
  athenaSimulatorTab: 'Athena simulator',
  athenaSimPointed: 'Athena credentials point at the simulator',
  athenaSimNotPointed: 'Athena credentials do not point at the simulator',
  athenaSimPointOrg: 'Point at simulator',
  athenaSimUnpointOrg: 'Unpoint',
  athenaSimUnpointOrgConfirm: 'Unpointing deletes this organization\'s configured Athena practices too (a practice cannot exist without credentials to query it with). Pointing again will need practices reconfigured. Continue?',
  athenaSimReset: 'Reset',
  athenaSimResetConfirm: 'Delete all simulated providers, patients, failure settings and the request log for this organization?',
  athenaSimAthenaBaseUrl: 'Athena base URL',
  athenaSimPractices: 'Configured practices',
  athenaSimPracticesTooltip: 'Athena practices enabled for this organization in its Athena configuration. Pointing at the simulator does not change them, but unpointing deletes them (a practice cannot exist without credentials).',
  athenaSimTokenFailure: 'Token endpoint answers',
  athenaSimApiFailure: 'API calls answer',
  athenaSimAnswerNormally: 'Normally',
  athenaSimNote: 'The simulator plays athenaOne for this organization, serving the providers and patients below per practice. Simulator API:',
  athenaSimProviders: 'Simulated providers',
  athenaSimPatients: 'Simulated patients',
  athenaSimRequestLog: 'Request log',
  athenaSimRefresh: 'Refresh',
  athenaSimAddProvider: 'Add provider',
  athenaSimEditProvider: 'Edit provider',
  athenaSimAddPatient: 'Add patient',
  athenaSimEditPatient: 'Edit patient',
  athenaSimAddSampleData: 'Add sample data',
  athenaSimAddSampleDataTooltip: 'Adds sample providers, a referring provider and patients with MBIs and problem lists to the practice (default: the first configured practice).',
  athenaSimSampleDataAdded: 'Sample data added.',
  athenaSimDeleteConfirm: 'Delete this simulated record?',
  athenaSimKind: 'Kind',
  athenaSimKindProvider: 'Provider',
  athenaSimKindReferring: 'Referring',
  athenaSimPractice: 'Practice',
  athenaSimAthenaId: 'Athena ID',
  athenaSimDepartment: 'Department',
  athenaSimNpi: 'NPI',
  athenaSimSpecialty: 'Specialty',
  athenaSimSpecialtyId: 'Specialty ID',
  athenaSimTaxonomy: 'Taxonomy code',
  athenaSimProviderType: 'Provider type',
  athenaSimPhone: 'Phone',
  athenaSimFax: 'Fax',
  athenaSimDirectAddress: 'Direct address',
  athenaSimAddress: 'Address',
  athenaSimAddress2: 'Address line 2',
  athenaSimCity: 'City',
  athenaSimState: 'State',
  athenaSimZip: 'ZIP',
  athenaSimCountry: 'Country',
  athenaSimEmail: 'Email',
  athenaSimMobilePhone: 'Mobile phone',
  athenaSimHomePhone: 'Home phone',
  athenaSimDob: 'Date of birth',
  athenaSimSex: 'Sex',
  athenaSimMbi: 'MBI',
  athenaSimPcp: 'PCP',
  athenaSimNoPcp: 'No PCP',
  athenaSimProblems: 'Problem list',
  athenaSimAddProblem: 'Add problem',
  athenaSimProblemName: 'Problem',
  athenaSimIcd10: 'ICD-10',
  athenaSimSnomed: 'SNOMED',
  athenaSimProblemStatus: 'Status',
  athenaSimProblemActive: 'Active',
  athenaSimProblemResolved: 'Resolved',
  athenaSimOnset: 'Onset',
  athenaSimResolved: 'Resolved on',
  athenaSimRemove: 'Remove',
  athenaSimExtra: 'Extra Athena fields (JSON)',
  athenaSimExtraTooltip: 'Merged verbatim into the Athena patient record, e.g. {"language6392code": "eng"}. An "insurances" array is added after the Medicare insurance built from the MBI.',
  athenaSimExtraInvalid: 'Extra fields must be a JSON object.',
  athenaSimPatientHint: 'A malformed MBI is kept as entered, so bulk upload validation can be tested.',
  athenaSimProviderHint: 'Providers are served as the practice providers (e.g. a patient PCP); referring providers by the referring-provider search.',
  athenaSimTime: 'Time',
  athenaSimRequest: 'Request',
  athenaSimHttpStatus: 'Status',
  athenaSimResponseBody: 'Response',
  nppesSimulatorTab: 'NPPES simulator',
  nppesSimPointed: 'NPPES calls are routed to the simulator',
  nppesSimNotPointed: 'NPPES calls are not routed to the simulator',
  nppesSimPointOrg: 'Point at simulator',
  nppesSimUnpointOrg: 'Unpoint',
  nppesSimPointOrgConfirm: 'Route the provider-directory NPPES calls of "{0}" to the simulator? Its users will see simulated providers, Direct addresses and fax numbers in provider search and PCP resolution instead of the real NPI Registry. Point only test organizations. Continue?',
  nppesSimUnpointOrgConfirm: 'Unpointing sends this organization\'s provider-directory calls back to the real NPI Registry (or the configured default). The simulated registry itself is shared and stays as it is. Continue?',
  nppesSimReset: 'Reset',
  nppesSimResetConfirm: 'Delete all simulated providers, the failure setting and the request log? Organizations stay pointed at the simulator.',
  nppesSimBaseUrl: 'NPPES base URL',
  nppesSimKey: 'Simulator key',
  nppesSimKeyTooltip: 'The global key every call to the simulated registry must present in the X-Nppes-Sim-Key header (env NPPES_SIMULATOR_KEY). The only divergence from the real registry, which is public and unauthenticated.',
  nppesSimKeyConfigured: 'Configured',
  nppesSimKeyMissing: 'Not configured on this server',
  nppesSimKeyMissingTooltip: 'Pointing needs the NPPES_SIMULATOR_KEY environment variable on the server.',
  nppesSimApiFailure: 'API calls answer',
  nppesSimAnswerNormally: 'Normally',
  nppesSimNote: 'The simulator plays the public NPI Registry for every organization pointed at it, serving the global provider set below. Pointing is per organization, the registry is shared. Simulator API:',
  nppesSimProviders: 'Simulated providers',
  nppesSimRequestLog: 'Request log',
  nppesSimRefresh: 'Refresh',
  nppesSimAddProvider: 'Add provider',
  nppesSimEditProvider: 'Edit provider',
  nppesSimAddSampleData: 'Add sample data',
  nppesSimAddSampleDataTooltip: 'Adds a fixed sample registry: the three providers matching the Athena simulator (same NPIs, so PCP resolution lines up), a deactivated record, one without Direct or fax, one with several taxonomies/locations/faxes and an organization record. Existing NPIs are kept.',
  nppesSimSampleDataAdded: 'Sample data added.',
  nppesSimDeleteConfirm: 'Delete this simulated record?',
  nppesSimNpi: 'NPI',
  nppesSimEnumerationType: 'Type',
  nppesSimEnumIndividual: 'Individual',
  nppesSimEnumOrganization: 'Organization',
  nppesSimStatus: 'Status',
  nppesSimStatusActive: 'Active',
  nppesSimStatusDeactivated: 'Deactivated',
  nppesSimFirstName: 'First name',
  nppesSimMiddleName: 'Middle name',
  nppesSimLastName: 'Last name',
  nppesSimNamePrefix: 'Prefix',
  nppesSimNameSuffix: 'Suffix',
  nppesSimCredential: 'Credential',
  nppesSimSex: 'Sex',
  nppesSimSexUnset: 'Unset',
  nppesSimOrganizationName: 'Organization name',
  nppesSimLastUpdated: 'Last updated',
  nppesSimTaxonomies: 'Taxonomies (JSON)',
  nppesSimAddresses: 'Addresses (JSON)',
  nppesSimPracticeLocations: 'Practice locations (JSON)',
  nppesSimEndpoints: 'Endpoints (JSON)',
  nppesSimJSONArrayInvalid: 'Each of these fields must be a JSON array.',
  nppesSimProviderHint: 'The JSON arrays are served verbatim by the simulated Read API, in the registry\'s own shape (taxonomies with code/desc/primary, addresses with address_purpose LOCATION first, endpoints with endpointType DIRECT for Direct messaging). The NPI checksum is not enforced, like the real registry.',
  nppesSimTime: 'Time',
  nppesSimRequest: 'Request',
  nppesSimHttpStatus: 'Status',
  nppesSimResponseBody: 'Response',
  accessSimNotEnabled: 'The ACCESS simulator dev routes are not enabled on this server.',
  accessSimPointed: 'Pointed at simulator',
  accessSimNotPointed: 'Not pointed at simulator',
  accessSimPointOrg: 'Point at simulator',
  accessSimUnpointOrg: 'Unpoint',
  accessSimReset: 'Reset',
  accessSimResetConfirm:
    'Delete all simulator patients, response scripts, submissions and communication log for this organization?',
  accessSimResetDone: 'Simulator state wiped.',
  accessSimEnvironment: 'Environment',
  accessSimConfigured: 'Configured',
  accessSimNotConfigured: 'Not configured',
  accessSimBaseUrl: 'Simulator API',
  accessSimOrg: 'Organization',
  accessSimOauthPolicy: 'OAuth policy',
  accessSimOauthPolicyLenient: 'Lenient (accept any credentials)',
  accessSimOauthPolicyStrict: 'Strict (validate credentials)',
  accessSimOauthOutage: 'OAuth outage (token endpoint fails)',
  accessSimMailbox: 'Mailbox',
  accessSimPatients: 'Simulated patients',
  accessSimAddPatient: 'Add patient',
  accessSimPatientId: 'ID',
  accessSimMbi: 'MBI',
  accessSimDisplayName: 'Display name',
  accessSimTrack: 'Track',
  accessSimStatus: 'Status',
  accessSimResponses: 'Responses',
  accessSimInherited: 'Defaults',
  accessSimOrgDefaults: 'Organization defaults',
  accessSimDefaultsHint: 'What the simulator answers for a patient without a per-patient override.',
  accessSimPatientScriptHint: 'Per-patient overrides win over the organization defaults.',
  accessSimMode: 'Mode',
  accessSimResultCode: 'Result code',
  accessSimResultDisplay: 'Result display',
  accessSimPoll202: '202s before answer',
  accessSimTimesRemaining: 'Times remaining',
  accessSimHttpStatus: 'HTTP status',
  accessSimErrorBody: 'Error body',
  accessSimFailAt: 'Fail at',
  accessSimModeResult: 'Return a result code',
  accessSimModeHttpError: 'Return an HTTP error',
  accessSimModeStillProcessing: 'Never finish (always 202)',
  accessSimModeNoRecord: 'No such patient (404)',
  accessSimUseDefault: 'Use organization default',
  accessSimClearOverride: 'Clear override',
  accessSimOverrideSet: 'Override',
  accessSimNoCommLog: 'No API calls recorded for this patient yet.',
  accessSimSubmissionId: 'Submission',
  accessSimSendUnalignmentEmail: 'Inject unalignment email',
  accessSimSendUnalignmentEmailDone: 'Unalignment email injected.',
  accessSimSendUnalignmentEmailNeedsPatient: 'Select a patient to inject an unalignment email for.',
  accessSimDeletePatientConfirm: 'Delete this simulated patient and everything scripted for it?',
  accessSimPartialSave: 'Saved, but these operations failed:',
  accessSimGenerateMbi: 'Generate random MBI',
  accessSimOrgPatient: 'Prefill from an existing patient',
  accessSimNoOrgPatients: 'No existing patient with an MBI in this organization.',
  accessSimKindFilter: 'Kind',
  accessSimAllKinds: 'All kinds',
  accessSimCopyAsJson: 'Copy as JSON',
  accessSimExpandBody: 'Show full body',
  accessSimCollapseBody: 'Hide full body',
  accessSimNoSubmission: 'No submission (OAuth / email)',
  accessSimCloudTimeNote:
    'In the cloud environment the simulator clock cannot be fast-forwarded: time-dependent behavior (202s, deadline windows, monthly G-code candidates) only advances with real time. Use a local/dev environment to control the clock.',
  accessSimPoll202Tooltip:
    'How many times the simulator answers 202 (still processing) before returning the final result.',
  accessSimFailAtTooltip:
    'Which phase of the operation should fail: accept (the initial call) or poll (a subsequent poll).',
  accessSimOauthPolicyTooltip:
    'Lenient: token errors are tolerated; Strict: token errors fail the operation. Token outage makes the token endpoint fail (a full auth outage).',
  accessSimBaseUrlTooltip:
    'The ACCESS simulator of this environment. A pointed organization stores no URL: its calls always go to the simulator of the environment it runs in.',
  accessSimMailboxTooltip:
    'Where injected emails (e.g. unalignment notices) appear.',
  accessSimStatusTooltip:
    'new: just created; in_flight: a submission is being processed; done: finished; parked: left mid-flight on purpose.',
  accessSimTrackTooltip: 'The CMS ACCESS track the patient is enrolled in: CKM, eCKM, MSK or BH.',
  athenaBaseUrl: 'Athena Base URL',
  athenaClientId: 'Client ID',
  athenaClientSecret: 'Client Secret',
  athenaScope: 'OAuth Scope',
  athenaPractices: 'Athena Practices',
  addAthenaPractice: 'Add Athena Practice',
  editAthenaPractice: 'Edit Athena Practice',
  athenaPracticeId: 'Practice ID',
  athenaPracticeDisplayName: 'Display Name',
  athenaPracticeEnabled: 'Enabled',
  athenaCredentialsSaved: 'Athena credentials saved',
  athenaPracticeSaved: 'Athena practice saved',
  athenaPracticeDisabled: 'Athena practice disabled',
  athenaPracticeIdInvalid: 'Practice ID must be a positive integer',
  athenaConfigurationSaveFailed: 'Unable to save Athena configuration',
  athenaConfigurationLoadFailed: 'Unable to load Athena configuration',
  samlConfigurationTab: 'SAML',
  externalApiLogsTab: 'External API Logs',
  externalApiEnabled: 'External API Enabled',
  samlMetadataUrl: 'IdP Metadata URL',
  samlMetadataUrlPlaceholder: 'https://example.com/saml/metadata',
  samlAllowIdpInitiated: 'Allow IdP Initiated',
  samlSignAuthnRequests: 'Sign Authn Requests',
  samlSpMetadataUrl: 'SP Metadata URL',
  samlSpEntityId: 'SP Entity ID',
  samlSpAcsUrl: 'SP ACS URL',
  samlNotConfiguredForOrganization: 'No SAML provider is configured for this organization yet.',
  samlMetadataUrlRequired: 'IdP Metadata URL is required',
  showAllPatients: 'Show All Patients (regardless of consent)',
  masterLog: 'Master Log',
  addOrganizationManager: 'Add Organization Manager',
  editOrganizationManager: 'Edit Organization Manager',
  active: 'Active',
  inactive: 'Inactive',
  online: 'Online',
  offline: 'Offline',
  blocked: 'Blocked',
  suspended: 'Suspended',
  unassigned: 'Unassigned',
  manufactured: 'Manufactured',
  manufacturer: 'Manufacturer',
  deleted: 'Deleted',
  urls: 'URLs',
  key: 'Key',
  dateOfCreation: 'Date of Creation (Days)',
  addOutboundAPI: 'Add Outbound API',
  editOutboundAPI: 'Edit Outbound API',
  secretKey: 'Secret Key',
  host: 'Host',
  url: 'URL',
  ip: 'IP',
  activeSessions: 'Active Sessions',
  signedInOn: 'Signed in on',
  timestamp: 'Timestamp',
  authenticationLog: 'Authentication Log',
  device: 'Device',
  capActivityDetails: 'Cap Activity Details',
  hubActivityDetails: 'Hub Activity Details',
  selectOrganization: 'Select',
  deviceId: 'Device ID',
  deviceName: 'Device Name',
  systolicPressure: 'Systolic Pressure',
  diastolicPressure: 'Diastolic Pressure',
  meanArterialPressure: 'Mean Arterial Pressure',
  deviceType: 'Device Type',
  deviceModel: `Device Model`,
  weight: 'Weight',
  glucose: 'Glucose',
  glucoseConcentration: 'Glucose concentration',
  sampleLocation: 'Sample location',
  pulse: 'Pulse',
  saturation: 'Saturation',
  oxygenSaturation: 'Oxygen Saturation',
  viewDetails: 'View details',
  hubDetails: 'Hub Details',
  bloodPressure: 'Blood Pressure',
  weeklyAvgBloodPressure: 'Weekly Avg. Blood Pressure',
  avgBloodPressure: 'Avg. Blood Pressure',
  heartRateAndBloodPressure: 'Heart Rate and Blood Pressure',
  schedules: {
    schedules: 'Schedules',
    scheduleName: 'Schedule Name',
    patient: 'Patient',
    scheduleType: 'Schedule Type',
    time: 'Time',
    accuracy: 'Accuracy',
    medication: 'Medication',
    startDate: 'Start Date',
    endDate: 'End Date',
    addCap: 'Add Cap',
    capId: 'Cap ID',
    capName: 'Cap Name',
    timeFor: 'Time From Last Take',
    lastActivityDate: 'Last Activity Date',
    lastActivityTime: 'Last Activity Time',
    battery: 'Battery',
    addName: 'Add Name',
    enterName: 'Enter name',
    search: 'Search',
    title1: 'Add Schedule to:',
    title2: 'Select Medication',
    title3: 'Set Schedule',
    title4: 'Dates',
    title5: 'Review',
    enableEndDate: 'Enable End Date',
    disableEndDate: 'Disable End Date',
    errorScheduleName: 'Please enter schedule name',
    errorMedicationName: 'Please select medication name',
    errorSelectTime: 'Please select time',
    errorSelectTimezone: 'Please select timezone',
    errorSelectStartDate: 'Please select start date',
    timezone: 'Timezone',
  },
  bpMonitor: 'BP Monitor',
  scale: 'Scale',
  ble: 'Bluetooth',
  billing: {
    billing: 'Billing',
    reportDateRangeTooltip:
      'The date range includes billing claims that overlap the selected period. A claim may start before or end after these dates.',
    lte: 'LTE',
    ble: 'Bluetooth',
    hub: 'HUB',
    ID: 'ID',
    nickname: 'Nickname',
    costMonth: 'Cost / month',
    added: 'Added',
    device: 'Type',
    tasks: 'Tasks',
    deviceEvents: 'Device Events',
  },
  capPatient: {
    endEnrollmentWhen: 'End enrollment',
    enrollmentEnded: 'Enrollment ended for {0}',

    watchedBy: 'Watched by',
    dob: 'D.O.B',
    patientName: 'Patient Name',
    enterPatientName: 'Enter Patient Name',
    enterFirstName: 'Enter Firstname',
    enterLastName: 'Enter Lastname',
    enrollment: 'Enrollment',
    organType: 'Organ Type',
    downloadPatientData: 'Download Patient Data',
    downloadNotesAndActions: 'Download Notes and Actions',
    downloadProgramAnalytics: 'Download Program Analytics',
    mobileNumber: 'Mobile Number',
    phoneNumber: 'Phone Number',
    email: 'Email',
    address: 'Address',
    addressFromImport: 'Address from import',
    insurance: 'Insurance',
    insuranceName: 'Insurance Name',
    enterInsuranceName: 'Enter Insurance Name',
    policyId: 'Policy ID',
    enterPolicyId: 'Enter Policy ID',
    groupNumber: 'Group Number',
    enterGroupNumber: 'Enter Group Number',
    payerId: 'Payer ID',
    enterPayerId: 'Enter Payer ID',
    insuranceAndBillingNotes: 'Insurance and Billing Notes',
    centerDetails: 'Center Details',
    providerCenterDetails: 'Provider/Center Details',
    centerPracticeName: 'Center/Practice Name',
    enterCenterPracticeName: 'Enter Center/Practice Name',
    orderingProvider: 'Provider',
    enterOrderingProvider: 'Enter Provider',
    clinicContact: 'Clinic Phone Number',
    enterClinicContact: 'Enter Clinic Phone Number',
    medicalHistory: 'Medical History',
    primaryCondition: 'Primary Condition',
    enterPrimaryCondition: 'Enter Primary Condition',
    secondaryCondition: 'Secondary Condition',
    enterSecondaryCondition: 'Enter Secondary Condition',
    noConditionsSelected: 'No conditions selected',
    conditionAssignedToActiveEnrollment: 'This condition is assigned to an active enrollment and cannot be removed.',
    unknownConditionCannotBeAssignedToEnrollment: 'Unknown condition cannot be assigned to enrollment.',
    addMedicalHistory: 'Add Medical History',
    transplantDetails: 'Transplant Details',
    transplantOrganType: 'Transplant Organ Type',
    enterTransplantOrganType: 'Enter Transplant Organ Type',
    task: 'Task',
    addOrgan: 'Add Organ',
    transplantDate: 'Transplant Date',
    taskName: 'Task Name',
    notes: 'Notes',
    notesFromPharmacyProvider: 'Notes from pharmacy/provider',
    status: 'Status',
    taskTime: 'Task Time',
    duration: 'Duration',
    durationMinutes: 'Minutes',
    durationSeconds: 'Seconds',
    startTime: 'Start Time',
    endTime: 'End Time',
    deviceId: 'Device ID',
    deviceName: 'Device Name',
    deviceType: 'Device Type',
    registeredDate: 'Registered Date',
    activationDate: 'Activation Date',
    battery: 'Battery',
    startDate: 'Start Date',
    endDate: 'End Date',
    dose: 'Dose',
    logTime: 'Log Time',
    viewHistory: 'View History',
    loggedThisMonth: 'Logged this month',
    goal: 'Goal',
    goalThisMonth: 'Goal this month',
    startTimer: 'Start Timer',
    stopTimer: 'Stop Timer',
    patientId: 'Patient ID',
    mrn: 'MRN',
    athenaPatientId: 'Athena Patient ID',
    practiceId: 'Practice ID',
    medicareBeneficiaryId: 'Medicare Beneficiary ID (MBI)',
    patientDetails: 'Patient Details',
    summary: 'Summary',
    dateOfBirth: 'Date of birth',
    firstName: 'Firstname',
    lastName: 'Lastname',
    errorReadingFile: 'Error while reading file',
    errorInvalidFile: 'Invalid file selected, valid file format:',
    errorPatientName: 'Please enter patient name',
    errorFirstName: 'Please enter first name',
    errorLastName: 'Please enter last name',
    errorDOB: 'Please select date of birth',
    errorTextPhoneNumber: 'Please enter text phone number',
    errorPrimaryPhoneNumber: 'Please enter primary phone number',
    errorEmail: 'Please enter email',
    errorTimezone: 'Please select Timezone',
    errorAddress: 'Please enter address',
    errorInsuranceName: 'Please enter insurance name',
    errorPolicyId: 'Please enter policy id',
    errorGroupNumber: 'Please enter group number',
    errorCenterName: 'Please enter center name',
    errorFacility: 'Please select Facility',
    errorProvider: 'Please enter provider',
    errorClinicContact: 'Please enter clinic phone number',
    errorPrimaryCondition: 'Please enter primary condition',
    errorSecondaryCondition: 'Please enter secondary condition',
    errorOrganType: 'Please enter organ type',
    errorTransplantDate: 'Please enter transplant date',
    addInsurance: 'Add Insurance',
    addCenterDetails: 'Add Center Details',
    month: 'Month',
    months: 'Months',
    numberOfTask: 'Number of Tasks',
    numberOfDays: 'Days with event',
    tcClaims: 'TC Claims',
    date: 'Date',
    dateOfService: 'Date of Service',
    reviewerName: 'Reviewer Name',
    type: 'Type',
    note: 'Note',
    tcId: 'TC ID',
    billableDate: 'Billable Date:',
    billableTime: 'Billable time',
    updateTask: 'Update Task',
    addTask: 'Add Task',
    addTaskDisabledTooltip: 'Available once the patient has an active enrolled program',
    allTasks: 'All tasks',
    allPrograms: 'All programs',
    allDoctors: 'All doctors',
    filteredTasks: 'Tasks ({0})',
    filteredPrograms: 'Programs ({0})',
    filteredDoctors: 'Doctors ({0})',
    filterOptionsLoadFailed: 'Could not load the task history filters',
    totalTime: 'Total time',
    cptCodes: 'CPT Codes',
    cptCode: 'CPT Code',
    diagnosticsCode: 'Diagnostics code',
    data: 'Data',
    defaultTimeZone: 'America/New_York',
    cycleStartDate: 'Start date',
    cycleEndDate: 'End date',
    fileWithXRecords: '{0} with {1} records(s)',
    errorRequiredFields: 'Required fields missing',
    errorFile: 'Unable to read file ',
    errorFiles: 'File errors encountered',
    missingFieldFormat: 'Field missing: {0}',
    incorrectFieldFormat: 'Incorrect format',
    wrongFieldLengthFormat: 'Field too long. Maximum length is {0}',
    incorrectFieldValue: 'Incorrect value: {0}',
    missingTransplantDetails: 'No transplant details',
    missingInsurance: 'No insurance',
    missingCenterDetails: 'No center details',
    missingMedicalHistory: 'No medical history',
    invalidRecords: 'invalid records(s)',
    patientNotAdded: 'patient(s) not added',
    uploadSucceeded: 'Upload succeeded',
    patientAlreadyExists: 'Patient already exists',
    readyForUpload: 'Ready for upload',
    noNewPatients: 'No patients found to be assigned to cohort.',
    patientStatusInCohort: {
      assigned: 'Already in cohort',
      toAssign: 'Will be assigned to cohort',
      toRemove: 'Will be removed from cohort',
      nothingToDo: '-',
      successAdd: 'Sucessfully added to cohort',
      successRemove: 'Sucessfully removed from cohort',
      error: 'Error',
    },
    assignCohort: 'Assign Cohort',
    unassignFromCohort: 'Unassign from Cohort',
    patientStatus: {
      enrolled: 'Enrolled',
      onboarded: 'Onboarded',
      verified: 'Registered',
      activated: 'Activated',
      ended: 'Disenrolled',
      notEnrolled: 'Not Enrolled',
    },
    notEnrolledReason: {
      didNotRespond: 'Did not respond',
      declined: 'Declined',
      ineligible: 'Ineligible',
    },
    disenrolledReason: {
      patientRequested: 'Patient requested',
      nonCompliant: 'Non-compliant',
      lostContact: 'Lost contact',
      deceased: 'Deceased',
      other: 'Other',
    },
    terminatedReason: {
      clinicalGoalsAchieved: 'Clinical Goals Achieved',
      noLongerRequiresMonitoring: 'No Longer Requires Monitoring',
      duplicateEnrollmentIdentified: 'Duplicate Enrollment Identified',
      enrolledInAnotherRPMProgram: 'Enrolled in Another RPM Program',
      lossOfCoverageInsuranceChange: 'Insurance Change',
      movedOutOfServiceAreaTransferredCare: 'Transferred Care',
      noContactWithPatient: 'No Contact with Patient',
      noLongerMeetsEligibilityCriteria: 'No Longer Meets Eligibility Criteria',
      nonAdherentToMonitoringRequirements: 'Non-Adherent to Monitoring Requirements',
      patientRequestedDisenrollment: 'Patient Requested Disenrollment',
      patientDeceased: 'Patient Deceased',
      other: 'Other',
      nonCompliant: 'Non-Compliant',
      patientDeleted: 'Patient Account Deleted',
      patientAccountDeleted: 'Patient Account Deleted',
    },
    onboardedDate: 'Onboarded Date',
    enrolledDate: 'Enrolled Date',
    activatedDate: 'Activated Date',
    disenrolledDate: 'Disenrolled Date',
    notEnrolledDate: 'Not Enrolled Date',
    numberOfEnrollmentsInState: 'Number of enrollments in {0} state',
    enrollFlowStages: {
      onboarding: 'Onboarding',
      registration: 'Registering',
      enrolling: 'Enrolling',
      activating: 'Activating',
    },
    youDontHaveRightsToEnroll: 'You don\'t have rights to enroll patients',
    youDontHaveRightsToActivate: 'You don\'t have rights to activate patients',
    cantAssignKitToPatientWithShipment: 'Cannot assign kit to patient with shipment in progress',
    noMedicationSchedule: 'No medication schedule',
    noMedicationScheduleTooltip: 'No medication schedule is linked to this enrollment, so its adherence can\'t be measured.',
    noMedicationScheduleFilterTooltip: 'RTM/CTAM enrollments whose kit has a medication device but no medication schedule.',
    noMedicationScheduleWarning: 'No medication schedule is linked to the {1} enrollment of {0}. Without one, adherence for this enrollment can\'t be measured.',
    medicationNotLinkedWarning: 'This medication won\'t be linked to the {0} enrollment, which still has no medication schedule.',
    activateAnyway: 'Activate anyway',
    closeAnyway: 'Close anyway',
    saveAnyway: 'Save anyway',
    contactInformation: 'Contact Information',
    patientSaved: 'Patient Details for {0} have been saved',
    assignSmartCap: 'Assign Smart Cap',
    linkWithProgram: 'Link with Program',
    noProgram: 'No Program',
    enableWelcomeMessage: 'Enable Welcome Message',
    enableEndOfEnrollmentMessage: 'Enable End of Enrollment Message',
    selectProgramsToEnd: 'Select Programs to End',
    programsToEnd: 'Programs to End',
    scheduleTelevisit: 'Schedule Televisit',
    televisitScheduledDate: 'Televisit scheduled date',
    rescheduleTelevisit: 'Reschedule Televisit',
    scheduledTelevisits: 'Scheduled Televisits',
    televisitRescheduled: 'Televisit has been rescheduled',
    welcomeMessage: 'Welcome Message',
    welcomeMessageScheduledDate: 'Welcome Message scheduled date',
    welcomeMessageScheduledTime: 'Welcome Message scheduled time',
    welcomeMessageScheduledTimeAmPm: 'Welcome Message scheduled time AM/PM',
    sendWhenEnrollmentActivates: 'Send when enrollment activates',
    sendOnFirstEvent: 'Send on first event',
    endOfEnrollmentMessage: 'End of Enrollment Message',
    addConditionsFacilitiesCohorts:
      'Please setup your organization (add conditions, facilities and cohorts) before adding your first patient',
    patientAgreed: 'Patient agreed',
    patientNotAgreed: 'Patient not agreed',
    patientNotConsented: 'Patient not consented',
    patientConsentIsRequired: 'Patient consent is required',
    consentForNotifications: 'Consent for Notifications',
    provider: 'Provider',
    careProvider: 'Care Provider',
    careProviders: 'Care Providers',
    newPatient: 'New Patient',
    activateEnrollment: 'When to Activate Enrollment',
    enrollmentWillActivate: 'Enrollment will activate',
    enrollmentActivationModesEnum: {
      FirstEvent: 'On first event',
      OnDayAfterFirstEvent: 'On day after first event',
      Manual: 'Custom date',
    },
    enrollmentEndDateIsSet: 'Enrollment end date is set',
    enrollmentIsReadyToStart: 'Enrollment is ready to start',
    missedReadingReminder: 'Missed Reading Reminder',
    missedReadingsTreshold: 'Missed Readings Threshold',
    reminderEveryDays: 'Reminder every (days)',
    reminderEveryDaysHelp: 'Sent after {0} days since the last reading or reminder',
    missedReadingsMessage: 'Missed Readings Message',
    sendAlertNotificationTo: 'Send alert notification to',
    alertRecipientsTooltip: 'Caregivers can be configured in Info → Caregivers section.<br />Care Provider phone can be configured in Info → Center Details → Clinic Phone Number.',
    caregiversAndCareprovider: 'Caregivers and care provider',
    enableAlertNotification: 'Enable alert notification',
    noAlertsToShow: 'No alerts to show',
    reminderForMissedReadings: 'Reminder for {0}',
    reminderForMissedReadingsEnabled: 'Reminder for {0} missed readings enabled',
    xDays: '{0} days',
    selectDevice: 'Select Device',
    enrollmentIsCancelled: 'Enrollment is cancelled',
    engagementMessages: 'Engagement Messages',
    adherenceMilestonesMessages: 'Adherence Milestones Messages',
    adherenceMilestones: 'Adherence Milestones',
    alertTypes: {
      enrollment: 'Billing Alerts',
      vitals: 'Vitals Alerts',
      medications: 'Adherence Alerts',
      openActions: 'Open Actions',
    },
    enrollmentAlerts: {
      missing_mandatory_tasks: 'Missing mandatory tasks',
      missing_cpt: 'Missing CPT',
    },
    alertsTooltips: {
      enrollmentOn: 'Billing alerts - there are impediments to generating CPT codes',
      vitalsOn: 'Vitals alerts - patient has abnormal vitals readings',
      medicationsOn: 'Adherence alerts - patient has missed medication doses',
      openActionsOn: 'There are open actions for patient',
      enrollment: 'Billing alerts - there are no impediments to generating CPT codes',
      vitals: 'Vitals alerts - patients vitals readings are within normal range',
      medications: 'Adherence alerts - patient has no missed medication doses',
      openActions: 'There are no open actions for patient',
    },
    openActions: 'Open Actions',
    missingMandatoryTasksForBilling: 'Missing mandatory tasks for billing',
    selectPatientStatus: 'Select Patient Status',
    selectAtLeastOneEnrollmentToEndError: 'Please select at least one program to end',
    takeTimes: 'Take Times',
    manualSmsEnabled: 'Manual SMS enabled',
    manualSMS: 'Manual SMS',
    notificationsEnabled: 'Notifications enabled',
    notifications: 'Notifications',
    disabledWithExeptionOfManualSMS: 'Disabled (with exception of manual SMS)',
    notesAndActions: 'Notes & Actions',
    selectProgramToGetDefaultWelcomeMessage: 'Select program to get default welcome message',
  },
  fieldsRequired: 'fields required',
  messages: {
    archived: 'Archived',
    messages: 'Messages',
    new: 'New',
    inbox: 'Inbox',
    number: 'Number',
    name: 'Name',
    from: 'From',
    to: 'To',
    toFrom: 'To/From',
    conversation: 'Conversation',
    date: 'Date',
    time: 'Time',
    newMessage: 'New Message',
    displaySystemMessages: 'Display system messages',
    typeMessage: 'Type Message',
    archive: 'Archive',
    unarchive: 'Unarchive',
    read: 'Read',
    unread: 'Unread',
    markAs: 'Mark as',
    prefabReplies: 'Prefab Responses',
    prefabReply: 'Prefab Response',
    shortcut: 'Shortcut',
    author: 'Author',
    shared: 'Shared',
    private: 'Private',
    shareWithCollegues: 'Share prefab with colleagues',
    addToPrefabs: 'Add to prefab responses',
    addAsPrefab: 'Add reply as a prefab',
    addReply: 'Add Reply',
    createNewPrefab: 'Create new prefab response',
    editPrefab: 'Edit prefab response',
    recipients: 'Recipients',
    manualSmsDisabled: 'Sending text messages to this patient is disabled. You can enable it in patient info page.',
  },
  esi: {
    active: 'Active',
    pending: 'Pending',
    termed: 'Termed',
    activatedDate: 'Activated Date',
    termedDate: 'Termed Date',
  },
  textDays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  settingPage: {
    details: 'Details',
  },
  timer: 'Timer:',
  alltime: 'All-time',
  selectTimezone: 'Please select timezone',
  patientInfo: 'Patient Info',
  frequecyType: {
    asNeeded: 'As Needed',
    everyday: 'Every day',
    specificDays: 'Specific days',
    interval: 'Interval',
    onceDaily: 'Every day',
    twiceDaily: 'Twice a day',
    threeTimesDaily: 'Three times a day',
    fourTimesDaily: 'Four times a day',
    fiveTimesDaily: 'Five times a day',
    sixTimesDaily: 'Six times a day',
    everyFourHours: 'Every 4 hours',
  },
  searchConversation: 'Search Conversation ',
  editCapManager: 'Edit Cap Manager',
  capManagerUpdated: 'Cap manager updated',
  activateYourDeviceBySMSText: `Activate your device by SMS. Your unique 6 digit activation code can be found printed on the label attached to  your device. Text the code to:`,
  pleaseEnterCodeAL: 'Please enter code ',
  charachterAL: ' character',
  selectMedicineAL: 'Please select medicine from list box',
  timepickerAL: 'Please select timezone from timepicker',
  medicationScreenAL: 'navigate to the medications screen',
  refreshDataAL: 'Refresh the data',
  navigateToScreenAL: {
    navigateTo: 'navigate to the',
    screen: 'screen',
  },
  refreshAL: 'Refresh the data',
  chooseStartDateAL: 'Choose start Date',
  chooseEndDateAL: 'Choose end Date',
  clear: 'Clear',
  unsupportedDevice: 'This device type is not fully supported yet. Please contact customer support.',
  rem: `REM`,
  deepSleep: 'Deep',
  lightSleep: 'Light',
  awake: 'Awake',
  opportunity: 'Opportunity',
  percentChange: '% Change',
  ended: 'Ended',
  length: 'Lenght',
  sleepAt: 'Sleep at',
  wakeUpAt: 'Wake-up at',
  selectedTimezone: ' selected timezone',
  billingStatus: {
    pending: 'Pending',
    submitted: 'Submitted',
    onhold: 'On-Hold',
  },
  reading: 'Reading',
  custom: 'Custom',
  calories: 'Calories',
  distance: 'Distance',
  exerciseTime: 'Exercise time',
  exerciseIntensity: 'Exercise intensity',
  restHR: 'Rest HR',
  alertsEnum: {
    bloodPressure: 'Blood Pressure Alerts',
    oxygenSaturation: 'Saturation Alerts',
    weight: 'Weight Alerts',
    glucose: 'Glucose Concentration Alerts',
    spirometry: 'Spirometry Alerts',
    temperature: 'Temperature Alerts',
    heartRate: 'Heart rate Alerts',
    pm25: 'PM 2.5 Alerts',
    coagulation: 'Coagulation Alerts',
  },
  unit: 'Unit',
  alertThreshold: 'Alert Threshold',
  alertThresholds: 'Alert Thresholds',
  goals: 'Goals',
  goal: 'Goal',
  lowWeight: 'Low Weight',
  highWeight: 'High Weight',
  lowSystolic: 'Low Systolic',
  highSystolic: 'High Systolic',
  lowDiastolic: 'Low Diastolic',
  highDiastolic: 'High Diastolic',
  lowGlucose: 'Low Glucose',
  highGlucose: 'High Glucose',
  lowFev1: 'Low FEV1',
  highFev1: 'High FEV1',
  lowFvc: 'Low FVC',
  highFvc: 'High FVC',
  change: 'Change',
  changeSinceLastReading: 'Change since last reading',
  latestReadings: 'Latest Readings',
  patientLog: 'Patient Log',
  time: 'Time',
  ampm: 'AM/PM',
  pulseOx: 'Pulse Ox',
  language: 'Language',
  new: 'New',
  documents: 'Documents',
  supportDocuments: {
    general: 'General documents',
    documentsLoadFailed: 'Unable to load support documents. Please try again.',
    foldersLoadFailed: 'Unable to load document folders. The saved selection has been preserved.',
    noFolders: 'No document folders are available. The saved selection has been preserved.',
    folderUnavailable: 'unavailable',
    currentFolderUnavailable: 'The saved folder is unavailable. Select an available folder to change it.',
    refreshFolders: 'Refresh folders',
    retry: 'Retry',
  },
  pulseMeasures: 'Pulse measures',
  stepsBy: 'Accumulated steps by',
  dropOr: 'Drag and drop file, or',
  fileUploadedSuccessfully: 'File uploaded successfully',
  manualUploadProcessInfo:
    'As this is a manual patient upload process, please communicate to the to the coordinator that data has been uploaded.',
  fileUploadFail: 'File upload failed',
  fileExceedMaximumSizeOf: 'File exceed maximum size of',
  documentsGeneralProblem: 'Problem with getting access to documents',
  rxcap: 'RxCap',
  rxcapRights: 'onwards. All Rights Reserved.',
  privacyPolicyText: 'Privacy Policy',
  termText: 'Terms & Conditions',
  and: 'and',
  dragFile: 'Drag and drop file, or',
  chooseFile: 'Choose File',
  readingDataFromFile: 'Reading data from file...',
  uploadingPatients: 'Uploading patients...',
  allFacilities: 'All Facilities',
  facility: 'Facility',
  providerFacility: 'Provider / Facility',
  addEditProvidersFacilities: 'Add / Edit Facilities',
  selectFacility: 'Select Facility',
  selectManager: 'Select Manager',
  selectCohort: 'Select Cohort',
  select: 'Select',
  noOptionSelected: 'No option selected',
  english: 'English',
  spanish: 'Spanish',
  languagesEnum: {
    en: 'English (UK)',
    'en-us': 'English (US)',
    es: 'Spanish',
    ar: 'Arabic',
    zh: 'Chinese',
    'yue': 'Chinese (Cantonese)',
    vi: 'Vietnamese',
    ko: 'Korean',
  },
  actions: 'Actions',
  addNote: 'Add Note',
  editNote: 'Edit Note',
  createActionItem: 'Create Action Item',
  enterManualVitals: 'Enter Manual Vitals',
  moreVitals: 'More vitals…',
  hideMoreVitals: 'Hide additional vitals',
  measuredBy: 'Measured By',
  measurementTimestamp: 'Measurement Timestamp',
  bloodGlucose: 'Blood Glucose',
  height: 'Height',
  systolic: 'Systolic',
  diastolic: 'Diastolic',
  prothrombinTime: 'PT',
  inr: 'INR',
  peakExpiratoryFlow: 'Peak Expiratory Flow',
  fev1: 'FEV1',
  fvc: 'FVC',
  shakes: 'Shakes',
  count: 'Count',
  duration: 'Duration',
  neurological: 'Neurological',
  orientation: 'Orientation',
  coordination: 'Coordination',
  inhalationDuration: 'Inhalation Duration',
  exercise: 'Exercise',
  amount: 'Amount',
  burnedCalories: 'Burned Calories',
  editAction: 'Edit Action',
  emailPatient: 'Email Patient',
  title: 'Title',
  category: 'Category',
  severity: 'Severity',
  note: 'Note',
  completedAction: 'Completed Action',
  openAction: 'Open Action',
  created: 'Created',
  edited: 'Edited',
  complete: 'Complete',
  resolved: 'Resolved',
  open: 'Open',
  completed: 'Completed',
  reOpen: 'Re-Open',
  actionStatus: 'Action Status',
  statusDate: 'Status Date',
  limitVisibility: 'Limit {0} visibility to:',
  noteCharLimit: '{0} must be less than {1} charecters long',
  xMustBeLessThenY: '{0} must be less than {1}',
  logitemType: 'Log Item Type',
  downloadTemplateCsv: 'Download template cvs file',
  downloadTemplateXslx: 'Download template xlsx file',
  andXmore: '... and {0} more',
  createKit: 'Create Kit',
  kit: 'Kit',
  kitId: 'Kit ID',
  kitIds: 'Kit IDs',
  kitStatus: 'Kit Status',
  selectKit: 'Select Kit',
  attachKit: 'Attach Kit',
  reassignKit: 'Reassign Kit',
  kitToReplace: 'Kit to replace',
  removeKit: 'Remove Kit',
  attachDeviceToKit: 'Attach Device to a Kit',
  attachDevicesToKit: 'Attach Devices to a Kit',
  kitName: 'Kit Name',
  enrollmentId: 'Enrollment ID',
  editEnrollment: 'Edit Enrollment',
  attachAdditionalKitWarning: 'This patient already has {0} kit(s). Confirm that you want to attach another kit.',
  activeSince: 'Active Since',
  deleteKit: 'Delete Kit',
  deleteKitWarning: 'Are you sure you want to delete this kit',
  editKit: 'Edit Kit',
  healthMonitorAlerts: {
    title: 'Health Monitor Alerts',
    description:
      'Rules define which system metric is monitored and when it is considered unhealthy. When a rule condition is met, an incident is opened and its active subscriptions determine who receives SMS or email notifications.',
    rules: 'Rules',
    incidents: 'Incidents',
    fieldHelp: '{0} help',
    descriptionLabel: 'Description',
    descriptionTooLong: 'Must be {0} characters or less',
    metricType: 'Metric Type',
    detectorKey: 'Detector Key',
    detectorKeyHelp:
      'SMS Failure Rate measures failed outbound SMS messages as a percentage of all SMS messages. Event Failure Rate measures failed device events as a percentage of all device events. Failed Events Count counts records that could not be processed and supports category and CAP ID filters.',
    operator: 'Operator',
    thresholdOperator: 'Threshold Operator',
    thresholdValue: 'Threshold Value',
    severity: 'Severity',
    timeWindow: 'Time Window',
    windowPreset: 'Window Preset',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    editRule: 'Edit Alert Rule',
    createRule: 'Create Alert Rule',
    updateRule: 'Update Rule',
    createRuleButton: 'Create Rule',
    ruleSaveFailed: 'Failed to save alert rule',
    ruleUpdated: 'Alert rule updated',
    ruleCreated: 'Alert rule created',
    failureCategoriesInclude: 'Failure Categories to Include',
    failureCategoriesIncludeOptional: 'Failure Categories to Include (optional)',
    failureCategoriesIncludeHelp:
      'When categories are selected, only failed events in those categories are counted.',
    failureCategoriesExclude: 'Failure Categories to Exclude',
    failureCategoriesExcludeOptional: 'Failure Categories to Exclude (optional)',
    failureCategoriesExcludeHelp:
      'Failed events in the selected categories are ignored. Exclusions are applied after inclusions.',
    allCategories: 'All categories',
    noExcludedCategories: 'No excluded categories',
    failureCategoriesLoadFailed: 'Failure categories could not be loaded',
    noCategoriesAvailable: 'No categories available',
    capIdPattern: 'CAP ID Pattern',
    capIdPatternOptional: 'CAP ID Pattern (optional)',
    capIdPatternPlaceholder: 'e.g. CAP-%',
    capIdPatternHelp:
      'Matches CAP IDs case-insensitively. Use % for any number of characters and _ for one character. For example, CAP-% matches every CAP ID starting with CAP-.',
    detectors: {
      smsFailureRate: 'SMS Failure Rate',
      eventFailureRate: 'Event Failure Rate',
      failedEventsCount: 'Failed Events Count',
    },
    operators: {
      greaterThan: 'Greater Than (>)',
      greaterThanOrEqual: 'Greater Than or Equal (>=)',
      lessThan: 'Less Than (<)',
      lessThanOrEqual: 'Less Than or Equal (<=)',
    },
    severityLevels: {
      info: 'Info',
      warning: 'Warning',
      critical: 'Critical',
    },
    timeWindows: {
      last1Hour: 'Last 1 Hour',
      last24Hours: 'Last 24 Hours',
      last7Days: 'Last 7 Days',
      last28Days: 'Last 28 Days',
      last30Days: 'Last 30 Days',
    },
    subscription: {
      edit: 'Edit Subscription',
      create: 'Create Subscription',
      update: 'Update Subscription',
      description:
        'A subscription determines who receives notifications when this alert rule triggers. Choose a portal user as the recipient, or enter an email address or phone number for a custom recipient. Then choose whether to send notifications by SMS, Email, or both.',
      recipientUser: 'Recipient User',
      recipientUserOptional: 'Recipient User (optional)',
      recipientUserHelp:
        "The selected portal user's saved email and phone number are used unless an override is entered.",
      searchPlaceholder: 'Search by name, username, or email...',
      enterAtLeast2Characters: 'Enter at least 2 characters',
      noUsersFound: 'No users found',
      searchFailed: 'Users could not be loaded',
      unnamedUser: 'Unnamed user',
      label: 'Subscription Label',
      labelOptional: 'Subscription Label (optional)',
      labelHelp:
        'Internal name used to recognize this subscription in the list. It does not affect delivery.',
      emailOverride: 'Email Override',
      emailOverrideOptional: 'Email Override (optional)',
      emailOverrideHelp:
        "Replaces the recipient user's saved email for this subscription. It can also be used without a recipient user.",
      phoneNumberOverride: 'Phone Number Override',
      phoneNumberOverrideOptional: 'Phone Number Override (optional)',
      phoneNumberOverrideHelp:
        "Replaces the recipient user's saved phone number for this subscription. It can also be used without a recipient user.",
      smsEnabled: 'SMS Enabled',
      emailEnabled: 'Email Enabled',
      contactMethod: 'Recipient User, Email Override, or Phone Number Override',
      notificationChannel: 'SMS Enabled or Email Enabled',
      contactMethodRequired:
        'Required: select a Recipient User or enter an Email or Phone Number Override.',
      notificationChannelRequired: 'An active subscription must have SMS or Email enabled.',
      invalidEmail: 'Invalid email format',
      invalidPhone: 'Invalid phone number format',
      saveFailed: 'Failed to save subscription',
      updated: 'Subscription updated',
      created: 'Subscription created',
    },
  },
  myAlerts: 'My Alerts',
  showingXPendingAlerts: 'Showing {0} Pending Alerts',
  showingXofXPendingAlerts: 'Showing {0} of {1} Pending Alerts',
  showingXAlerts: 'Showing {0} Alerts',
  showingXofXAlerts: 'Showing {0} of {1} Alerts',
  priority: 'Priority',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  type: 'Type',
  measurements: 'Measurements',
  characters: 'characters',
  vitals: 'Vitals',
  capType: 'Cap Type',
  selectDevice: 'Select Device',
  heartRateDevice: 'Heart-rate device',
  heartRateFromBloodPressureCuff: 'From the blood-pressure cuff (no extra device)',
  heartRateFromPulseOximeter: 'From the pulse oximeter (no extra device)',
  heartRateSeparateDevice: 'Separate all-day device, e.g. a wrist band (adds one unless the order already has one)',
  includedWith: 'Included with {0}',
  separateDevice: 'separate device',
  separateHeartRateDevice: 'Separate heart-rate device',
  separateHeartRateDeviceNotMapped: "Smart ordering can't ship a separate device: no available wrist band is listed under Heart rate in this organization's Device Mappings. Ask an administrator to add one, or take heart rate from the current device.",
  checkingSeparateHeartRateDevice: 'Checking which heart-rate devices smart ordering can ship for this organization…',
  separateHeartRateDeviceNeedsHub: "Smart ordering can't ship a separate device: the wrist band it would add needs a hub, and no hub is orderable for this organization. Ask an administrator to make one orderable, or take heart rate from the current device.",
  separateHeartRateDeviceCheckFailed: "Couldn't check which heart-rate devices this organization can ship. Saving the enrollment still checks the choice.",
  offeredVitalsCheckFailed: "Couldn't check which vitals this organization has devices for, so every vital is listed.",
  noVitalDevicesOffered: 'No vital devices are available for this organization',
  cohorts: 'Cohorts',
  cohort: 'Cohort',
  activePatients: 'Active Patients',
  inactivePatients: 'Inactive Patients',
  assignedTo: 'Assigned to',
  facilities: 'Facilities',
  createCohort: 'Create Cohort',
  editCohort: 'Edit Cohort',
  cohortName: 'Cohort Name',
  cohortId: 'Cohort Id',
  primaryCohortManager: 'Primary Cohort Manager',
  primaryManager: 'Primary Manager',
  secondaryManager: 'Secondary Manager',
  numberOfEnrollments: 'Number of Enrollments',
  createdBy: 'Created by',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  updatedBy: 'Updated by',
  uuid: 'UUID',
  skip: 'Skip',
  flowVolumeCurve: 'Flow Volume Curve',
  volumeTimeCurve: 'Volume Time Curve',
  clearAlert: 'Clear alert',
  clearAlertError: 'Clear alert error',
  clearAlertsToSetVitalsLimitsAndGoals: 'Clear alerts to set vitals limits and goals',
  clearAlertsToSetMissedReadingsReminder: 'Clear alerts to set missed readings reminder',
  activeAlertThresholdsWarning: 'An alert is currently active. Updated thresholds will trigger new notifications only after you clear the current alert.',
  setReminder: 'Set reminder',
  spirometry: 'Spirometry',
  program: 'Program',
  programEnrollment: 'Program Enrollment',
  confirmations: 'Confirmations',
  programs: {
    rtm: 'RTM',
    ccm: 'CCM',
    rpm: 'RPM',
    pcm: 'PCM',
    ctam: 'CTAM',
    eckm: 'eCKM',
    ckm: 'CKM',
    msk: 'MSK',
    bh: 'BH',
  },
  subprograms: {
    rtm: {
      musculoskeletal: 'Musculoskeletal',
      respiratory: 'Respiratory',
      behavioralHealth: 'Behavioral Health',
    },
    ccm: {
      basic: 'Basic',
      complex: 'Complex',
    },
  },
  defaultProgram: 'Default Program',
  otherPrograms: 'Other Programs',
  writtenConsentGiven: 'Written consent given',
  verbalConsentGiven: 'Verbal consent given',
  selectCondition: 'Select Condition',
  selectOrganizationTemplate: 'Select Organization Template',
  selectOrganizationType: 'Select Organization Type',
  selectProgram: 'Select Program',
  selectPrograms: 'Select Programs',
  patientWillBeAssigned: 'Patient will be assigned to:',
  searchKit: 'Search Kit',
  scanBarcodeOrEnterId: 'Scan barcode on the box, or enter id',
  redings: 'Redings',
  deviceTypes: {
    bpm: 'BP Monitor',
    scales: 'Scales',
    glucometer: 'Glucometer',
    wristBand: 'Wrist Band',
    spirometer: 'Spirometer',
    hailieInhaler: 'Hailie Inhaler',
    thermometers: 'Thermometers',
    pulseOximeter: 'Pulse Oximeter',
    bluetoothCap: 'Bluetooth cap',
    hub: 'Hub',
    lte: 'LTE',
    lsc: 'LSC',
    inhaler: 'Inhaler',
    airQualityMonitor: 'Air Quality Monitor',
    ptInrMonitor: 'PT/INR Monitor',
  },
  readingStatus: {
    allReadings: 'All Readings',
    newReadings: 'New Readings',
    archivedReadings: 'Archived Readings',
  },
  normal: 'Normal',
  abnormal: 'Abnormal',
  alert: 'Alert',
  batteryReading: 'Battery reading',
  localization: 'Localization',
  firmwareVersion: 'Firmware version',
  signalQuality: 'Signal quality',
  signalQualityEnum: {
    Excellent: 'Excellent',
    Good: 'Good',
    Medium: 'Medium',
    Weak: 'Weak',
  },
  problems: 'Problem(s)',
  sleep: 'Sleep',
  pillsTaken: 'Pills taken',
  inhalationTaken: 'Inhalation taken',
  zephyRxDashboard: 'ZephyRx Dashboard',
  editConditionList: 'Edit Condition List',
  editFacilityList: 'Edit Facility List',
  patientAlerts: 'Patient Alerts',
  thermometer: 'Thermometer',
  lowTemperature: 'Low Temperature',
  highTemperature: 'High Temperature',
  lowSaturation: 'Low Saturation',
  lowHR: 'Low Heart rate',
  highHR: 'High Heart rate',
  highPm25: 'High PM 2.5',
  lowPt: 'Low PT',
  highPt: 'High PT',
  lowInr: 'Low INR',
  highInr: 'High INR',
  missedDosesAlerts: 'Missed doses Alerts',
  reviewBy: 'Review By',
  last2days: 'Last 48 hours',
  hour: 'hour',
  hours: 'hours',
  saveWithNoKit: 'Save with no kit',
  xObjectsAssignedtoY: '{0} {1} assigned to {2}',
  xObjectsUnassignedfromY: '{0} {1} unassigned from {2}',
  enroll: 'Enroll',
  continueEnrollment: 'Continue Enrollment',
  cancelEnrollment: 'Cancel Enrollment',
  moveToNotEnrolled: 'Move to Not Enrolled',
  moveToOnboarded: 'Move to Onboarded',
  moveToNotEnrolledWarning: 'Are you sure you want to move patient {0} to Not Enrolled?',
  moveToOnboardedRegisteredWarning: 'Are you sure you want to move patient {0} to Onboarded/Registered state?',
  selectNotEnrolledReason: 'Select reason for not enrolling',
  selectDisenrolledReason: 'Select reason for disenrollment',
  selectTerminatedReason: 'Select reason for ending enrollment',
  setEnrollmentEndDate: 'Set enrollment end date',
  disenroll: 'Disenroll',
  activateNow: 'Activate enrollment',
  changeEnrollmentEndDate: 'Change enrollment end date',
  register: 'Register',
  unregister: 'Unregister',
  unregisterEnrollmentWarning:
    'Are you sure you want to unregister the enrollment for patient {0}? The enrollment will be moved back to Onboarded.',
  enrollmentUnregistered: 'The enrollment for patient {0} was moved back to Onboarded.',
  pharmacyNotesToProvider: 'Pharmacy notes to Provider',
  enrollmentFor: 'Enrollment for',
  enrollmentCondition: 'Enrollment Condition',
  enrollmentProgram: 'Enrollment Program',
  enrollmentType: 'Enrollment type',
  enrollmentConsent: 'Enrollment Consent',
  consentChecklist: {
    title: 'Patient consent',
    status: 'Consent status',
    statusNotObtained: 'Not obtained',
    statusVerbal: 'Verbal consent given',
    statusWritten: 'Written consent given',
    statusDeclined: 'Declined',
    dateObtained: 'Date obtained',
    obtainedBy: 'Obtained by',
    givenBy: 'Consent given by',
    givenByPatient: 'Patient',
    givenByCaregiver: 'Caregiver',
    informedThat: 'Patient was informed that:',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    templateFooter: 'Consent template: {0} · {1} · all items are required to activate the enrollment',
    badgeNotObtained: 'Not obtained',
    badgeDeclined: 'Declined',
    badgeVerbal: 'Verbal consent recorded',
    badgeWritten: 'Written consent recorded',
    badgeProgress: '{0} of {1} confirmed',
    selectProgramFirst: 'Select a program to see the consent checklist.',
    errorStatus: "Record the patient's verbal or written consent to activate the enrollment.",
    errorDate: 'Enter the date consent was obtained.',
    errorFutureDate: 'The consent date cannot be in the future.',
    errorObtainedBy: 'Enter who obtained the consent.',
    errorItems: 'Confirm every item before activating the enrollment.',
    label: 'Consent',
    pillVerbal: 'Verbal',
    pillWritten: 'Written',
    pillNotObtained: 'Not obtained',
    obtainedByName: 'by {0}',
    details: 'Details',
    hide: 'Hide',
    recorded: 'Recorded',
    recordedAtBy: '{0} by {1}',
    template: 'Template',
    informedThatCount: 'Patient was informed that ({0} of {1}):',
    requiredBeforeActivation: 'Required before activation',
    recordConsent: 'Record consent',
    recordedBeforeChecklist: 'Recorded before the consent checklist',
  },
  enrollmentConsentNotSetError: 'Either written or verbal consent must be given to enroll patient',
  accessTrack: 'ACCESS Track',
  accessGCodesTitle: 'ACCESS G-codes',
  accessGCodesCandidate: 'ACCESS candidate',
  accessGCodesStatus: 'Candidate status',
  accessGCodesCode: 'G-code',
  accessGCodesPeriod: 'Care period',
  accessGCodesDos: 'DOS',
  accessGCodesDeadline: 'Submission deadline',
  accessGCodesDisposition: 'Billing disposition',
  accessGCodesDiagnosis: 'Diagnosis',
  accessGCodesPolicy: 'Diagnosis policy',
  accessGCodesQualification: 'Diagnosis qualification',
  accessGCodesQualificationDecision: 'Decision',
  accessGCodesQualifyingCodes: 'Qualifying codes',
  accessGCodesExclusionCodes: 'Exclusion codes',
  accessGCodesEnrollmentCodes: 'Enrollment diagnosis codes',
  accessGCodesPos: 'Place of service',
  accessGCodesPosReason: 'Reason for place of service',
  accessGCodesServiceStartedOn: 'First service date',
  accessGCodesConfirmCareDelivery: 'Confirm Active Care Delivery',
  accessGCodesCreateDisposition: 'Create billing disposition',
  accessGCodesAssignClinicians: 'Assign clinicians',
  accessGCodesRenderingClinician: 'Rendering clinician',
  accessGCodesSupervisingClinician: 'Supervising clinician',
  accessGCodesNoSupervisingClinician: 'No supervising clinician',
  accessGCodesApproveDisposition: 'Approve disposition',
  accessGCodesDispositionActions: 'Disposition actions',
  accessGCodesAction: 'Action',
  accessGCodesSendToReview: 'Send to review',
  accessGCodesResolveReview: 'Resolve review',
  accessGCodesCancelDisposition: 'Cancel disposition',
  accessGCodesUpdateDisposition: 'Update disposition',
  accessGCodesReason: 'Reason',
  accessGCodesAcceptedSnapshot: 'Accepted billing snapshot',
  accessGCodesAuditHistory: 'Audit history',
  accessGCodesNoEvents: 'No audit events recorded.',
  accessGCodesActionFailed: 'The ACCESS G-code action could not be completed.',
  accessGCodesCompleteRequiredFields: 'Complete the required fields before confirming care delivery.',
  accessGCodesCareDeliveryConfirmed: 'Active Care Delivery confirmed.',
  accessGCodesDispositionCreated: 'Billing disposition created.',
  accessGCodesRenderingRequired: 'Select a rendering clinician.',
  accessGCodesCliniciansAssigned: 'Billing clinicians assigned.',
  accessGCodesDispositionApproved: 'Billing disposition approved.',
  accessGCodesReasonRequired: 'A reason is required for this action.',
  accessGCodesDispositionUpdated: 'Billing disposition updated.',
  careUpdateConsent: 'Patient consent for care updates to PCP and referring clinicians',
  primaryCareProviderName: 'Primary Care Provider name',
  primaryCareProviderNpi: 'Primary Care Provider NPI',
  primaryCareProvider: 'Primary Care Provider',
  referringProvider: 'Referring Provider',
  referredByProvider: 'Was the patient referred by a provider?',
  externalProviderDirectory: {
    searchBy: 'Search by',
    npi: 'NPI',
    name: 'Name',
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    state: 'State',
    search: 'Search',
    match: 'Provider match',
    providerName: 'Provider name',
    status: 'Status',
    specialty: 'Specialty',
    specialtyCode: 'Specialty code',
    organization: 'Organization',
    directAddress: 'Direct Secure Messaging address',
    faxNumber: 'Fax number',
    useProvider: 'Use this provider',
    useEnteredProvider: 'Use entered data',
    changeProvider: 'Change provider',
    addProviderTitle: 'Add {0}',
    changeProviderTitle: 'Change {0}',
    removeProviderTitle: 'Remove {0}',
    removeProviderConfirmation: 'Remove {0}? The provider will remain available in the provider directory.',
    providerSaved: '{0} was saved.',
    providerRemoved: '{0} was removed.',
    searchAnother: 'Search another provider',
    enterManually: 'Enter manually',
    editManually: 'Edit manually',
    removeProvider: 'Remove provider',
    active: 'Active',
    deactivated: 'Deactivated',
    manualEntryHelp: 'Enter the provider details and at least one delivery channel.',
    selectProviderRequired: 'Search for and select a {0}, or enter one manually.',
    requiredProviderData: 'First name, last name, a valid NPI, and a Direct Secure Messaging address or fax number are required.',
    communicationChannelRequired: 'A Direct Secure Messaging address or fax number is required.',
    nameRequired: 'Provider first and last name are required.',
    npiRequired: 'Provider NPI is required.',
    noResults: 'No matching providers were found.',
    searchFailed: 'Provider search failed. Please try again.',
    resolveFailed: 'PCP lookup failed. You can search for the provider manually.',
    partialResults: 'Some provider directories could not be reached. Review the available results before continuing.',
    resolvedFromAthena: 'PCP found in athenaOne. Review the proposed data before using it.',
    pcpNotFound: 'No PCP was found in athenaOne. Search for the provider manually.',
    pcpChannelMissing: 'The PCP found in athenaOne has no usable communication channel. Search for another source below.',
    pcpNpiMissing: 'The PCP found in athenaOne has no NPI. Search for the provider manually.',
    athenaMappingMissing: 'This patient is not linked to athenaOne. Search for the PCP manually.',
    athenaDisabled: 'athenaOne provider lookup is not enabled. Search for the PCP manually.',
  },
  invalidNpi: 'Enter a valid 10-digit NPI.',
  invalidNpiChecksum: 'NPI checksum does not match.',
  treatmentPlan: 'Treatment plan',
  accessRegistrationSubmitted: 'The request was successfully submitted to CMS. The enrollment status may change after CMS responds.',
  accessEligibilityAwaitingConfirmation: 'Awaiting CMS eligibility confirmation',
  accessEligibilityFailed: 'Failed',
  accessEnrollmentEligibilitySubmitted: 'The diagnosis was submitted to CMS for another eligibility check. The enrollment status may change after CMS responds.',
  accessAlignmentSubmitted: 'The patient was enrolled and the alignment request was submitted to CMS.',
  accessAlignmentAwaitingConfirmation: 'Awaiting CMS alignment confirmation',
  alignment: 'Alignment',
  lastAlignmentResult: 'Last alignment result',
  enrollmentStart: 'Enrollment Start',
  enrollmentEnd: 'Enrollment End',
  enrollmentDateTimezoneTooltip: '{0} - {1} timezone',
  agreementToSpeakWithProvider: 'Agreement to speak with Provider',
  consent: 'Consent',
  stateChangedDate: 'State changed date',
  nextOutreachDate: 'Next Outreach Date',
  changeStatus: 'Change status',
  outreachStatusEnum: {
    pending: 'Pending',
    set: 'Consents to Provider Call',
    retry: 'Retry',
    not_eligible: 'Not Eligible',
    declined: 'Declined',
  },
  extendedOutreachStatusEnum: {
    rpmOrderPending: 'RPM Order Pending',
    rpmOrderApproved: 'RPM Order Approved',
    ineligible: 'Ineligible',
    patientOutreachInProcess: 'Patient Outreach in Process',
    deferred: 'Deferred',
    patientDeclined: 'Patient Declined',
    unableToReach: 'Unable to Reach',
    rpmOrderDeclined: 'RPM Order Declined',
    noProviderRpmOrderReponse: 'No Provider RPM Order Reponse',
  },
  outreachStatusForEnrollmentWarning: 'Must be set to "{0}" before enrolling patient',
  patientStateChangeWarning: 'Patient will be moved to "{0}" state',
  reasonForUnregisteringPatient: 'Reason for unregistering patient',
  reasonForChangingOutreachStatus: 'Reason for changing outreach status',
  activate: 'Activate',
  assignKit: 'Assign Kit',
  assignKitAndActivationSchedule: 'Assign Kit and Activation Schedule',
  consentUploadInstruction: 'Signed consent can be uploaded via "Documents"',
  patientRegisteredInfo: '{0} has been registered',
  patientEnrolledInfo: '{0} has been enrolled to the system',
  patientActivatedInfo: 'Patient {0} has been activated',
  endDateSet: 'Enrollment end date for patient {0} has beed set',
  welcomeSmsSent: 'Welcome SMS was scheduled to be sent to patient {0}',
  kitAssignedInfo: 'Kit {0} has been assigned to patient {1}',
  wheresKitIdText:
    'You will find a 20 digit alphanumeric code printed here on the kit packaging. You should only need to enter the first few letters.',
  enrollmentKit: 'Enrollment Kit',
  noCapAvailable: 'No cap available',
  avgTimeDelta: 'Avg. Time Delta',
  tutorial: 'Tutorial',
  onboarding: 'Onboarding',
  enrollment: 'Enrollment',
  enrollments: 'Enrollments',
  preview: 'Preview',
  monitoring: 'Monitoring',
  sendTo: 'Send to',
  from: 'From',
  message: 'Message',
  standardMessage: 'Standard Message',
  phiSafeMessage: 'PHI Safe Message',
  isPhiSafe: 'Is PHI Safe',
  messageUnchanged: 'Message unchanged',
  SMSSent: 'Text sent successfully',
  SMSFailed: 'Unable to send Text',
  sendText: 'Send Text',
  uploadPatientList: 'Upload Patient List',
  patientListFiles: 'Patient List Files',
  perfusionIndex: 'Perfusion Index',
  maxAndRemainingChars: 'Max characters: {0} ({1} remaining)',
  maxAndOverflowChars: 'Max characters: {0} (too long by {1})',
  remainingChar: '{0} character remaining',
  remainingChars: '{0} characters remaining',
  selectTheme: 'Please select theme',
  theme: {
    blue: 'Blue',
    red: 'Red',
    petrol: 'Petrol',
    white: 'White (esi)',
  },
  selectBrand: 'Please select brand',
  lteUserInstructions: 'LTE User Instructions',
  rpmQuickGuide: 'RPM Quick Guide',
  rxcapPortal: 'RxCap Portal',
  smartCapPatientInstVideo: 'Smart Cap Patient Instruction Video',
  role: 'Role',
  selectRole: 'Select role',
  orgConfigUpdated: 'Org config updated',
  noPermissionsForModule: 'No permissions for this module.',
  modules: 'Modules',
  deviceMappings: 'Device Mappings',
  deviceMappingsUpdated: 'Device mappings updated',
  disableDeviceTitle: 'Disable device',
  disableDeviceMappingsWarning:
    'Disabling this device may prevent automatic fulfillment for organizations that use or inherit it. '
    + 'Configured mappings remain visible, but this device will no longer be selected for new orders.',
  noDevicesForVital: 'No devices measure this vital.',
  selectModuleToConfigure: 'Select a module to configure.',
  deviceMappingSourceOrg: 'Custom for this organization',
  deviceMappingSourceInherited: 'Inherited from {0}',
  deviceMappingSourceParentOrg: 'a parent organization',
  deviceMappingSourceGlobal: 'Platform default',
  deviceMappingSourceNotConfigured: 'Not configured',
  deviceMappingDivergingVitals:
    'The vitals in this module are configured differently; saving applies the list below to all of them.',
  deviceMappingNoDeviceWarning:
    'No device configured — enrollments that select this module will be rejected.',
  deviceMappingNoAvailableDeviceWarning:
    'No orderable device — enrollments that select this module will be rejected.',
  deviceUnavailableDeleted: 'device no longer exists',
  deviceUnavailableNotOrderable: 'withdrawn by RxCap',
  deviceUnavailableOrgDisabled: 'disabled in this organization catalog',
  deviceUnavailableOrgDisabledInherited: 'disabled by a parent organization',
  deviceUnavailableSmartmeterUnconfigured: 'SmartMeter SKU not configured',
  deviceUnavailableVitalNotSupported: 'does not measure this vital',
  deviceMappingCrossGroupAdvisory:
    'Patients enrolled for {0} and {1} may receive two separate devices: '
    + '{2} for {0} and {3} for {1}. The {0} device can also measure {1}; '
    + 'add {2} to the {1} preference list to allow one device to cover both.',
  deviceMappingHeartRateNote:
    'Patients whose order already has a device that measures heart rate (a blood-pressure cuff, pulse oximeter or wrist band) get heart rate from it. '
    + 'This list is used when heart rate needs its own device: heart-rate-only patients, or a clinician\'s request for a separate heart-rate device, '
    + 'which never picks a blood-pressure cuff or pulse oximeter.',
  deviceMappingsCopyFromParent: 'Copy parent settings',
  deviceMappingsCopyFromParentTooltip:
    'Merge the parent\'s effective preference list into this module. Existing order is kept, missing devices are appended, and the result becomes this organization\'s setting.',
  deviceMappingsCopyFromGlobal: 'Copy global settings',
  deviceMappingsCopyFromGlobalTooltip:
    'Merge the platform default preference list into this module. Existing order is kept, missing devices are appended, and the result becomes this organization\'s setting.',
  deviceMappingsResetToInherited: 'Reset to inherited',
  deviceMappingsResetToInheritedTooltip:
    'Delete this organization\'s setting for this module and resume inheritance from its parent, or from platform defaults when no parent mapping exists.',
  deviceMappingsCopied: '{0} device(s) added to this organization',
  deviceMappingsCopiedNothingNew: 'Now managed by this organization',
  deviceMappingsCopiedDivergent:
    'Copied {0} settings from {1} and normalized this organization. The source remains configured differently.',
  deviceMappingsReset: 'Device mappings reset to inherited',
  deviceMappingsResetDivergentTitle: 'Inherited settings differ',
  deviceMappingsResetAnyway: 'Reset anyway',
  deviceMappingsSaveFailed: 'Failed to save device mappings',
  deviceMappingsCopyFailed: 'Failed to copy device mappings',
  deviceMappingsResetFailed: 'Failed to reset device mappings',
  userPermissionsSaved: 'User permissions saved',
  contactUs: 'Contact Us',
  videos: 'Videos',
  gettingStart: 'Getting started using the portal',
  gettingStartDesc:
    'Just joined? Watch here to cover all the key areas you will need to learn to successfully manage your patients.',
  onboardingDesc: 'Watch this if you need a quick review of how to onboard new patients to the portal.',
  enrollementDesc: 'Watch this if you need a quick review of how to enroll new patients to the portal.',
  monitoringDesc: 'Watch this if you need a quick review of how to monitor your patients metrics.',
  billingDesc: 'Watch this if you need a quick review of how to manage your billing for your billing clinician.',
  smartCapRTMDesc:
    'You can send this video to your patients, so they can quickly learn about how to use their smart cap',
  SmartCapRTM: 'Smart Cap for RTM',
  network: 'Network',
  networkTime: 'Last network time',
  rxcapLaunchOutlineExternal: 'RxCap Launch Outline',
  setDefault: 'Set default',
  authenticationHeader: 'Authentication Header',
  authHeader: 'Auth Header',
  pauseAPI: 'Pause API',
  successfieldRequired: 'Success Field Required',
  maxTimeWithoutEvents: 'Maximum Time Without Event',
  maxBatchSize: 'Max Batch Size',
  errorMaxBatchSize: 'Must be greater than 0',
  successFieldRequired: 'Success Field',
  required: 'Required',
  notRequired: 'Not Required',
  apiStatus: {
    active: 'Active',
    paused: 'Paused',
  },
  missedDoses: 'Missed doses',
  alertCleared: 'Alert successfully cleared',
  size: 'Size',
  itemSaved: '{0} saved successfully',
  manage: 'Manage',
  noDataAvailableChooseNavigation:
    'No data to display for the chosen time period. Please use navigation options to view data from a different time period',
  atmocubeValues: {
    tvoc: 'TVOC',
    vocIndex: 'VOC Index',
    noxIndex: 'NOx Index',
    relativeHumidity: 'Relative Humidity',
    atmosphericPressure: 'Atmospheric Pressure',
    noiseLevels: 'Noise Levels',
    lightIntensity: 'Light Intensity',
    formaldehyde: 'Formaldehyde',
    occupancy: 'Occupancy',
  },
  hailieEventSubTypes: {
    inhalation: 'Inhalation',
    shakeDetection: 'Shake Detection',
    respirationFlow: 'Respiration Flow',
    respirationTiming: 'Respiration Timing',
  },
  passwordTexts: {
    yourPasswordShouldBe: 'Your password should be',
    eightTo32Characters: '8 to 32 characters long',
    atLeastOneDigit: 'at least have one digit',
    atLeastOneUpperCase: 'at least have one upper case letter',
    atLeastOneLowerCase: 'at least have one lower case letter',
    atLeastOneSpecialCharacter: 'at least have one (~!*^@#$%&) special character',
    matchWithConfirmField: 'match with confirm field',
    oldPasswordIsRequired: 'Old password is required',
    notAllowedCharacters: 'Not allowed characters',
  },
  startDateShouldBeBeforeEndDate: 'Start date should be before end date',
  allowedDataRangeIs6Months: 'Maximum allowed data range is 6 months',
  allowedDataRangeIsXMonths: 'Maximum allowed data range is {0} months',
  noDataInGivenPeriod: 'No data was available in the chosen period. Please select different time period.',
  timeThisMonth: 'Time this Month',
  todaysMedications: "Today's Medications",
  statusEnum: {
    pending: 'Pending',
    submitted: 'Submitted',
    onhold: 'On-Hold',
    enabled: 'Enabled',
    disabled: 'Disabled',
    active: 'Active',
    inactive: 'Inactive',
    forbidden: 'No access',
    invited: 'Invited',
    configured: 'Enabled',
  },
  copy: 'Copy',
  copyToClipboard: 'Copy to clipboard',
  copiedToClipboard: 'Copied to clipboard',
  publicKeyHasBeenDeleted: 'Public key has been deleted, all tokens are now revoked',
  publicKeyIsInvalid: 'Public key is invalid',
  noticeSaveCredentials: 'Notice: Please save those credentials. It will not be possible to obtain them again.',
  credentialsCopiedToClipboard: 'Credentials copied to clipboard',
  applyFilters: 'Apply page filters',
  billableTime: 'Billable time',
  pm25: 'PM 2.5',
  healthCenter: 'Health Center',
  yourDevices: 'Your Devices',
  yourMedications: 'Your Medications',
  year: 'Year',
  unitsEnum: {
    lbs: 'lbs',
    kg: 'kg',
    minutes: 'mins',
    hours: 'hours',
  },
  dailyAverage: 'Daily Average',
  hourlyAverage: 'Hourly Average',
  dateRange: 'Date Range',
  portalAccess: 'Portal Access',
  editUser: 'Edit User',
  addUser: 'Add User',
  addRemoveUsers: 'Add / Remove Users',
  userName: 'User Name',
  resetPasswordMethodPrompt: 'How would you like to reset your password?',
  changePasswordWarning: 'Do you want to change your password? We will send the password reset link to ',
  userSaved: 'User Details for {0} have been saved',
  rolesEnum: {
    organization_manager: 'Organization Manager',
    capmanager: 'Cap Manager',
    doctor: 'Admin',
  },
  rolesPluralEnum: {
    organization_manager: 'Organization Managers',
    capmanager: 'Cap Managers',
    doctor: 'Admins',
  },
  confirmPasswordReset: 'Confirm Password Reset',
  confirmReinvite: 'Confirm Invite Resend',
  dateRangeAdjustedWarning:
    'The maximum date range allowed for download is 6 months. The start date of your selected date range has been adjusted to fit within this limit.',
  maximumDateRangeAllowedMonths: 'The maximum date range allowed is {0} months.',
  selectDateRangeOrLeaveBlank: 'Select date range or leave blank to get all data',
  scheduleEnded: 'Schedule Ended',
  assignedDate: 'Assigned Date',
  unassignedDate: 'Unassigned Date',
  invalidTimezone: 'Invalid timezone',
  dataRangeAberraviations: {
    day: 'D',
    week: 'W',
    twoWeeks: '2W',
    month: 'M',
    sixMonths: '6M',
    year: 'Y',
  },
  invalidTag: 'Invalid tag',
  insertTag: 'Insert tag',
  replaceMessage: 'Replace message',
  insertIntoMessage: 'Insert into message',
  messageTagHelp: {
    Name: 'Patient name from the patient profile.',
    PatientName: 'Patient name from the patient profile.',
    CaregiverName: 'Caregiver name from the patient record.',
    Medicine: 'Medication name from the patient schedule.',
    Time: 'Scheduled notification time from the patient schedule.',
    MinutesToTake: 'Minutes remaining before the scheduled dose.',
    MinutesAfterTake: 'Minutes since the scheduled dose.',
    Code: 'One-time verification code.',
    Alert: 'Text of the alert that triggered this message.',
    Link: 'Link to the scheduled video visit.',
    DateTime: 'Date and time of the scheduled video visit.',
    PharmacyName: 'Organization name used in SMS branding.',
    ExpectedDelivery: 'Shipment delivery date: estimated before delivery or actual after delivery.',
    SupportNumber: 'SMS sender phone number currently used as the contact number.',
    StreakCount: 'Number of consecutive days in the current streak.',
    MilestoneName: 'Name of the milestone reached.',
    EncouragementEmoji: 'Emoji chosen for the milestone message.',
    CompliantDays: 'Number of days the patient was compliant.',
    TotalDays: 'Total number of days in the milestone period.',
    ThresholdDays: 'Day threshold configured for this milestone.',
    ProgramName: 'Name of the patient program.',
    CompletionDate: 'Date the enrollment was completed.',
    DeviceName: 'Name of the device involved in the alert.',
    NearestDose: 'Time of the nearest scheduled dose.',
    PatientPortalURL: 'Patient portal link from organization branding.',
    NextDoseTime: 'Time of the next dose in schedules linked to this enrollment.',
    NextDoseMedication: 'Medication for the next dose in this enrollment.',
    NextDoseDate: 'Date of the next dose in this enrollment.',
    DeviceInstructions: 'Instruction video links for devices in this enrollment. Configure them under Admin → Devices → Files or Organization → Configuration → Files.',
    MissedDays: 'Number of consecutive days without a reading.',
    VitalName: 'Name of the vital sign that was not measured.',
  },
  awaitingBleReset: 'Awaiting BLE Reset',
  resetBle: 'Reset BLE chip',
  enableDexcomIntegration: 'Enable Dexcom integration',
  resetDexcomIntegration: 'Re-enable Dexcom integration',
  disableDexcomIntegration: 'Disable Dexcom integration',
  enableDexcomIntegrationConfirm: 'Are you sure you want to enable Dexcom integration for patient {0}?',
  enableDexcomIntegrationSuccess: 'Dexcom integration enabled successfully',
  disableDexcomIntegrationConfirm: 'Are you sure you want to disable Dexcom integration for patient {0}?',
  disableDexcomIntegrationSuccess: 'Dexcom integration disabled successfully',
  authorizeRxcapForDexcom:
    'To configure your device, please authorize RxCap to access your Dexcom data. We will redirect you to Dexcom website, where you will need to log in and accept our authorization.',
  reAuthorizeRxcapForDexcom:
    'Our authorization to access your Dexcom data has expired or was revoked. Please authorize RxCap to access your Dexcom data. We will redirect you to Dexcom website, where you will need to log in and accept our authorization.',
  notNow: 'Not now',
  dexcomDeviceConfiguration: 'Dexcom Device Configuration',
  selectDexcomKit: 'Select the kit for the Dexcom device',
  dexcomDeviceConfigured: 'Dexcom Device Configured',
  dexcomDeviceConfiguredSuccess:
    'Your Dexcom device has been configured successfully. Now, the data synced with your dexcom app on your phone will be available to your care provider',
  dexcomInvalidCode: 'Invalid code',
  dexcomCodeNotMatchingPatient:
    'The code obtained from Dexcom was not issued for this patient. Please contact your care provider for assistance.',
  dexcomConfigurationFailed: 'Dexcom configuration failed',
  dexcomConfigurationFailedText:
    'There was a problem configuring your Dexcom device. Please contact your care provider for assistance.',
  noReadingsSince: 'No readings since',
  newNotesSince: 'New notes since',
  numberOfDays: 'Number of days',
  allowedRangeWarning: 'Allowed range is {0}-{1}',
  coagulation: 'Coagulation',
  bulkAddTexts: {
    selectSheet: 'Select Excel sheet to upload',
    multipleSheets: 'Excel Sheet',
    noRows: 'No rows found in the selected sheet',
    columns: 'Columns',
    matchedColumns: 'Matched column headers for import:',
    unmatchedColumns: 'Unmatched column headers excluded from import:',
    newConditionsFound: 'New conditions found',
    unknownConditionsFound: 'Unknown conditions found',
    patientsWithNoCondition: 'Patients with no condition',
    conditionsToAdd: 'Following ICD10 conditions have been found that will be added to the organization',
    unrecognizedConditions:
      'The following conditions are not valid ICD10 codes and will be replaced as ‘Unknown’. Please adjust the conditions in the file or in patient record after import',
    unknownCondition: '{0} patient(s) have no conditions. They will be assigned to ‘{1}’ condition.',
    missingColumns: 'The following columns are missing from the selected sheet:',
    noFacility:
      '{0} patients have no facility or their facility is not added to organization. They will be assigned to ‘{1}’ facility',
    newFacilitiesInfo: '{0} new facilities have been found that will be added to the organization',
    patientsWithNoFacility: 'Patients with no facility',
    unknownFacilitiesFound: 'Unknown facilities found',
    errorReadingFile: 'Error while reading file',
    noPatientsInFile: 'No patients found in the file',
    duplicatePhoneNumberWarning: 'Patient with phone number {0} already exists. New patient will be created without phone number.',
    patientsWithPhoneNumberRemovedWarning: '{0} patient(s) had their phone numbers removed due to duplication.',
    patientPhoneRemovedNote: 'Patient phone number was removed during import due to duplication. The phone number was {0}.',
  },
  bulkUploadReview: {
    patients: 'Patients',
    state: 'State',
    tier: 'Tier',
    sourceRows: 'Source Rows',
    targetOrg: 'Target Organization',
    changedFields: 'Changed Fields',
    track: 'Track',
    errors: 'Errors',
    details: 'Details',
    noPatients: 'No patients found',
    before: 'Before',
    after: 'After',
    patientPreview: 'Patient Preview',
    total: 'Total',
    byState: 'By state',
    byTier: 'By tier',
    filterState: 'Filter by state',
    filterTier: 'Filter by tier',
    name: 'Name',
    action: 'Action',
    field: 'Field',
    requested: 'Requested',
    openPatient: 'Open patient',
    changed: 'Changed',
    fields: {
      mrn: 'MRN',
      pharmacyPatientId: 'Pharmacy Patient ID',
      medicareBeneficiaryId: 'MBI',
      firstName: 'First Name',
      lastName: 'Last Name',
      dateOfBirth: 'Date of Birth',
      gender: 'Gender',
      language: 'Language',
      timezone: 'Timezone',
      primaryPhoneNo: 'Primary Phone',
      textPhoneNo: 'Mobile Phone',
      email: 'Email',
      homeAddress: 'Home Address',
      address: 'Address',
      conditions: 'Conditions',
      insurance: 'Insurance',
      centerDetails: 'Center Details',
      transplantDetails: 'Transplant Details',
      medications: 'Medications',
      enrollments: 'ACCESS enrollments',
    },
    actions: {
      create: 'Create',
      update: 'Update',
    },
    states: {
      refining: 'Being checked',
      proposed: 'Proposed',
      unchanged: 'Unchanged',
      accepted: 'Accepted',
      rejected: 'Rejected',
      applied: 'Applied',
      error: 'Error',
    },
    sheetStatuses: {
      awaiting_confirmation: 'Awaiting confirmation',
      in_progress: 'In progress',
      awaiting_review: 'Waiting for review',
      finished: 'Finished',
    },
    reasons: {
      name_dob_only_merge: 'Rows merged on name and date of birth only: confirm they are one person',
      phone_will_be_removed: 'The mobile phone belongs to another patient: this may be that patient, or a relative sharing the phone. Accepting creates a new patient without the phone and adds it as a note',
      mbi_conflict: 'The MBI belongs to another patient',
      mrn_conflict: 'The MRN belongs to another patient',
      source_no_match: 'Not found in {source}: the patient will not be linked to it',
      source_unavailable: '{source} could not be reached: re-check the patient later to link it',
      filled_from_source: 'Taken from {source}: {fields}',
      source_conditions_skipped: '{count} {source} problem(s) left out: the organization has no matching condition',
      source_conditions_unavailable: '{source} did not return the problem list: no conditions were taken from it',
      missing_first_name: 'The first name is missing',
      missing_last_name: 'The last name is missing',
      missing_date_of_birth: 'The date of birth is missing',
      pcp_missing: 'No primary care provider: the sheet\'s PCP needs a valid NPI the NPI Registry knows',
      pcp_incomplete: 'The primary care provider has no Direct address or fax: complete it before Care Updates are sent',
      pcp_npi_invalid: 'The sheet\'s PCP NPI is not a valid NPI: it was ignored',
      pcp_not_found: '{source} does not know the sheet\'s PCP NPI',
      pcp_change: 'The sheet replaces the patient\'s primary care provider with another one: accept this patient by itself',
      pcp_not_individual: 'The sheet\'s PCP NPI belongs to an organization, not a provider: it was ignored',
      source_record_not_found: '{source} does not know the patient ID in the sheet: check the ID and the practice',
      source_not_configured: 'The sheet names a {source} patient, but the organization has no {source} configured',
      source_identity_mismatch: 'The {source} patient has a different name or date of birth',
      source_link_conflict: 'The {source} patient is linked to another patient, or this patient to another {source} patient',
      source_request_failed: '{source} refused the request',
      athena_practice_ambiguous: 'The organization has several athenaOne practices: add a practice column to the sheet',
      invalid_value: 'A cell holds a value its column can not take',
      identity_change: 'The sheet changes the chosen patient\'s {fields}',
      phone_owner_changed: 'The mobile phone was taken by another patient since the review: check the patient again',
      target_org_has_sub_orgs: 'The organization has sub-organizations: a new patient must go to one of them. Route the row with the organization mapping',
      athena_id_missing: 'An ACCESS sheet needs the athenaOne patient ID of every row',
      mbi_missing: 'An ACCESS sheet needs the MBI of every row',
      mbi_invalid: 'The MBI is not a valid Medicare Beneficiary Identifier',
      track_missing: 'An ACCESS sheet needs the proposed track of every row (with several tracks, each row names its own)',
      track_invalid: 'The track is not an ACCESS track (eCKM, CKM, MSK or BH)',
      track_conflict: 'Rows of this patient propose both eCKM and CKM: a patient can be in only one of them',
      track_not_supported_by_org: 'The organization does not offer the {track} track',
      consent_missing: 'Consent to participate not confirmed: the patient is added, no enrollment is proposed',
      care_update_consent_missing: 'Care-update consent not confirmed: Care Updates stay blocked until it is recorded',
      access_not_configured: 'The organization has no CMS ACCESS configuration: registration will not be possible',
      payer_id_missing: 'No payer ID in the insurance: ACCESS eligibility will need one',
      track_differs_from_enrollment: 'The patient\'s {enrollment_track} enrollment ({enrollment_status}) is in progress, and a patient can\'t be in both eCKM and CKM: no {track} enrollment is proposed',
      track_ended_before: 'The patient\'s earlier enrollment on this track has ended: a new one is proposed. Reject the patient if the file predates the ending',
      enrollment_not_enrolled: 'The patient\'s ACCESS enrollment was found ineligible: the retry is the clinician\'s',
      referral_incomplete: 'The referring provider has no Direct address or fax: complete it before Care Updates are sent',
      referring_provider_not_found: '{source} does not know the referring provider\'s NPI: no referring provider was attached',
      referring_provider_npi_missing: 'The referring provider was given by name only: add the NPI at registration',
      referring_provider_unresolved: 'The patient was referred by a provider the sheet does not name',
      referring_provider_npi_invalid: 'The referring provider\'s NPI is not a valid NPI: it was ignored',
      track_supported_by_diagnosis: 'The diagnosis evidence supports the {track} track ({qualifying_count} qualifying code(s))',
      track_not_supported_by_diagnosis: 'The diagnosis evidence does not support the {track} track ({decision}); the clinician confirms the track at registration',
      track_evidence_unavailable: 'No diagnosis evidence for the {track} track: the clinician confirms the track at registration',
    },
    sources: {
      local: 'Our patients',
      athena: 'athenaOne',
      nppes: 'NPPES',
    },
    andMore: '(and {0} more)',
    level: 'Level',
    levels: {
      error: 'Error',
      warning: 'Warning',
      note: 'Note',
    },
    rowNumber: 'Row',
    columnMappedTo: 'Mapped to {0} (#{1}): {2}',
    columnNotUsed: 'Not used by the upload',
    dataOutcomes: {
      matched: 'Found',
      no_match: 'Not found',
      choice_pending: 'Choose',
      unavailable: 'Not reachable',
      not_applicable: 'Not checked',
      failed: 'Failed',
    },
    outcomes: {
      matched: 'Patient found',
      no_match: 'Patient not found',
      choice_pending: 'Choose the patient',
      unavailable: 'Not reachable',
      not_applicable: 'Not checked',
      failed: 'Failed',
    },
    verdicts: {
      certain: 'Same patient',
      unresolved: 'Possibly the same patient',
      eliminated: 'Different patient',
      conflict: 'Conflict',
    },
    evidence: {
      same: 'Same as in the sheet',
      different: 'Different from the sheet',
      unknown: 'Nothing to compare',
    },
    chooseNone: {
      local: 'None of these: create a new patient',
      athena: 'Not in athenaOne',
      other: 'None of these',
    },
    noneChosen: {
      local: 'A new patient was chosen',
      athena: 'Not in athenaOne was chosen',
      other: 'None of these was chosen',
    },
    openOwner: {
      mbi_conflict: 'Open the patient holding the MBI',
      mrn_conflict: 'Open the patient holding the MRN',
    },
    choicePending: 'Choose the patient',
    choicePendingHint: 'Several records could be this patient: open the details and choose one before accepting',
    sourcePending: 'Being checked',
    record: 'Record',
    evidenceHeader: 'Compared with the sheet',
    verdict: 'Verdict',
    chosen: 'Chosen',
    thisIsThePatient: 'This is the patient',
    confirmCreateNew: 'Create a new patient instead of updating one of these? If the new patient collides with another patient (e.g. the MBI), the creation fails and you can fix that patient and re-check.',
    recheck: 'Re-check',
    stillChecking: '{0} still checking: {1}',
    choicesWaiting: 'Waiting for your choice: {0}',
    prepareForReview: 'Prepare patients for review',
    retryFailed: 'Retry failed patients',
    issues: 'Messages',
    uncertain: 'Uncertain',
    filterAction: 'Filter by action',
    reviewed: 'Reviewed',
    accept: 'Accept',
    reject: 'Reject',
    acceptMatched: 'Accept matched ({0})',
    acceptNew: 'Accept new patients ({0})',
    rejectRemaining: 'Reject remaining ({0})',
    confirmAcceptMatched: 'Accept {0} matched patients? Their records will be updated as shown.',
    confirmAcceptNew: 'Accept {0} new patients? They will be created as shown.',
    confirmRejectRemaining: 'Reject {0} remaining proposals? Nothing will be written for them.',
    uncertainNotIncluded: 'Uncertain patients are not included; accept them one by one.',
    decisionDone: 'Accepted: {0}. Rejected: {1}.',
    decisionAppliedLater: 'Accepted patients are written in the background; any that changed since planning come back for review.',
  },
  lastLogin: 'Last login',
  validUntil: 'Valid until',
  changeDeviceState: 'Change device state',
  events: 'Events',
  changeOrgState: 'Change administrative state',
  changeState: 'Change state',
  analytics: 'Analytics',
  maskPHIData: 'Mask PHI data',
  addEditConditions: 'Add / Edit Conditions',
  importedData: 'Imported Data',
  providerVisitSummary: 'Provider Visit Summary',
  answers: 'Answers',
  property: 'Property',
  record: 'Record',
  showExtendedData: 'Show Extended Data',
  prescriber: 'Prescriber',
  now: 'Now',
  shipping: {
    terminationShippingWarning: 'This enrollment has unfinished orders or shipments. Ending the enrollment will not stop fulfillment. Contact the person responsible for shipping.',
    terminationOrders: 'Order(s)',
    terminationShipments: 'Shipment(s)',
    endedEnrollmentWarning: 'A linked enrollment has ended. Review whether fulfillment should continue.',
    endedEnrollmentPatient: 'Patient ID: {0}',
    endedEnrollments: 'Enrollment: {0}',
    endedEnrollmentSummary: '{0} — ended {1}',

    shipments: 'Shipments',
    showInactivePatients: 'Show inactive patients',
    inactivePatientsTooltip: 'Inactive patients are paused or soft-deleted. This option includes their historical shipments only; it does not reactivate them or change access elsewhere.',
    patientsAwaitingKit: 'Patients Awaiting Kit',
    shipping: 'Shipping',
    recent: 'Recent',
    recentDeliveries: 'Recent Deliveries',
    deviceModels: 'Device Models',
    deliveriesCount: 'Deliveries',
    latestDelivered: 'Latest Delivered',
    markDeliveryReviewed: 'Mark as Reviewed',
    markDeliveryReviewedQuestion: 'Do you want to mark this delivery as reviewed?',
    deliveryReviewedSuccessfully: 'Delivery marked as reviewed',
    unmarkDeliveryReviewed: 'Un-mark as Reviewed',
    unmarkDeliveryReviewedQuestion: 'Do you want to move this delivery back to pending?',
    deliveryUnreviewedSuccessfully: 'Delivery moved back to pending',
    shippingStatus: 'Shipping Status',
    shippingAddress: 'Shipping Address',
    shippingMethod: 'Shipping Method',
    trackingNumber: 'Tracking Number',
    createShipment: 'Create Shipment',
    editShipment: 'Edit Shipment',
    sendPackage: 'Send Package',
    markAsDelivered: 'Mark as Delivered',
    markAsDeliveredQuestion: 'Do you want to mark shipment to {0} as delivered?',
    shippedDevices: 'Shipped Devices',
    shipmentStatuses: {
      new: 'In Progress',
      created: 'Created',
      in_transit: 'In Transit',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
    orderStatuses: {
      pending_review: 'Pending Review',
      rejected_by_doctor: 'Rejected by Doctor',
      draft: 'Draft',
      open: 'Open',
      in_fulfillment: 'In Fulfillment',
      partially_delivered: 'Partially Delivered',
      cancelled: 'Cancelled',
      delivered: 'Delivered',
    },
    billingStatuses: {
      billable: 'Billable',
      unbillable: 'Unbillable',
      post_billable: 'Post-billable',
      sample: 'Sample',
      reassigned: 'Reassigned',
    },
    billingStatus: 'Billing Status',
    shipmentId: 'Shipment ID',
    order: 'Order',
    orderDetails: 'Order details',
    orderId: 'Order ID',
    orderNumber: 'Order Number',
    orderCategory: 'Order Category',
    providerOrderNumber: 'Provider Order Number',
    salesOrderNumber: 'Sales Order Number',
    shippingDate: 'Shipping Date',
    shippingCreated: 'Shipping created',
    deliveryDate: 'Delivered Date',
    eta: 'ETA',
    shippingCost: 'Shipping Cost',
    selectExistingKit: 'Select existing kit',
    createNewKit: 'Create new kit',
    creatingShipmentSuccess: 'Shipment created successfully',
    shipmentDetails: 'Shipment details',
    deliveryMethod: 'Delivery Method',
    shipDirectlyToPatient: 'Ship directly to patient',
    pickupAtPharmacy: 'Pickup at pharmacy',
    shippedByPharmacy: 'Shipped by pharmacy',
    deliveryMethodLabels: {
      not_set: '-',
      ship_to_patient: 'Ship directly to patient',
      pickup_at_pharmacy: 'Pickup at pharmacy',
      shipped_by_pharmacy: 'Shipped by pharmacy',
    },
    prepareShipment: 'Prepare shipment',
    prepareAnotherShipment: 'Prepare another shipment',
    prepareShipments: 'Prepare shipments',
    prepareShipmentsQuestion: 'Do you want to prepare shipments for {0} order(s)?',
    prepareShipmentDisabledTooltip: 'Patient already has shipment in progress',
    shipmentsCreatedSuccess: 'Shipments created successfully',
    printShipmentDetails: 'Print Shipment Details',
    cancelShipment: 'Cancel Shipment',
    cancelShipmentQuestion: 'Do you want to cancel shipment to {0}?',
    cancelSmartmeterOrder: 'Cancel SmartMeter Order',
    cancelSmartmeterOrderQuestion: 'Do you want to cancel the SmartMeter order for {0}? SmartMeter will stop fulfillment and this shipment will be cancelled.',
    cancelSmartmeterOrderNotCancellable: 'This SmartMeter fulfillment is not in a cancellable state',
    kitShippedMessage: 'SMS to patient',
    orders: 'Orders',
    createOrder: 'Create Order',
    unlinkedHardwareWarning: 'This patient has hardware on {0} order(s) that are not tied to any program — check before creating another.',
    unlinkedHardwareShipped: 'shipment {0}',
    selectProgramsForOrder: 'Select the programs for this order',
    oneKitPerOrder: 'one order ships one kit - select several programs only when a single kit covers them all',
    editOrder: 'Edit Order',
    deleteOrder: 'Delete Order',
    cancelOrder: 'Cancel Order',
    deleteOrderQuestion: 'Do you want to delete order {0}?',
    cancelOrderQuestion: 'Do you want to cancel order {0}?',
    placeOrderQuestion: 'Do you want to place order {0}?',
    placeOrder: 'Place Order',
    smartmeterOrder: 'Smartmeter Order',
    smartmeterOrderId: 'Smartmeter Order ID',
    placeSmartmeterOrder: 'Place order with Smartmeter',
    smartmeterOrderAlreadyPlaced: 'Smartmeter order already placed',
    placeSmartmeterOrderQuestion: 'Do you want to place order for devices: {0} for patient {1} with Smartmeter?',
    smartmeterOrderPlacedSuccessfully: 'Smartmeter order placed successfully',
    variants: 'Variants',
    smartmeterSku: 'Smartmeter SKU',
    smartmeterConfigureSkuFor: 'Configure Smartmeter SKU for {0}',
    smartmeterConfigureSkuFailed: 'Failed to configure Smartmeter SKU',
    smartmeterSaveAnyway: 'Save anyway?',
    smartmeterProposedSkusForModel: 'Proposed SKUs for {0}',
    smartmeterOtherTypeKits: 'Other {0} kits',
    smartmeterDifferentDeviceKits: 'Different device kits (requires override)',
    smartmeterAccessorySkus: 'Accessories / services (ship no device)',
    smartmeterOverrideSku: 'Override SKU (optional)',
    smartmeterNoOverride: 'No override',
    smartmeterAckSkuWithoutDevice: 'I confirm this order intentionally ships accessory/service items without a device.',
    smartmeterAckSkuModelMismatch: 'I confirm the substitution with a different device category is intended.',
    smartmeterAddress2Rejected: 'I confirm the address line 2 is correct and should be used for shipping.',
    fixAddress2OrConfirm: 'Please fix address line 2 or confirm it is correct.',
    smartmeterOrderStatusEnum: {
      submitted: 'Submitted',
      shipped: 'Shipped',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      error: 'Error',
    },
    fulfillmentProvider: 'Fulfillment Provider',
    vendorStatus: 'Vendor Status',
    recipientName: 'Recipient Name',
    recipientPhone: 'Recipient Phone',
    recipientEmail: 'Recipient Email',
    orderType: 'Order Type',
    orderTypes: {
      standard: 'Standard',
      sample: 'Sample',
      replacement: 'Replacement',
    },
    orderCategories: {
      bulk: 'Bulk',
      direct: 'Direct',
    },
    shippingFlows: {
      outbound: 'Outbound',
      return: 'Return',
    },
    shippingFlow: 'Shipping Flow',
    patientAddress: 'Patient Address',
    contactDetails: 'Contact Details',
    organizationAddress: 'Organization Address',
    patientContactDetails: 'Patient Contact Details',
    organizationContactDetails: 'Organization Contact Details',
    targetOrganization: 'Target Organization',
    billedOrganization: 'Billed Organization',
    isPatientBilled: 'Is patient billed?',
    invoices: 'Invoices',
    itemsCount: 'Items Count',
    customer: 'Customer',
    invoiceDate: 'Invoice Date',
    shipmentDate: 'Shipment Date',
    assignedOrganizationDate: 'Assigned to Organization Date',
    unassignedOrganizationDate: 'Unassigned from Organization Date',
    orderNotes: 'Order Notes',
    deliveryDateBeforeInTransit: 'Delivery date cannot be before in transit date ({0})',
    deliveryDateBeforeCreatedAt: 'Delivery date cannot be before shipment creation date ({0})',
    createMapping: 'Create Mapping',
    acceptOrder: 'Accept Order',
    rejectOrder: 'Reject Order',
    acceptOrderQuestion: 'Do you want to accept order for patient {0}?',
    rejectOrderQuestion: 'Do you want to reject order for patient {0}?',
    orderAcceptedSuccessfully: 'Order accepted successfully',
    orderRejectedSuccessfully: 'Order rejected successfully',
    rejectOrderReason: 'Reason for rejecting order',
    orderCreated: 'Order created',
    smartOrderCreatedInfo: 'We`ve created a device order for patient {0}. Before we can ship the devices, the order needs to be accepted by your organization. Oders can be accepted or rejected in the "Shipping" → "Orders" tab. Click "Go to Orders" to navigate to Orders page.',
    goToOrders: 'Go to Orders',
    sendToReview: 'Send to review',
    createReturnShipmentOrder: 'Create return shipment order',
    pendingReturns: 'Pending Returns',
    devicesToReturn: 'Devices to return',
    newOrder: 'New Order',
    returnOrder: 'Return Order',
    returnDevices: 'Return Devices',
    warehouseToShipDevices: 'Warehouse to ship devices',
    markAsReturnedByPatient: 'Mark as Returned by Patient to Pharmacy',
    markAsReturnedByPatientQuestion: 'Do you want to mark kit {0} as returned by patient to pharmacy?',
    markAsReturnedByPatientSuccess: 'Kit marked as returned by patient to pharmacy successfully',
    droppedOffDate: 'Dropped off date',
    kitsToReturn: 'Kits to Return',
    sharedKitReturnWarning: 'This kit is also used by another active enrollment. An automatic return will not be created while that enrollment remains active.',
    whatHappensToKit: 'What should happen to patient`s kit? ',
    returnToWarehouse: 'Return to warehouse',
    keepWithPatient: 'Keep with patient',
    waiveReturn: 'Waive Return',
    waiveReturnQuestion: 'Do you want to waive return for kit {0}?',
    waiveReturnSuccess: 'Kit return waived successfully',
    waiveReturnReason: 'Reason for waiving return',
    waivedDate: 'Waived date',
    waivedBy: 'Waived by',
    revokeWaiverReturn: 'Revoke Return Waiver',
    revokeWaiverReturnQuestion: 'Do you want to revoke return waiver for kit {0}?',
    revokeWaiverReturnSuccess: 'Kit return waiver revoked successfully',
    receivedAt: 'Received at',
    releaseFromInspection: 'Release from Inspection',
    releaseFromInspectionQuestion: 'Do you want to release kit {0} from inspection?',
    releaseFromInspectionSuccess: 'Kit released from inspection successfully',
    selectVariant: 'Select Variant',
    selectVariantForDevice: 'Select Variant for {0} Device(s)',
    variantFor: 'Variant for {0}',
    deviceUnavailable: 'Unavailable',
    deviceUnavailableRemove: 'No longer available - remove it from the order or reduce its quantity to 0',
    catalogLoadFailed: 'Could not load the device catalog. The order cannot be saved until the catalog is loaded.',
    catalogRetry: 'Retry',
  },
  print: 'Print',
  printAll: 'Print All',
  inProgress: 'In Progress',
  defaultReminders: 'Default Reminders',
  files: 'Files',
  deviceInstructionVideoSection: 'Device instruction videos',
  deviceInstructionHelpLabel: 'About device instruction videos',
  deviceInstructionHelp: 'Links to these videos are sent in SMS messages using the [DeviceInstructions] tag. Organization settings take precedence over global settings.',
  deviceInstructionAddFile: 'Add file',
  deviceInstructionAllLanguages: 'All languages',
  deviceInstructionSource: 'Source',
  deviceInstructionGlobal: 'Global defaults',
  deviceInstructionOrgLevels: { global: 'Global', partner: 'Partner', client: 'Client', location: 'Location' },
  deviceInstructionNotConfigured: 'Not configured',
  deviceInstructionOwnSetting: 'Own setting',
  deviceInstructionTryAgain: 'Try again',
  deviceInstructionAssignedFile: 'File name',
  deviceInstructionVideoLanguage: 'Video language: {0}',
  deviceInstructionRemoveAssignment: 'Remove assignment',
  deviceInstructionRemoveAssignmentConfirm: 'Remove the video assignment for {0} ({1})? An inherited video may appear instead.',
  deviceInstructionSelectPurpose: 'Select a file purpose',
  deviceInstructionVideoPurpose: 'Device instruction video',
  deviceInstructionUploadFile: 'Upload file',
  deviceInstructionAssignAt: 'Assign at',
  deviceInstructionSelectOrganization: 'Select an organization',
  deviceInstructionOrganizationsError: 'Could not load organizations.',
  deviceInstructionAssignStored: 'Assign video',
  deviceInstructionPurpose: 'Purpose',
  deviceInstructionDeviceType: 'Device type',
  deviceInstructionNoTypes: 'No instruction videos are assigned here or inherited.',
  deviceInstructionNoAssignments: 'No instruction videos are assigned.',
  deviceInstructionInherited: 'Inherited',
  deviceInstructionSelector: 'Device',
  deviceInstructionSelectorKind: 'Apply to',
  deviceInstructionModel: 'Model',
  deviceInstructionModelLabel: '{0} {1} ({2})',
  deviceInstructionTypeLabel: '{0}',
  deviceInstructionModelFallsBackToType: 'This model uses the video for device type {0}.',
  deviceInstructionSelectKind: 'Select device type or model',
  deviceInstructionSelectType: 'Select a device type',
  deviceInstructionSearchModels: 'Search manufacturer or model',
  deviceInstructionAlreadyConfigured: 'This device already has a video at this level. Use Replace video in its row below.',
  deviceInstructionChooseFileFirst: 'Choose a video before uploading.',
  deviceInstructionTargetsError: 'Could not load available devices.',
  deviceInstructionPreview: 'Preview',
  deviceInstructionHidePreview: 'Hide preview',
  deviceInstructionChooseFile: 'Choose video',
  deviceInstructionReplace: 'Replace video',
  deviceInstructionUploading: 'Uploading…',
  deviceInstructionLocalPreview: 'Selected video for {0}',
  deviceInstructionCurrentPreview: 'Current video for {0}',
  deviceInstructionInvalidFile: 'Choose an MP4 or WebM video with a matching file extension.',
  deviceInstructionFileTooLarge: 'Choose a nonempty video smaller than 250 MiB.',
  deviceInstructionLoadError: 'Could not load instruction videos.',
  deviceInstructionPreviewError: 'Could not preview this video.',
  deviceInstructionUploadError: 'Could not upload the video.',
  deviceInstructionFileAlreadyExists: 'A file with this name already exists in storage.',
  deviceInstructionCompleteUploadError: 'The file uploaded, but could not be registered.',
  deviceInstructionReplaceTarget: 'Replace video for {0} ({1})',
  deviceInstructionStorageFiles: 'Storage files',
  deviceInstructionObjectName: 'Object name',
  deviceInstructionFileType: 'Type',
  deviceInstructionFileSize: 'Size',
  deviceInstructionCreated: 'Created',
  deviceInstructionStorageStatus: 'Status and usage',
  deviceInstructionAvailable: 'Available',
  deviceInstructionMissingStorage: 'Missing from storage',
  deviceInstructionMissingStorageLabel: 'Warning: file missing from storage',
  deviceInstructionMissingStorageHelp: 'This database file has no matching object in storage.',
  deviceInstructionUnregistered: 'Not registered',
  deviceInstructionUnregisteredLabel: 'Unknown storage file',
  deviceInstructionUnregisteredHelp: 'This storage object is not registered in the database.',
  deviceInstructionUsedOnce: 'Used by 1 assignment',
  deviceInstructionUsedCount: 'Used by {0} assignments',
  deviceInstructionNoStorageFiles: 'No files were found in storage or the database.',
  deviceInstructionLoadingStorage: 'Loading storage files…',
  deviceInstructionStorageLoadError: 'Could not load storage files.',
  deviceInstructionStoredVideo: 'Stored video',
  deviceInstructionSelectStoredVideo: 'Select a stored video',
  deviceInstructionNoStoredVideos: 'No assignable videos are available in storage.',
  deviceInstructionAssigning: 'Assigning…',
  deviceInstructionStoredPreview: 'Stored video {0}',
  deviceInstructionStoredPreviewError: 'Could not preview the stored video.',
  deviceInstructionStoredAssignError: 'Could not assign the stored video.',
  deviceInstructionDeleteStored: 'Delete stored file',
  deviceInstructionDeleteStoredFile: 'Delete stored file {0}',
  deviceInstructionDeleteStoredConfirm: 'Delete {0} from storage?',
  defaultRemindersEnum: {
    "early_sms": 'Early SMS',
    "late_sms": 'Late SMS',
    "on_time_sms": 'On Time SMS',
    "low_battery_sms": 'Low Battery SMS',
    "missed_doses_sms": 'Missed Doses SMS',
    "missed_meas_sms": 'Missed Measurements SMS',
    "welcome_rtm_msg_sms": 'Welcome RTM Message SMS',
    "welcome_rpm_msg_sms": 'Welcome RPM Message SMS',
    "prepackage_rtm_msg_sms": 'Prepackage RTM Message SMS',
    "prepackage_rpm_msg_sms": 'Prepackage RPM Message SMS',
    "shipment_delivered_sms": 'Shipment Delivered SMS',
    "return_shipment_patient_sms": 'Return Shipment Patient SMS',
    "caregiver_invitation_sms": 'Caregiver Invitation SMS',
    "caregiver_deleted_sms": 'Caregiver Deleted SMS',
    "caregiver_subscribed_sms": 'Caregiver Subscribed SMS',
    "caregiver_unsubscribed_sms": 'Caregiver Unsubscribed SMS',
    "patient_alert_sms": 'Patient Alert SMS',
    "caregiver_alert_sms": 'Caregiver Alert SMS',
    "careprovider_alert_sms": 'Care Provider Alert SMS',
    "televisit_sms": 'Televisit SMS',
    "televisit_no_link_sms": 'Televisit No Link SMS',
    "first_take_congratulations_sms": 'First Take Congratulations SMS',
    "streak_achievement_sms": 'Streak Achievement SMS',
    "back_on_track_sms": 'Back on Track SMS',
    "dose_confirmed_sms": 'Dose Confirmed SMS',
    "first_dose_reminder_sms": 'First Dose Reminder SMS',
    "daily_evening_missed_dose_sms": 'Daily Evening Missed Dose SMS',
    "enrollment_completed_sms": 'Enrollment Completed SMS',
    "unused_device_sms": 'Unused Device SMS',
    "fault_cap_left_open": 'Cap Left Open SMS',
    "communication_lost_sms": 'Communication Lost SMS',
    "sms_auto_reply": 'Auto Reply SMS',
    "caregiver_missed_meas_sms": 'Caregiver Missed Measurement SMS',
    "careprovider_missed_meas_sms": 'Care Provider Missed Measurement SMS',
  },
  milestoneReminderResetInfo: 'Resetting a milestone message clears all organization-specific milestone messages for that language. Inherited messages will apply.',
  defaultRemindersSaved: 'Default reminders saved.',
  editDefaultReminders: 'Edit Default Reminders',
  printedAt: 'Printed at: {0}',
  thresholds: 'Thresholds',
  actionOptionOff: '{0} (OFF)',
  actionOptionOn: '{0} (ON)',
  isOrderable: 'Is Orderable',
  allSelectedDefaultsEnabled: 'All selected work types are already enabled by default.',
  allSelectedDefaultsDisabled: 'All selected work types are already disabled by default.',
  allSelectedTasksEnabled: 'All selected tasks are already enabled.',
  allSelectedTasksDisabled: 'All selected tasks are already disabled.',
  globalTaskDefault: 'Default for new organizations',
  systemWorkTypeMetadataExplanation: 'System work type: its name, sequence and Tracks time setting are protected and cannot be changed.',
  globalTaskDefaultExplanation: 'Applies only to newly created organizations. Existing organizations are not changed.',
  enableTaskByDefault: 'Enable by default',
  disableTaskByDefault: 'Disable by default',
  workTypeMandatoryOrganizations: 'Mandatory in organizations: {0}.',
  workTypeAutoStartOrganizations: 'Auto-start task in organizations: {0}.',
  workTypeDefaultsUpdated: 'Tasks updated',
  workTypeDeleted: 'Task deleted',
  unableToUpdateWorkTypeDefaults: 'Unable to update default work types',
  unableToDeleteWorkType: 'Unable to delete task',
  unableToSaveWorkType: 'Unable to save task',
  mandatoryTasks: 'Mandatory Tasks',
  missingMandatoryTasks: 'Missing Mandatory Task(s)',
  missingCPTCodes: 'Missing CPT code(s)',
  missingXMandatoryTasks: 'Missing {0} Mandatory Task(s)',
  cannotDisableMandatoryTasks: 'Mandatory tasks cannot be disabled.',
  selectMandatoryTasksFor: 'Select Mandatory Tasks for {0}',
  selectTask: 'Select Task',
  recentlyUsedTasks: 'Recently Used Tasks',
  otherTasks: 'Other Tasks',
  comments: 'Comments',
  comment: 'Comment',
  dateOfEariestAlert: 'Date of earliest alert',
  reviewChart: 'Review Chart',
  selected: 'Selected',
  workTypes: 'Work Types',
  workType: 'Work Type',
  changeStatus: 'Change Status',
  eligibility: 'Eligibility',
  checkEligibility: 'Check Eligibility',
  eligibilityStatus: 'Eligibility Status',
  refreshEligibilityStatus: 'Refresh Eligibility Status',
  eligibilityCheckInProgress: 'Eligibility check in progress',
  noInsurancePlansFound: 'No insurance plans found',
  confidenceScore: 'Confidence Score',
  insurancePlans: 'Insurance Plans',
  lastChecked: 'Last Checked',
  planName: 'Plan Name',
  serviceStatus: 'Service Status',
  coverageDates: 'Coverage Dates',
  insuranceType: 'Insurance type',
  // Two-factor authentication settings
  twoFactorSettings: {
    title: 'Security',
    status: 'Two-Factor Authentication',
    enable: 'Enable 2FA',
    disable: 'Disable 2FA',
    enabled: 'Enabled',
    disabled: 'Disabled',
    backupCodesRemaining: 'Backup Codes Remaining',
    regenerateCodes: 'Regenerate',
    setupTitle: 'Set Up Two-Factor Authentication',
    setupInstructions: 'Scan this QR code with your authenticator app (such as Google Authenticator or Authy):',
    manualEntry: 'Or enter this code manually:',
    enterCode: 'Enter the 6-digit code from your app:',
    disableTitle: 'Disable Two-Factor Authentication',
    disableWarning: 'Enter your password to disable two-factor authentication. This will make your account less secure.',
    regenerateTitle: 'Regenerate Backup Codes',
    regenerateWarning: 'Enter your password to regenerate backup codes. Your old codes will no longer work.',
    backupCodesTitle: 'Your Backup Codes',
    backupCodesWarning: 'Save these codes in a secure location. Each code can only be used once.',
    passwordRequired: 'Password is required',
    loadError: 'Failed to load 2FA status',
    enableError: 'Failed to start 2FA setup',
    disableError: 'Failed to disable 2FA',
    regenerateError: 'Failed to regenerate backup codes',
  },
  timerInactivityWarning: 'The timer detected no patient monitoring activity and will stop in {0} seconds unless you click "Continue Timer."',
  timerStoppedDueToInactivity: 'The timer has stopped because no patient monitoring activity was detected for 5:00 minutes. To start the timer again, click "Start Timer."',
  patientNotActivatedTimerWarning: 'This patient does not have an activated device. Click "Start Timer" to record the current task, or leave the timer stopped if you do not want to record time. By clicking "Start Timer," you acknowledge that the task time will be recorded and may contribute to a time-based billing code for the applicable billing month. Submission of any resulting code for reimbursement is at the user’s discretion.',
  recordedBeforeActivation: 'Pre-activation',
  recordedBeforeActivationTooltip: 'This task was recorded before the enrollment was activated.',
  recordedAfterActivationTooltip: 'This task was recorded after the enrollment was activated.',
  billingDayTooltip:
    "The day this counts toward for billing, in the patient's time zone when it was recorded. It can differ from the date of the start and end times, which are shown in your time zone.",
  timeInPortalTimezoneTooltip: 'Shown in your time zone ({0}).',
  roleSwitcher: {
    title: 'Switch Role',
    switchRole: 'Switch Role',
    switching: 'Switching...',
    resetToNative: 'Reset to Native Role',
    resetting: 'Resetting...',
    currentRole: 'Current',
    switched: 'Switched',
    defaultRole: 'Role',
    allFacilities: 'All Facilities',
    notAvailable: 'Role switching is not available for your account.',
    noRolesAvailable: 'No switchable roles available.',
    errorLoading: 'Failed to load role switching options.',
    errorSwitching: 'Failed to switch role. Please try again.',
    errorResetting: 'Failed to reset to native role. Please try again.',
    patientRoleCannotBeExtended: 'Patient role cannot be extended to another organization.',
    inherentSwitchableRoles: 'Roles may appear in the Switch Role dropdown by design, even if not explicitly assigned. Organization managers have inherent switchable roles that allow switching to additional roles within the organization.',
  },
  removeRole: 'Remove Role',
  removeRoleWarning: 'Are you sure you want to remove the role "{0}" from user {1}?',
  copyCellToClipboard: 'Copy cell to clipboard',
  copyRowToClipboard: 'Copy row to clipboard',
  sequence: 'Sequence',
  sequenceMustBeInteger: 'Sequence must be an integer',
  editWorkType: 'Edit Work Type',
  addWorkType: 'Add Work Type',
  isDefaultTask: 'Is default task',
  isTimerDefaultTask: 'Is default task for timer',
  tracksTime: 'Tracks time',
  previousTimerDefaultTaskWarning: 'Setting this task as default for timer will unset previously set task "{0}"',
  newTimerDefaultTask: 'New default task for timer',
  setAsDefaultTaskForTimer: 'Set as default task for timer',
  setAsDefaultTaskForTimerWarning: 'Do you want to set "{0}" as default task for timer? This will unset previously set task "{1}"',
  clearDefaultTaskForTimer: 'Clear default task for timer',
  clearDefaultTaskForTimerWarning: 'Do you want to clear "{0}" as the default task for the timer? The organization fallback task may be used instead.',
  timerDefaultTaskCleared: 'Default task for timer cleared',
  enabledForOrg: 'Enabled for organization',
  includeEmptyDataInExport: 'Export data for all device types and CPT codes, including those with no data in the selected date range',
  notSet: 'Not set',
  annotations: 'Annotations',
  editAnnotations: 'Edit Annotations',
  color: 'Color',
  quantity: 'Quantity',
  requiresHub: 'Requires Hub',
  changedBy: 'Changed by',
  oldValue: 'Old value',
  newValue: 'New value',
  timelineEventTypesEnum: {
    status_changed: 'Status changed',
    kit_added: 'Kit added',
    kit_removed: 'Kit removed',
    org_assigned: 'Organization assigned',
    org_unassigned: 'Organization unassigned',
    billing_record_created: 'Billing record created',
    shipment_new: 'New Shipment',
    shipment_created: 'Shipment created',
    shipment_in_transit: 'Shipment in transit',
    shipment_delivered: 'Shipment delivered',
    shipment_cancelled: 'Shipment cancelled',
  },
  saveSettings: 'Save Settings',
  deviceInvoices: {
    deviceInvoices: 'Device Invoices',
    deviceInvoice: 'Device Invoice',
    initial: 'Initial Cost',
    recurring: 'Recurring Cost',
    invoiceData: 'Invoice Data',
    pricing: 'Pricing',
    billingOrg: 'Billing Org',
    item: 'Item',
    shippingItemPrefix: 'Shipping',
    shippingItemSummary: 'Shipping ({0} devices)',
    kittingFee: 'Kitting Fee',
    fixedShippingFee: 'Fixed Shipping Fee',
    dataFee: 'Data Fee',
    price: 'Price',
    readyForApproval: 'Ready for approval',
    approved: 'Approved',
    actionRequired: 'Action required',
    canceled: 'Canceled',
    markReady: 'Mark as ready for approval',
    billingMonth: 'Billing month',
    invoiceUuid: 'Invoice UUID',
    sourceDeviceId: 'Source device ID',
    billingEndDate: 'Billing end date',
    invoiceDate: 'Invoice date',
    isSample: 'Is sample',
    sample: 'Sample',
    regular: 'Regular',
    editSampleStatus: 'Edit sample status',
    markDeviceAsSampleWarning: 'Mark this device as sample? Editable device invoices will be recalculated.',
    markDeviceAsRegularWarning: 'Mark this device as regular? Editable device invoices will be recalculated.',
    sampleStatusChangeWarning: 'Editable device invoices will be recalculated.',
    sampleStatusUpdated: 'Sample status updated successfully',
    invoiceIssuesEnum: {
      pricing_definition_missing: 'Missing pricing',
      multiple_assignments: 'Multiple assignments',
      automatic_assignment: 'Device added automatically outside the official process',
      missing_program: 'Missing program',
      multiple_programs_in_kit_month: 'Multiple programs',
      new_enrollment_assigned: 'New enrollment assigned',
      multiple_base_devices_in_kit_month: 'Multiple base devices',
      missing_kit_assignment_timestamp: 'Missing kit assignment timestamp',
      missing_kit_assignment: 'Missing kit assignment',
      missing_enrollment: 'Missing enrollment',
      'enrollment terminated but kit still assigned to organization': 'Enrollment terminated but kit still assigned',
    },
    invoiceUpdated: 'Invoice updated successfully',
    invoiceUpdateFailed: 'Failed to update invoice',
    setInvoiceDate: 'Set Invoice Date',
    changeInvoiceDate: 'Change Invoice Date',
    clearInvoiceDate: 'Clear Invoice Date',
    clearInvoiceDateWarning: 'You are going to clear the invoice date for the selected approved invoices.',
    invoiceDateUpdated: 'Invoice date updated successfully',
    invoiceDateCleared: 'Invoice date cleared successfully',
    invoiceDateUpdateFailed: 'Failed to update invoice date',
    invoiceDateRequired: 'Invoice date is required',
    invoicesCanceled: 'Invoices canceled successfully',
    cancelInvoices: 'Cancel Invoices',
    restoreInvoice: 'Restore Invoice',
    restoreInvoices: 'Restore Invoices',
    invoicesRestored: 'Invoices restored successfully',
    restoreInvoicesWarning: 'Are you sure you want to restore the selected canceled invoices? Restored invoices will re-enter the review flow.',
    batchActionWarning: 'You are going to modify {0} elements.',
    batchActionSingleWarning: 'You are going to modify 1 element.',
    markInvoicesReady: 'Mark Invoices as Ready for Approval',
    invoicesMarkedReady: 'Invoices marked as ready for approval successfully',
    approveInvoices: 'Approve Invoices',
    invoicesApproved: 'Invoices approved successfully',
    requestAction: 'Request Action',
    actionRequested: 'Action requested successfully',
    recalculateInvoices: 'Recalculate Invoices',
    recalculateInvoice: 'Recalculate Invoice',
    invoicesRecalculated: 'Invoices recalculated successfully',
    batchActionAllActionRequiredWarning: 'This may modify all Action required invoices.',
    recalculateInvoicesWarning: 'Are you sure you want to recalculate selected invoices? This will update invoice amounts based on current device assignments and pricing, and may change invoice issues.',
    recalculateAllActionRequiredInvoicesWarning: 'You are going to recalculate invoices in Action required. This will update invoice amounts based on current device assignments and pricing, and may change invoice issues.',
    initialDownloadDateRangeInfo: 'The selected date range applies to the shipment date. For invoices without a shipment, the date added to org is used.',
    recurringDownloadDateRangeInfo: 'The selected date range applies to the billing period shown on the invoice.',
    generateInvoicesForMonth: 'Generate Invoices for Month',
    recurringStartedMonthRequired: 'Select current or past month.',
    invoiceHistoryEntryTypes: {
      commented: 'Commented',
      field_edit: 'Field Edit',
      generated: 'Generated',
      recalculated: 'Recalculated',
      approved: 'Approved',
      canceled: 'Canceled',
      ready_for_approval: 'Ready for Approval',
      action_required: 'Action Required',
      marked_ready: 'Marked Ready for Approval',
      restored: 'Restored',
    },
    relationTypes: {
      same_device: 'Same device',
      same_billing_source: 'Same billing source',
    },
    pricingScope: 'Pricing Scope',
    defaultPrice: 'Default Price',
    organizationPrice: 'Organization Price',
    addPrice: 'Add Price',
    editPrice: 'Edit Price',
    deletePrice: 'Delete Price',
    deletePriceWarning: 'Are you sure you want to delete this price?',
    priceDeleted: 'Price deleted successfully',
    pricingType: "Pricing Type",
    priceHistory: 'Price History',
    viewPricesHistory: 'View Prices History',
    noPricesHistory: 'No price changes history available for this price',
    setNewPrice: 'Set new price',
    itemDescription: 'Item description',
  },
  issues: 'Issues',
  continueWithSSO: 'Continue with SSO',
  checking: 'Checking...',
  enterEmailOrUsername: 'Enter your email or username to continue with SSO.',
  operationCompleted: 'Operation completed successfully',
  updated: 'Updated',
  baselined: 'Baselined',
  relatedItems: 'Related Items',
  effectiveFrom: 'Effective from',
  effectiveTo: 'Effective to',
  editPrice: 'Edit Price',
  addComment: 'Add Comment',
  invalidUsernameOrPassword: 'Invalid username or password',
  internalError: 'Something went wrong. Please try again.',
  submittedDate: 'Submitted date',
  cancelledDate: 'Cancelled date',
  attempts: 'Attempts',
  errorMessage: 'Error message',
  timerStoppedReasons: {
    active: 'Timer is currently running',
    manual: 'Timer was stopped manually',
    inactivity: 'Timer was stopped due to inactivity',
    interrupted: 'Timer session was interrupted',
  },
  saveConfiguration: 'Save Configuration',
  searchByNameAndDob: 'Search in Athena by Name and DOB',
  searchByAthenaPatientId: 'Search in Athena by Athena Patient ID',
  searchResults: 'Search Results',
  noPatientsFound: 'No patients found',
  selectPatient: 'Select Patient',
  mismatchBetweenPatientAndAthena: 'Mismatch between patient and Athena record',
  patientOverrideWarning: 'After selecting patient, the edited record will be overridden by data from Athena',
  vitalValue: 'Vital Value',
  globalDefaults: 'Global defaults',
  restrictedOrganization: 'Restricted organization',
  orgLevels: { global: 'Global', partner: 'Partner', client: 'Client', location: 'Location', 'care-provider': 'Care Provider' },
  sourceLanguage: '{0} ({1})',
  reminderPreviewError: 'Unable to load the impact preview. Please try again before saving.',
  reminderPreviewRetry: 'Retry preview',
  reminderImpactApplies: 'This change will affect {0}:',
  reminderImpactOverridden: 'This change will not affect {0} because they use a more specific template:',
  reminderImpactFallback: 'The reset will also affect {0}:',
  reminderImpactOneClient: '1 client',
  reminderImpactManyClients: '{0} clients',
  reminderImpactOneLocation: '1 location',
  reminderImpactManyLocations: '{0} locations',
  createOrgSpecificTemplate: 'Create Organization Specific Template',
  createLanguageSpecificTemplate: 'Create Language Specific Template',
  clearOrgSpecificTemplate: 'Clear Organization Specific Template',
  clearLanguageSpecificTemplate: 'Clear Language Specific Template',
  insufficientPermissionsToEditTemplate: 'You do not have sufficient permissions to edit this template.',
  editCurrentlyUsedTemplate: 'Edit Currently Used Template: {0}',
  tags: 'Tags',
  patientActions: {
    notHidden: 'Not hidden',
    title: 'Actions',
    assignedTo: 'Assigned to',
    unassigned: 'Unassigned',
    me: 'Me',
    anyone: 'Anyone',
    assignee: 'Assignee',
    patient: 'Patient',
    action: 'Action',
    state: 'State',
    open: 'Open',
    completed: 'Completed',
    allStatuses: 'Open and completed',
    allPriorities: 'All priorities',
    priority: 'Priority',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    deadline: 'Deadline',
    overdue: 'Overdue',
    overdueOnly: 'Overdue only',
    showHidden: 'Hidden only',
    hiddenUntil: 'Hidden until {0}',
    edit: 'Edit action',
    assignToMe: 'Assign to me',
    hide: 'Hide',
    hideNo: 'Do not hide',
    hideDay: 'For 1 day',
    hideWeek: 'For 1 week',
    hideUntil: 'Until date',
    unhide: 'Show again',
    complete: 'Complete',
    reopen: 'Re-open',
    closedAutomatically: 'This action is closed automatically once it no longer applies. You can assign or hide it.',
    completedByChartReview: 'Complete it with Review on the patient page.',
    completedByCareUpdate: 'This action closes when its Care Update is completed.',
    completeWarning: 'This action is normally closed automatically. Complete it anyway?',
    history: 'History',
    noHistory: 'No changes recorded',
    historyStart: 'History starts here',
    unknownActor: 'Unknown',
    completedBy: 'Completed by {0}',
    completedAutomatically: 'Completed automatically',
    createdBy: 'Created by {0}',
    saved: 'Action saved',
    requestFailed: 'The request failed',
    fields: {
      content: 'Text',
      viewable_by: 'Visible to',
      is_action: 'Action',
      completed_at: 'Completed at',
      completed_by: 'Completed by',
      priority: 'Priority',
      assignee: 'Assignee',
      due_at: 'Deadline',
      past_deadline: 'Past deadline',
      hidden_until: 'Hidden until',
      closable_by: 'Closed by',
    },
    closableBy: {
      system: 'The system',
      human_with_warning: 'People (normally automatic)',
      human: 'People',
    },
    accessType: 'ACCESS action',
    allAccessTypes: 'All actions',
    track: 'Track',
    allTracks: 'All tracks',
    type: 'Type',
    resultCode: 'CMS result',
    resolution: 'Resolution',
    resolutionHint: 'Optional: what was done, or why the path was closed',
    recheckEligibility: 'Check eligibility again',
    recheckSubmitted: 'Eligibility check submitted; this action closes when CMS no longer reports a mismatch',
    accessTypes: {
      access_care_initiation: 'Care initiation',
      access_care_escalation: 'Care escalation',
      access_care_completion: 'Care completion',
      not_eligible_ack: 'Not eligible – acknowledge',
      proceed_to_alignment: 'Eligible – proceed to alignment',
      proceed_to_switch: 'Eligible to switch – proceed to switch',
      data_mismatch: 'Data mismatch – correct data',
      recheck_window_expired: 'Re-check window expired',
    },
  },
  surveys: {
    surveys: 'Surveys',
    createSurvey: 'Create survey',
    newSurveyTitle: 'New survey',
    untitledSurvey: 'Untitled survey',
    untitledQuestion: 'Untitled question',
    title: 'Title',
    description: 'Description',
    statusDraft: 'Draft, not published',
    publishedVersion: 'Published, version {0}',
    unpublishedChanges: 'unpublished changes',
    unsavedChanges: 'unsaved changes',
    sent: 'Sent',
    completed: 'Completed',
    lastChanged: 'Last changed',
    builder: 'Builder',
    responses: 'Responses',
    archive: 'Archive',
    archived: 'Survey archived',
    archiveConfirm: 'Archive the survey "{0}"? Links already sent keep working until they expire.',
    publish: 'Publish',
    publishedNotification: 'Version {0} published',
    publishFailed: 'The survey could not be published',
    publishBeforeSending: 'Publish the survey before sending it',
    send: 'Send survey',
    sendNow: 'Send',
    sendTitle: 'Send survey (version {0})',
    sendFailed: 'The survey could not be sent',
    sentNotification: 'The survey is being sent to {0} patient(s)',
    draftSaved: 'Draft saved',
    saveFailed: 'The change could not be saved',
    loadFailed: 'Surveys could not be loaded',
    downloadFailed: 'The file could not be downloaded',
    pageN: 'Page {0}',
    pageTitlePlaceholder: 'Page title (optional)',
    deletePage: 'Delete page',
    addPage: 'Add page',
    deleteQuestion: 'Delete question',
    dragToReorder: 'Drag to reorder',
    information: 'Information',
    informationText: 'Information text',
    questionText: 'Question',
    questionId: 'Question ID (export column)',
    required: 'Answer required',
    options: 'Options',
    optionN: 'Option {0}',
    addOption: 'Add option',
    removeOption: 'Remove option',
    minimum: 'Minimum',
    maximum: 'Maximum',
    maxLength: 'Maximum length',
    showOnlyIf: 'Show this question only if',
    showPageOnlyIf: 'Show this page only if',
    addCondition: 'Show only if…',
    addPageCondition: 'Show this page only if…',
    conditionMatch: 'Match',
    behaviorAll: 'all of the rules',
    behaviorAny: 'any of the rules',
    question: 'Question',
    operator: 'Condition',
    value: 'Value',
    addRule: 'Add rule',
    removeRule: 'Remove rule',
    patientPreview: 'Patient preview',
    problemsToFix: 'Fix before publishing',
    itemTypes: {
      single_choice: 'Single choice',
      multi_choice: 'Multiple choice',
      scale: 'Rating scale',
      boolean: 'Yes / No',
      integer: 'Whole number',
      decimal: 'Decimal number',
      date: 'Date',
      short_text: 'Short text',
      long_text: 'Long text',
      display: 'Information text',
    },
    operators: {
      answered: 'is answered',
      not_answered: 'is not answered',
      equals: 'is',
      not_equals: 'is not',
      contains: 'includes',
      not_contains: 'does not include',
      gt: 'is greater than',
      gte: 'is at least',
      lt: 'is less than',
      lte: 'is at most',
    },
    channel: 'Send by',
    channels: { sms: 'SMS', email: 'Email' },
    recipients: 'Recipients',
    recipientsByFilter: 'Patients matching filters',
    recipientsSelected: 'Selected patients',
    patients: 'Patients',
    searchPatients: 'Search patients',
    conditions: 'Conditions',
    anyCondition: 'Any condition',
    facilities: 'Facilities',
    anyFacility: 'Any facility',
    medication: 'Medication',
    medicationPlaceholder: 'Any medication, or part of its name',
    linkValidDays: 'Link valid for (days)',
    linkValidDaysRange: 'Between 1 and 60 days',
    countingRecipients: 'Counting recipients…',
    willReceive: '{0} patient(s) will receive the survey.',
    nobodyToSend: 'Nobody can receive the survey with these settings. Change the recipients or the channel.',
    publishedTypeLocked: 'This question was published, so its type can’t change. Add a new question instead.',
    sendSurveyTitle: 'Send a survey',
    patientField: 'Patient',
    survey: 'Survey',
    surveyWithVersion: '{0} (version {1})',
    chooseSurvey: 'Choose a published survey',
    noPublishedSurveys: 'No published surveys yet',
    chooseSurveyFirst: 'Choose a survey to send.',
    timepoint: 'Timepoint (optional)',
    timepointPlaceholder: 'e.g. Baseline, Day 90',
    timepointColumn: 'Timepoint',
    patientTab: 'Surveys',
    noPatientSurveys: 'No surveys were sent to this patient yet. Use Actions → Send survey.',
    archivedSuffix: '(archived)',
    notAnswered: '-',
    skipped: {
      already_open: '{0} skipped: they have an unfinished survey link.',
      no_mobile_phone: '{0} skipped: no mobile phone.',
      no_email: '{0} skipped: no email address.',
      sms_opted_out: '{0} skipped: opted out of SMS.',
    },
    version: 'Version',
    sentAt: 'Sent',
    completedAt: 'Completed',
    expiresAt: 'Link expires',
    viewResponse: 'View answers',
    revokeLink: 'Revoke link',
    revokeConfirm: 'Revoke the survey link of {0}? The link will stop working.',
    linkRevoked: 'Link revoked',
    downloadResponses: 'Download responses (CSV)',
    downloadCodebook: 'Download column guide (codebook)',
    answersSummary: 'Answers (version {0} questions, completed responses)',
    answeredN: '{0} answered',
    numberSummary: 'Min {0} · Average {1} · Max {2}',
    countLabels: {
      waiting: 'Waiting to send',
      sent: 'Sent, not opened',
      in_progress: 'Opened, not finished',
      completed: 'Completed',
      expired: 'Expired',
      failed: 'Not delivered or revoked',
    },
    assignmentStatus: {
      pending: 'Waiting to send',
      sending: 'Sending',
      sent: 'Sent',
      in_progress: 'In progress',
      completed: 'Completed',
      failed: 'Not delivered',
      revoked: 'Revoked',
      expired: 'Expired',
    },
    addQuestionToPage: 'Add a question to page {0}',
    chooseQuestionType: 'Choose the question type…',
    previewHint: 'Try the survey here like a patient would. Test answers are kept while you edit and are never saved.',
    previewValid: 'All answers are valid: this is what the patient would submit.',
    checkAnswers: 'Check answers',
    archiveTooltip: 'Hide this survey from the list and stop new sends. Links already sent keep working until they expire.',
    saveTooltip: 'Save your changes as a draft. Patients see only published versions.',
    publishTooltip: 'Save and lock the current draft as a new version. New sends use the latest version; earlier answers keep the version they were sent with.',
    sendTooltip: 'Send the latest published version to patients by SMS or email.',
    editInBuilder: 'Edit in builder',
    viewResponses: 'View responses',
    openedAt: 'Opened',
    startedAt: 'Started',
    downloadResponsesTooltip: 'One row per patient who opened the survey, one column per question. Answers are codes; the column guide explains them.',
    downloadCodebookTooltip: 'Explains every column of the responses file and what each code means (e.g. which option "c4" is).',
    countTooltips: {
      waiting: 'Created and waiting for the next send run (about every minute).',
      sent: 'The message was sent; the patient has not opened the link yet.',
      in_progress: 'The patient opened the link but has not submitted yet. They can continue later.',
      completed: 'The patient submitted the survey.',
      expired: 'The link expired before the patient submitted.',
      failed: 'Could not be delivered (no phone or email, opted out, vendor error) or the link was revoked.',
    },
    patient: {
      loading: 'Loading your survey…',
      invalidLink: 'This survey link is invalid or has expired. Please contact your care team for a new one.',
      thankYou: 'Thank you!',
      submitted: 'Your answers were sent to your care team. You can close this page.',
      alreadySubmitted: 'This survey was already completed. You can close this page.',
      resumeHint: 'Your answers are saved as you go. You can close this page and continue later with the same link.',
      saved: 'Your answers are saved. You can close this page and continue later with the same link.',
      submitFailed: 'Your answers could not be sent. Please check your connection and try again.',
    },
  },
};

export default english;
